/* HH: Auswahl 30 Tage merken (muss ganz oben stehen) */
/* v4b: the record of what is already in the cart (hh-cfg-added) travels with the selection, so a returning visitor's "Zur Kasse" never adds the set a second time */
(function(){try{var K='hh-cfg-v1',A='hh-cfg-added',L='hh-cfg-keep',D=30*864e5;if(!sessionStorage.getItem(K)){var k=JSON.parse(localStorage.getItem(L)||'null');if(k&&k.ts&&Date.now()-k.ts<D){if(k.added&&typeof k.added==='object'&&!sessionStorage.getItem(A))sessionStorage.setItem(A,JSON.stringify(k.added));delete k.ts;delete k.added;sessionStorage.setItem(K,JSON.stringify(k));}}var save=function(){try{var v=sessionStorage.getItem(K);if(v){var o=JSON.parse(v);o.ts=Date.now();var a=sessionStorage.getItem(A);if(a)o.added=JSON.parse(a);localStorage.setItem(L,JSON.stringify(o));}}catch(e){}};addEventListener('pagehide',save);document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden')save();});document.addEventListener('click',function(){setTimeout(save,60);},true);}catch(e){}})();
/* HuggHer Konfigurator v1 — vanilla JS, no dependencies.
   Reads the JSON blob rendered by sections/huggher-configurator.liquid (script[data-hh-cfg-data])
   and renders the whole experience into [data-hh-cfg].
   v4 (23 Oct 2026, Luis): step ORDER is a section setting. Default "moochie_first": 1 Moochie → 2 Farbe & Größe →
   3 Übersicht (the ad's visual hook first); "hoodie_first" = the old 1 Hoodie → 2 Moochie → 3 Übersicht.
   Positions (1..3: data-step, step{n}/row{n}, S.step, S.maxStep, the session) are separate from the panel KIND
   ('hoodie' = $.s1, 'moochie' = $.s2, 'sum' = $.s3): use kindAt(n) / posOf(kind), never a fixed step number.
   Sessions carry `order`; one saved in the other order is mapped on restore. Analytics carry kind + order.
   "Zur Kasse" either goes straight to the checkout (default) or opens the theme's cart drawer (setting checkout_mode). */
(function () {
  'use strict';
  if (window.__hhCfgBooted) return;
  window.__hhCfgBooted = true;

  /* ───────────────────────── helpers ───────────────────────── */
  var RMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function RM() { return !!window.HHCFG_FORCE_RM || !!(RMQ && RMQ.matches); }
  var MQD = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;
  function isDesk() { return !!(MQD && MQD.matches); }
  var EASE = {
    out: 'cubic-bezier(.22,1,.36,1)', inout: 'cubic-bezier(.65,0,.35,1)', spring: 'cubic-bezier(.34,1.56,.64,1)',
    snap: 'cubic-bezier(.5,1.5,.4,1)', glide: 'cubic-bezier(.16,1,.3,1)', fall: 'cubic-bezier(.3,0,.8,.15)', drop: 'cubic-bezier(.55,0,1,.45)'
  };
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function grp(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  // money in the visitor's presentment currency (Liquid prices come out in it; CHF via Markets must not be labelled €)
  var CUR = 'EUR', NF = {};
  function nf(cur, dec) {
    var k = cur + dec;
    if (!NF[k]) {
      try { NF[k] = new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur, minimumFractionDigits: dec, maximumFractionDigits: dec }); }
      catch (e) { NF[k] = { format: function (x) { var c = Math.round(x * 100), e2 = Math.floor(c / 100), ct = c % 100; return grp(e2) + (dec ? ',' + (ct < 10 ? '0' : '') + ct : '') + '\u00a0' + (cur === 'EUR' ? '\u20ac' : cur); } }; }
    }
    return NF[k];
  }
  function fmt(c) {
    c = Math.round(c || 0); var neg = c < 0;
    return (neg ? '\u2212' : '') + nf(CUR, 2).format(Math.abs(c) / 100);
  }
  // round-number shortening ("19 \u20ac") only for EUR
  function fmtShort(c) { return (CUR === 'EUR' && Math.round(c) % 100 === 0) ? nf(CUR, 0).format(Math.round(c) / 100) : fmt(c); }
  function slug(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function anim(el, kf, opts) {
    if (!el || !el.animate || RM()) return null;
    try { return el.animate(kf, opts); } catch (e) { return null; }
  }
  function done(a) { return a && a.finished ? a.finished.catch(function () {}) : Promise.resolve(); }
  function vibrate(p) { if (RM()) return; try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var MONTHS_S = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
  function shipLabel(iso, kind) {
    if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return '';
    var p = iso.split('-'), m = +p[1] - 1;
    if (m < 0 || m > 11) return '';
    return (+p[2]) + '. ' + (kind === 'short' ? MONTHS_S[m] : MONTHS[m]);
  }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function track(name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.HHCFG_ON_EVENT) window.HHCFG_ON_EVENT(name, data); } catch (e) {}
  }
  function navigate(url) { if (window.HHCFG_NAVIGATE) return window.HHCFG_NAVIGATE(url); window.location.href = url; }
  function ss(key, val) {
    try {
      if (val === undefined) return JSON.parse(sessionStorage.getItem(key) || 'null');
      sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  // per-viewer convenience only (e.g. size sheet tab); may be unavailable (private mode, in-app browsers)
  function ls(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  var ICON = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>',
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    undo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14L4 9l5-5"/><path d="M4 9h10a6 6 0 010 12h-3"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.7 4.5c2.1 0 3.5 1.1 4.3 2.4.8-1.3 2.2-2.4 4.3-2.4 3.7 0 5.8 3.9 4.3 7.3C19.5 16.4 12 21 12 21z"/></svg>',
    cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="3"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>',
    bottle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3h6v3H9z"/><path d="M8 6h8a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3V9a3 3 0 013-3z"/><path d="M8 12h8"/></svg>',
    sound: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9z"/><path d="M16 9a4 4 0 010 6M18.5 6.5a7.5 7.5 0 010 11"/></svg>',
    mute: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9z"/><path d="M17 9l5 6M22 9l-5 6"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 001.5.86l10.6-6.5a1 1 0 000-1.72L9.5 4.64A1 1 0 008 5.5z"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="8" width="20" height="8" rx="2"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/></svg>',
    zoom: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>'
  };
  var ARR = ' <span class="hh-arr" aria-hidden="true">→</span>';
  var SWATCH = { 'Cherry Blossom': '#F6C9DA', 'Midnight Black': '#1E1C21', 'Sky Blue': '#A9CDEB', 'Beige': '#E6D5C0' };

  /* ───────────────────────── texts ───────────────────────── */
  var T0 = {
    'prog.1': 'Hoodie', 'prog.2': 'Moochie', 'prog.3': 'Übersicht',
    'ed.k': 'Auflage', 'ed.sold': 'Ausverkauft', 'ed.live': 'Jetzt vorbestellen', 'ed.liveSub': 'Live',
    'ed.left': 'Nur noch <b>{n}</b> verfügbar', 'ed.reserved': '<b>{r}</b> von {size} <span class="hh-ed__opt3">schon </span>reserviert · nur noch <b>{n}</b> frei',
    'ed.edition': '{batch} · {size} Hoodies · nur noch <b>{n}</b> frei',
    'ed.days': 'Versand in <b>{d}</b> Tagen', 'ed.day1': 'Versand <b>morgen</b>', 'ed.date': 'Versand am <b>{date}</b>',
    'stage.alt': 'HuggHer Hoodie in {c}', 'stage.nosize': '{c} · Größe?', 'stage.chip': '{c} · {s}', 'stage.chipM': '{c} · {s} · {m}',
    'stage.swipe': 'Wischen für mehr Farben', 'stage.prev': 'Vorherige Farbe', 'stage.next': 'Nächste Farbe',
    'stage.malt': 'Moochie {m} – kommt in die Innentasche', 'stage.extra': '{n} Hoodies in deiner Auswahl',
    'cele.with': 'Dein HuggHer ist fertig ♥', 'cele.without': 'Dein HuggHer ist fertig ♥',
    's1.eyebrow': '{batch} · Vorbestellung', 's1.title': 'Zuerst wähle deinen Hoodie.',
    's1.sub': 'Der Hoodie mit Wärmflaschen-Tasche am Bauch – die 750-ml-Wärmflasche ist immer dabei.',
    'row2.teaser': '−{p} % mit deinem Hoodie',
    'rating': '{r} · {n} Bewertungen', 'rating.aria': 'Bewertet mit {r} von 5 Sternen, {n} Bewertungen. Zu den Bewertungen springen',
    'color.k': 'Farbe', 'color.left': 'noch {n}', 'color.leftLow': 'nur noch {n}', 'color.sizeLeft': '{s}: noch {n}', 'color.sold': 'Ausverkauft', 'color.sizeSold': '{s}: ausverkauft',
    'ugc.k': 'So tragen es andere', 'ugc.aria': 'Story ansehen: {c}', 'ugc.cap': 'Story',
    'size.k': 'Größe', 'size.help': 'Welche Größe?', 'size.low': 'nur {n}', 'size.soldAria': '{s} – ausverkauft',
    'size.req': 'Wähle zuerst deine Größe.',
    'stock.ships': 'in dieser Farbe & Größe verfügbar.', 'stock.pre': 'in dieser Farbe & Größe vorbestellbar.',
    'stock.color': 'in {c} vorbestellbar – wähle deine Größe.', 'stock.sold': 'In dieser Farbe & Größe ausverkauft.', 'stock.prefix': 'Nur noch',
    'sold.size': '{s} in {c} ist leider ausverkauft.', 'sold.alts': 'Noch da in:', 'sold.none': 'Diese Größe ist gerade in keiner Farbe mehr da.',
    'sold.color': '{c} ist gerade komplett ausverkauft. Schau dir die anderen Farben an.',
    'trust.1': 'Kostenloser Versand DE · AT · CH', 'trust.2': 'Kostenlos stornierbar bis zum Versand', 'trust.3': '30 Tage Rückgabe',
    's2.title': 'Wähle deinen Moochie.', 's2.badge': '−{p} %', 's2.sub': 'Mit deinem Hoodie: {w} statt {u}.', 's2.subOff': 'Der flauschige Bezug für deine Wärmflasche.',
    's2.subFree': 'Bei {h} Hoodies sind {n} Moochies gratis.',
    's2.info': 'Was ist ein Moochie?', 's2.infoBody': 'Ein flauschiger Bezug für deine 750-ml-Wärmflasche. Er passt genau in die Innentasche deines Hoodies.',
    'm.free': 'gratis', 'm.peek': 'In der Tasche', 'stage.mpeek': 'Vorschau: Moochie {m} in der Tasche', 'm.aria': 'Moochie {m}, {p}', 'm.none': 'Ohne Moochie', 'm.noneSub': 'Die Wärmflasche ist trotzdem dabei.',
    's2.req': 'Wähle einen Moochie – oder tippe auf „Ohne Moochie“.',
    's3.title': 'Dein HuggHer.', 's3.sub': 'Genau so, wie du ihn willst.',
    'sum.hoodie': 'HuggHer Hoodie', 'sum.hmeta': '{c} · Größe {s}', 'sum.pre': 'Vorbestellpreis',
    'sum.m': 'Moochie {m}', 'sum.mHalf': '−{p} % mit deinem Hoodie', 'sum.mFree': 'gratis zu deinem Bundle', 'sum.mFull': 'Moochie',
    'sum.none': 'Ohne Moochie', 'sum.bottle': '750-ml-Wärmflasche', 'sum.bottleMeta': 'ohne Bezug', 'sum.bottleVal': 'immer dabei',
    'sum.ship': 'Versand DE · AT · CH', 'sum.shipVal': 'kostenlos', 'sum.total': 'Gesamt', 'sum.vat': 'inkl. MwSt.',
    'sum.set': 'Hoodie {n}', 'sum.remove': 'Entfernen', 'sum.save': 'Du sparst {v}',
    'sum.free1': 'Du hast noch 1 Moochie gratis – such ihn dir aus.', 'sum.freeN': 'Du hast noch {k} Moochies gratis – such sie dir aus.', 'sum.freeCta': 'Moochie wählen',
    'seal.k': 'Auflage', 'seal.s': 'Vorbestellt',
    'pre.k': 'Vorbestellung · {batch}', 'pre.d': 'Versand am {date}', 'pre.s': 'Kostenlos stornierbar bis zum Versand · 30\u00a0Tage Rückgabe',
    'pre.now': 'Sofort lieferbar',
    // v3 (Luis): the offers are named "Wärme zu zweit" / "Wärme zu dritt"; the headline covers both
    'up.k': 'Mehr Wärme', 'up.title': 'Teile die Wärme.', 'up.t2': 'Wärme zu zweit', 'up.t2s': '2 Hoodies, 2 Moochies gratis – für dich und deine Lieblingsperson. Nur <b>+{d}</b>.',
    'up.t3': 'Wärme zu dritt', 'up.t3s': '3 Hoodies, 3 Moochies gratis – für die ganze Kuschel-Crew. <b>+{d}</b>.', 'up.t3from2': 'Wärme zu dritt', 'up.t3from2s': 'Noch ein Hoodie, und alle 3 Moochies sind gratis. Nur <b>+{d}</b>.',
    'up.pop': 'Beliebt', 'offer.2': 'Wärme zu zweit', 'offer.3': 'Wärme zu dritt',
    'sheet.title': 'Hoodie {n}', 'sheet.of': 'Hoodie {n} von {t}', 'sheet.hint': 'Der Moochie für Hoodie {n} ist gratis – such dir einen aus.',
    // v3: extra Moochies (full price; only the bundle Moochies are discounted)
    'xm.link': 'Weitere Moochies hinzufügen', 'xm.title': 'Weitere Moochies', 'xm.sub': 'Für alle, die du lieb hast. Jeder weitere Moochie kostet {p}.', 'xm.sub0': 'Für alle, die du lieb hast.',
    'xm.plus': 'Einen {m} mehr', 'xm.minus': 'Einen {m} weniger', 'xm.qty': '{n} × {m}', 'xm.have': 'schon {n}× dabei',
    'xm.req': 'Tippe bei einem Moochie auf +.', 'sum.xMeta': 'extra', 'sum.xMetaN': 'extra · {n} Stück', 'sum.xEach': '{n} × {p}', 'sum.xRemove': 'Moochie {m} (extra) entfernen',
    // v3 review: no Moochie in the order yet → "Moochie hinzufügen"; open bundle slots are named (the first one is gratis/−50 %)
    'xm.link0': 'Moochie hinzufügen', 'xm.title0': 'Moochie hinzufügen',
    'xm.subFree1': 'Für alle, die du lieb hast. Dein nächster Moochie ist gratis, jeder weitere kostet {p}.',
    'xm.subFreeN': 'Für alle, die du lieb hast. Deine nächsten {k} Moochies sind gratis, jeder weitere kostet {p}.',
    'xm.subHalf1': 'Für alle, die du lieb hast. Dein nächster Moochie kostet nur {h} (−{pct} %), jeder weitere {p}.',
    'xm.subHalfN': 'Für alle, die du lieb hast. Deine nächsten {k} Moochies kosten nur je {h} (−{pct} %), jeder weitere {p}.',
    'xm.free': 'gratis', 'xm.done': 'Fertig', 'xm.noteFree': 'davon {n} gratis', 'xm.noteHalf': '{n} × −{pct} %',
    'sum.xFree': '{n} davon gratis', 'sum.xHalf': '{n} davon −{pct} %', 'sum.remove1': 'Einen entfernen',
    'sum.xRemove1': 'Einen Moochie {m} (extra) entfernen', 'xm.removed': 'Moochie {m} (extra) entfernt.',
    'sheet.add': 'Hinzufügen · +{d}', 'sheet.addK': 'Hinzufügen', 'sheet.save': 'Übernehmen', 'sheet.cancel': 'Abbrechen', 'close': 'Schließen',
    'cta.size': 'Größe wählen ↓', 'cta.sizeUp': 'Größe wählen ↑', 'cta.sizeOther': 'Andere Größe wählen', 'cta.next1': 'Weiter zum Moochie', 'cta.next1bar': 'Moochie wählen', 'cta.moochie': 'Moochie wählen',
    'cta.next2': 'Zur Übersicht', 'cta.back': 'Zur Übersicht', 'cta.finish': 'Hoodie {n} fertigstellen', 'cta.checkout': 'Zur Kasse',
    'cta.adding': 'Wird hinzugefügt …', 'cta.toCheckout': 'Weiter zur Kasse …',
    'cta.resume': 'Weiter konfigurieren ↑',
    // v4 Moochie first: the hoodie step comes second and is named by what is still open there
    'cta.nextHbar': 'Farbe & Größe wählen', 'cta.nextHbarS': 'Farbe & Größe', 'cta.nextHi': 'Weiter zu Farbe & Größe', 'cta.moochieUp': 'Moochie wählen ↑',
    'row.hoodie0': 'Farbe & Größe', 's1.subM': '{m} sitzt schon in der Tasche – jetzt noch Farbe und Größe.',
    's1.sub0': 'Die 750-ml-Wärmflasche ist immer dabei – jetzt noch Farbe und Größe.',
    'stage.chipPeek': 'Vorschau: {m}', 'stage.chipMC': '{m} · {c}',
    'cta.cart': 'In den Warenkorb', 'act.trust': 'Kostenloser Versand DE · AT · CH · 30 Tage Rückgabe',
    'bar.total': 'Gesamt', 'bar.ship': 'Versand am {date}', 'bar.half': 'inkl. Moochie −{p} %', 'bar.free2': '2 Moochies gratis', 'bar.free3': '3 Moochies gratis', 'bar.pre': 'Vorbestellpreis',
    'err.soldout': 'Mist – das ist gerade ausverkauft: {msg}', 'err.network': 'Keine Verbindung. Prüf kurz dein Internet und versuch’s nochmal.',
    'err.generic': 'Da ist etwas schiefgelaufen. Versuch es bitte nochmal.', 'err.soldVariant': '{c} in {s} ist gerade ausverkauft – wähl bitte eine andere Größe oder Farbe.', 'err.soldMoochie': 'Moochie {m} ist gerade ausverkauft – such dir bitte einen anderen aus.', 'err.retry': 'Nochmal versuchen',
    'sr.total': 'Gesamt: {p}', 'sr.complete': 'Deine Auswahl ist komplett.',
    'sg.title': 'Welche Größe passt dir?', 'sg.lede': 'Der HuggHer ist bewusst oversized geschnitten. Nimm einfach deine gewohnte Größe – magst du es enger, nimm eine Nummer kleiner.',
    'sg.model': 'Unser Model ist 175 cm groß und trägt M.', 'sg.cap': 'Maße in cm', 'sg.hint': 'Tippe auf deine Größe, um sie zu wählen.', 'sg.cols': 'Größe|Brust|Taille|Länge',
    'sg.ret': 'Passt doch nicht? Du hast 30 Tage Zeit für die Rückgabe.', 'sg.soldIn': 'ausverkauft in {c}',
    'story.pick': 'Diese Farbe wählen', 'story.picked': 'Farbe gewählt ✓', 'story.on': 'Ton an', 'story.off': 'Ton aus',
    'story.play': 'Video abspielen', 'cta.next2i': 'Zur Übersicht', 'cta.next1i': 'Moochie wählen',
    'act.k': 'Fast geschafft', 'act.note': 'Sicher bezahlen mit',
    // size finder (wording + logic from the live PDP block "Meine Größe in 10 Sekunden finden")
    'sf.open': 'Meine Größe in 10 Sekunden finden', 'sf.chart': 'Größentabelle', 'sf.tabFind': 'Größe finden', 'sf.tabChart': 'Größentabelle',
    'sf.title': 'Finden wir deine Größe.', 'sf.lede': 'Zwei Zahlen und wie es sitzen soll. Unser Model ist 175 cm groß und trägt M.',
    'sf.units': 'Einheiten', 'sf.metric': 'cm / kg', 'sf.imperial': 'in / lb', 'sf.height': 'Größe', 'sf.weight': 'Gewicht',
    'sf.fitK': 'Wie soll es sitzen?', 'sf.fitN': 'Normal', 'sf.fitNs': 'Locker, wie gedacht', 'sf.fitX': 'Extra weit', 'sf.fitXs': 'Eine Nummer größer',
    'sf.go': 'Meine Größe anzeigen', 'sf.err': 'Gib deine Größe und dein Gewicht ein, um eine Größe zu sehen.',
    'sf.your': 'Deine Größe', 'sf.chest': 'Brust', 'sf.waist': 'Taille', 'sf.length': 'Länge',
    'sf.note': 'Eine Empfehlung, keine Garantie. Wenn es nicht passt, kannst du es 30 Tage lang umtauschen.',
    'sf.why1': 'Basierend auf deiner Größe und deinem Gewicht', 'sf.whyB': 'Du liegst zwischen zwei Größen — diese passt dir besser',
    'sf.whyX': 'eine Größe größer für mehr Platz', 'sf.whyL': 'mit etwas mehr Länge für deine Größe', 'sf.whyS': 'etwas kürzer, damit er nicht an dir hängt',
    'sf.take': 'Größe {s} übernehmen', 'sf.taken': 'Größe {s} ist gewählt ✓', 'sf.sold': '{s} ist in {c} gerade ausverkauft.', 'sf.soldAlt': 'Noch da in:',
    'sg.fitK': 'So fällt er aus',
    'gal.k': 'So sieht er in echt aus', 'gal.aria': 'Foto {n} von {t} groß ansehen', 'gal.photo': 'Foto'
  };

  /* ───────────────────────── boot ───────────────────────── */
  function boot(root) {
    var dataEl = q('script[data-hh-cfg-data]', root) || document.getElementById('hh-config-data');
    if (!dataEl) return;
    var D;
    D = JSON.parse(dataEl.textContent); // a parse error is handled by safeBoot (fallback to the normal product page)
    var S0 = D.s || {};
    var T = Object.assign({}, T0, D.t || {});
    function t(k, v) {
      var s = T[k] == null ? k : String(T[k]);
      if (v) s = s.replace(/\{(\w+)\}/g, function (m, n) { return v[n] != null ? v[n] : m; });
      return s;
    }
    var CFG = {
      shipIso: S0.shipDateIso || '', batch: S0.batchLabel || 'Auflage 4', barMin: S0.barMin == null ? 50 : +S0.barMin, colorLow: S0.colorLow == null ? 250 : +S0.colorLow,
      editionsSold: S0.editionsSold == null ? 3 : +S0.editionsSold, editionSize: +S0.editionSize || 0,
      showCompare: S0.showCompare !== false, showCountdown: S0.showCountdown !== false, warn: +S0.stockWarn || 20,
      mdisc: S0.mdisc !== false, mpct: S0.mpct == null ? 50 : +S0.mpct, tier2: !!S0.tier2, tier3: !!S0.tier3,
      defaultColor: S0.defaultColor || '', sizeTable: S0.sizeTable || ''
    };
    // v4: step order (positions 1..3) vs panel kinds. 'm1' = Moochie first (default), 'h1' = Hoodie first (old)
    var ORDER_ID = S0.stepOrder === 'hoodie_first' ? 'h1' : 'm1';
    var ORDER = ORDER_ID === 'm1' ? ['moochie', 'hoodie', 'sum'] : ['hoodie', 'moochie', 'sum'];
    var PAD = { hoodie: 's1', moochie: 's2', sum: 's3' }, HEAD = { hoodie: 'hh-s1-h', moochie: 'hh-s2-h', sum: 'hh-s3-h' };
    var NEXT_BAR = { moochie: 'cta.next1bar', hoodie: 'cta.nextHbar', sum: 'cta.next2' }, NEXT_IN = { moochie: 'cta.next1i', hoodie: 'cta.nextHi', sum: 'cta.next2i' };
    function posOf(k) { return ORDER.indexOf(k) + 1; }
    function kindAt(n) { return ORDER[n - 1]; }
    function kindDone(k) { return k === 'hoodie' ? hoodieDone() : (k === 'moochie' ? moochieDone() : false); }
    function firstMissingKind() { for (var i = 0; i < 2; i++) if (!kindDone(ORDER[i])) return ORDER[i]; return null; }
    // v4: after "Zur Kasse": 'checkout' = straight to the checkout (default), 'drawer' = the theme's cart drawer
    CFG.mode = S0.checkoutMode === 'drawer' ? 'drawer' : 'checkout';
    CFG.tagCart = S0.tagCart !== false;
    // ONE ship-date setting (ISO); the German label is derived from it so the page can never contradict itself
    CFG.shipDate = shipLabel(CFG.shipIso, 'long') || S0.shipDate || '';
    CFG.shipShort = shipLabel(CFG.shipIso, 'short') || CFG.shipDate;
    CUR = /^[A-Z]{3}$/.test(D.currency || '') ? D.currency : 'EUR';
    var R = Object.assign({ cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js', cart: '/cart', cartJs: '/cart.js', checkout: '/checkout' }, D.routes || {});

    /* ── data index ── */
    var names = (D.optionNames || []).map(function (n) { return String(n); });
    // option indices: by name, with the positions Liquid resolved as fallback (store locale could translate option names)
    var OI = D.opt || {};
    var iS = names.indexOf('Size'), iC = names.indexOf('Color'), iF = names.indexOf('Fulfillment');
    if (iS < 0 && OI.size >= 0) iS = OI.size;
    if (iC < 0 && OI.color >= 0) iC = OI.color;
    if (iF < 0 && OI.fulfillment >= 0) iF = OI.fulfillment;
    var FV = D.fValues || [];
    var PREVAL = FV.indexOf('Preorder') > -1 || !FV.length ? 'Preorder' : (FV[1] || FV[0]);
    if (names.indexOf('Size') < 0 || names.indexOf('Color') < 0 || (iF >= 0 && FV.length && FV.indexOf('Preorder') < 0)) track('hh_cfg_option_mismatch', { names: names, fValues: FV });
    if (iS < 0 || iC < 0) throw new Error('hh-cfg: size/colour option not found');
    var SIZES = D.sizes || [];
    var COLORS = (D.colors || []).map(function (c) { c.swatch = (c.swatch && /^(#|rgb)/.test(c.swatch)) ? c.swatch : (SWATCH[c.name] || '#ddd'); return c; });
    if (!COLORS.length || !SIZES.length || !(D.variants || []).length) throw new Error('hh-cfg: no colours/sizes/variants in data');
    var CBY = {}; COLORS.forEach(function (c) { CBY[c.name] = c; });
    var VX = {};
    (D.variants || []).forEach(function (v) {
      var c = v.options[iC], s = v.options[iS], f = iF >= 0 ? v.options[iF] : 'Ships Now';
      VX[c] = VX[c] || {}; VX[c][s] = VX[c][s] || { ships: null, pre: null };
      if (f === PREVAL) VX[c][s].pre = v; else VX[c][s].ships = v;
    });
    var MOO = (D.moochies || []).filter(function (m) { return m && m.available !== false && m.variantId; });
    var MBY = {}; MOO.forEach(function (m) { MBY[m.handle] = m; });
    var UGC = (D.ugc || []).filter(function (u) { return u && (u.poster || u.posterLg); });
    var GAL = (D.gallery || []).filter(function (g) { return g && g.src; });
    var FIT = D.fit && D.fit.src ? D.fit : null;
    var AIV = D.aiVideo && (D.aiVideo.hls || D.aiVideo.mp4) ? D.aiVideo : null;
    function hasVideo(u) { return !!(u && (u.hls || u.mp4 || u.video)); }
    // <source> list in the live PDP order: adaptive HLS first (Safari/iOS, recent Chrome), MP4 as the fallback
    function videoSources(u, lazy) {
      var a = lazy ? 'data-src' : 'src', h = '', mp4 = u.mp4 || u.video;
      if (u.hls) h += '<source ' + a + '="' + esc(u.hls) + '" type="application/x-mpegURL">';
      if (mp4) h += '<source ' + a + '="' + esc(mp4) + '" type="video/mp4">';
      return h;
    }

    function resolve(c, s) {
      var e = VX[c] && VX[c][s]; if (!e) return null;
      if (e.ships && e.ships.available) return e.ships;
      if (e.pre && e.pre.available) return e.pre;
      return null;
    }
    function countable(v) { return !!(v && v.tracked && String(v.policy).toLowerCase() === 'deny'); }
    function qtyOf(v) { return countable(v) ? Math.max(0, v.qty | 0) : null; }
    function colorAvail(c) { return SIZES.some(function (s) { return !!resolve(c, s); }); }
    function colorQty(c) {
      var sum = 0, any = false;
      SIZES.forEach(function (s) { var v = resolve(c, s), n = qtyOf(v); if (n != null) { sum += n; any = true; } });
      return any ? sum : null;
    }
    function anyVariantOf(c) {
      for (var i = 0; i < SIZES.length; i++) { var v = resolve(c, SIZES[i]); if (v) return v; }
      var e = VX[c] && VX[c][SIZES[0]]; return e ? (e.pre || e.ships) : (D.variants || [])[0];
    }
    function editionLeft() {
      var n = 0; (D.variants || []).forEach(function (v) { if ((iF < 0 || v.options[iF] === PREVAL) && v.available && countable(v)) n += Math.max(0, v.qty | 0); });
      return n;
    }
    function shipsNowAvailable() { return (D.variants || []).some(function (v) { return iF >= 0 && v.options[iF] !== PREVAL && v.available; }); }

    /* ── state ── */
    var S = {
      step: 1, maxStep: 1, sets: [{ color: null, size: null, moochie: null }], extras: {}, // extras: Moochie handle -> qty (v3)
      submit: 'idle', mode: null, error: null, celebrated: !!ss('hh-cfg-cele'), below: false, compact: false,
      touched: false, everStep1Done: false
    };
    function set0() { return S.sets[0]; }
    function vOf(set) { return set && set.color && set.size ? resolve(set.color, set.size) : null; }
    function setDone(set) { return !!(vOf(set) && set.moochie !== null); }
    function hoodieDone() { return !!vOf(set0()); }
    function moochieDone() { return set0().moochie !== null; }
    function allDone() { return hoodieDone() && moochieDone() && S.sets.every(setDone); }
    function firstIncompleteExtra() { for (var i = 1; i < S.sets.length; i++) if (!setDone(S.sets[i])) return i; return -1; }

    /* ── price model (prediction; the cart stays the source of truth) ──
       Real cart rules (Luis checked them in a live cart, 16 Oct): each hoodie unlocks ONE Moochie. With 1 hoodie it costs
       50 % (MOOCHIE 50% OFF), with 2 hoodies the 2 are free (Warmth for Both), with 3 the 3 are free (UNIQUE PRESALE OFFER 2).
       Every Moochie beyond one per hoodie costs the full price (1H+2M = 146,90 · 1H+3M = 184,90 · 2H+3M = 217,80).
       The discounts look at the cart, not at our bundles, so the count runs over ALL Moochies (bundle + extra); the bundle
       Moochies are listed first, so they get the discounted slots in the summary. */
    function extrasList(ex) {
      var out = [];
      MOO.forEach(function (mo) { var n = Math.max(0, (ex && ex[mo.handle]) | 0); for (var k = 0; k < n; k++) out.push(mo); });
      return out;
    }
    function extrasCount(ex) { return extrasList(ex).length; }
    function model(sets, ex) {
      if (ex === undefined) ex = S.extras;
      var N = sets.length, hoodies = 0, cmp = 0, preorder = true, hv = [];
      sets.forEach(function (s) {
        var v = vOf(s) || anyVariantOf(s.color || COLORS[0].name);
        hv.push(v);
        hoodies += v.price;
        cmp += (CFG.showCompare && v.compare > v.price) ? v.compare : v.price;
        if (iF >= 0 && v.options[iF] !== PREVAL) preorder = false;
      });
      var ms = [];
      sets.forEach(function (s, i) { if (s.moochie && s.moochie !== 'none' && MBY[s.moochie]) ms.push({ set: i, m: MBY[s.moochie] }); });
      extrasList(ex).forEach(function (mo) { ms.push({ set: -1, m: mo, extra: true }); });
      var M = ms.length, free = 0, half = 0, tier = 0;
      var bundled = Math.min(M, N); // one discounted Moochie per hoodie, never more
      if (CFG.tier3 && N >= 3) { free = Math.min(bundled, 3); tier = 3; }
      else if (CFG.tier2 && N >= 2) { free = Math.min(bundled, 2); tier = 2; }
      if (CFG.mdisc) half = bundled - free;
      var lines = ms.map(function (x) { return { set: x.set, handle: x.m.handle, unit: x.m.price, price: x.m.price, kind: 'full', extra: !!x.extra }; });
      // stable sort: at equal prices the bundle Moochies keep the discounted slots, the extras pay full
      var order = lines.slice().sort(function (a, b) { return b.unit - a.unit; });
      order.forEach(function (l, k) {
        if (k < free) { l.price = 0; l.kind = 'free'; }
        else if (k < free + half) { l.price = Math.round(l.unit * (1 - CFG.mpct / 100)); l.kind = 'half'; }
      });
      var mt = 0, mcmp = 0; lines.forEach(function (l) { mt += l.price; mcmp += l.unit; });
      return { N: N, M: M, total: hoodies + mt, compare: cmp + mcmp, hoodies: hoodies, hv: hv, lines: lines, free: free, half: half, tier: tier, preorder: preorder };
    }
    function lineFor(m, i) { for (var k = 0; k < m.lines.length; k++) if (m.lines[k].set === i) return m.lines[k]; return null; }
    function withSet(sets, i, patch) { return sets.map(function (s, k) { return k === i ? Object.assign({}, s, patch) : s; }); }
    function moochieCardPrice(sets, i, handle) { var m = model(withSet(sets, i, { moochie: handle })); return lineFor(m, i); }
    function tierDelta(target) {
      var base = model(S.sets), extra = S.sets.slice();
      var h = (MOO[0] && MOO[0].handle) || 'none';
      while (extra.length < target) extra.push({ color: set0().color, size: set0().size, moochie: h });
      // count the current main-set Moochie as decided-with for the prediction
      return model(extra).total - base.total;
    }

    /* ── initial state: ?variant > ?farbe/groesse/moochie > session > defaults ── */
    (function initState() {
      var p = new URLSearchParams(location.search);
      var vid = p.get('variant'), c = null, s = null, m = null;
      if (vid) (D.variants || []).forEach(function (v) { if (String(v.id) === vid) { c = v.options[iC]; s = v.options[iS]; } });
      if (p.get('farbe')) COLORS.forEach(function (x) { if (slug(x.name) === p.get('farbe')) c = x.name; });
      if (p.get('groesse')) SIZES.forEach(function (x) { if (slug(x) === p.get('groesse')) s = x; });
      if (p.get('moochie')) { var mm = p.get('moochie'); if (mm === 'ohne') m = 'none'; else MOO.forEach(function (x) { if (x.handle === mm || slug(x.title) === mm) m = x.handle; }); }
      var urlM = m;   // v4: a Moochie that came with the link (not from the session) pops into the pocket on landing
      // session (back from checkout without bfcache, reload): restore the whole bundle. syncUrl() writes farbe/groesse/moochie
      // after the first tap, so URL values that AGREE with the session must not block the restore; differing URL values
      // (e.g. a new ad link) only override hoodie 1.
      var sess = ss('hh-cfg-v1');
      if (sess && sess.sets && sess.sets.length) {
        var ok = sess.sets.every(function (x) { return x && CBY[x.color] && (!x.size || SIZES.indexOf(x.size) > -1) && (x.moochie == null || x.moochie === 'none' || MBY[x.moochie]); });
        if (ok) {
          var z = sess.sets[0];
          var agree = (c == null || c === z.color) && (s == null || s === z.size) && (m == null || m === z.moochie);
          S.sets = sess.sets.slice(0, 3).map(function (x) { return { color: x.color, size: x.size || null, moochie: x.moochie == null ? null : x.moochie }; });
          if (sess.extras && typeof sess.extras === 'object') Object.keys(sess.extras).forEach(function (h) { var n = sess.extras[h] | 0; if (MBY[h] && n > 0) S.extras[h] = Math.min(n, 20); });
          if (c == null) c = z.color;
          if (agree) { if (s == null) s = z.size; if (m == null) m = z.moochie; S.restore = { step: +sess.step || 1, maxStep: +sess.maxStep || +sess.step || 1, order: sess.order || 'h1' }; }   // no order = saved by the old Hoodie-first page
        }
      }
      if (!c || !CBY[c]) {
        c = (CFG.defaultColor && CBY[CFG.defaultColor] && colorAvail(CFG.defaultColor)) ? CFG.defaultColor : null;
        if (!c) for (var i = 0; i < COLORS.length; i++) if (colorAvail(COLORS[i].name)) { c = COLORS[i].name; break; }
        if (!c) c = COLORS[0].name;
      }
      S.sets[0] = { color: c, size: s && SIZES.indexOf(s) > -1 ? s : null, moochie: m == null ? null : m };
      if (hoodieDone()) S.everStep1Done = true;
      S.introChosen = !!(urlM && urlM !== 'none' && !S.restore);
    })();

    /* ───────────────────────── markup ───────────────────────── */
    var userTouchedStep = false;
    function shell() {
      var ed = editionHtml();
      // v4: position n holds the panel of kindAt(n); the pads keep their kind refs (s1 hoodie, s2 Moochie, s3 summary)
      var steps = ORDER.map(function (k, i) { return stepHtml(i + 1, k, '<div class="hh-step__pad" data-ref="' + PAD[k] + '"></div>'); }).join('');
      // pocket layers of one scene (order = paint order): zip, body, lower lip, shadow, paws
      var pkHtml = function (ref) {
        var l = function (n) { return '<img class="hh-pk__l" data-l="' + n + '" alt="" decoding="async" hidden>'; };
        return '<div class="hh-pk" data-ref="' + ref + '" aria-hidden="true" hidden>' + l('zip') + '<div class="hh-pk__g hh-pk__back">' + l('body') + '</div>' +
          l('front') + '<div class="hh-pk__g hh-pk__fx">' + l('shadow') + l('paws') + '</div></div>';
      };
      var stage = '' +
        '<div class="hh-stage" data-ref="stage">' +
          '<div class="hh-stage__box" data-ref="box">' +
            '<div class="hh-scene is-front" data-ref="scA">' +
              '<img class="hh-stage__img" data-ref="imgA" alt="" fetchpriority="high" decoding="async">' + pkHtml('pkA') +
            '</div>' +
            '<div class="hh-scene is-back" data-ref="scB" aria-hidden="true">' +
              '<img class="hh-stage__img" data-ref="imgB" alt="" decoding="async">' + pkHtml('pkB') +
            '</div>' +
            '<div class="hh-dock" data-ref="dock" hidden>' +
              '<span class="hh-dock__ring" data-ref="ring"></span>' +
              '<div class="hh-sticker" data-ref="sticker"><img data-ref="stickerImg" alt=""></div>' +
              '<span class="hh-dock__tag" data-ref="tag" aria-hidden="true"></span>' +
            '</div>' +
            '<div class="hh-stage__hearts" data-ref="hearts" aria-hidden="true"></div>' +
          '</div>' +
          '<div class="hh-stage__fade" aria-hidden="true"></div>' +
          '<div class="hh-stage__chip" data-ref="chip" aria-live="off"></div>' +
          '<button type="button" class="hh-stage__extras" data-ref="extras" data-act="goto" data-step="3" hidden></button>' +
          '<button type="button" class="hh-stage__nav hh-stage__nav--prev" data-act="stage-prev" aria-label="' + esc(t('stage.prev')) + '">' + ICON.prev + '</button>' +
          '<button type="button" class="hh-stage__nav hh-stage__nav--next" data-act="stage-next" aria-label="' + esc(t('stage.next')) + '">' + ICON.next + '</button>' +
          ratingChip('hh-stage__rating') +
          '<div class="hh-stage__dots" data-ref="dots" aria-hidden="true">' + COLORS.map(function () { return '<i></i>'; }).join('') + '</div>' +
          '<div class="hh-stage__cele" data-ref="cele" aria-hidden="true"></div>' +
        '</div>';
      return '' + ed +
        '<div class="hh-cfg__grid" data-ref="grid">' +
          '<div class="hh-stagewrap" data-ref="stagewrap">' + stage +
            '<nav class="hh-progress hh-progress--stage" aria-label="Fortschritt" data-ref="progM"></nav>' +
          '</div>' +
          '<div class="hh-stepscol" data-ref="col">' +
            '<nav class="hh-progress hh-progress--col" aria-label="Fortschritt" data-ref="progD"></nav>' +
            '<div class="hh-steps" data-ref="steps">' + steps + '</div>' +
            barHtml() +
          '</div>' +
        '</div>' +
        aivHtml() +
        '<div class="hh-live" aria-live="polite" data-ref="live"></div>' +
        '<div class="hh-sheet" data-ref="sheet" hidden></div>' +
        '<div class="hh-sheet hh-sheet--size" data-ref="sizeSheet" hidden></div>' +
        '<div class="hh-story" data-ref="story" role="dialog" aria-modal="true" aria-label="Story" hidden></div>';
    }
    // heat video below the configurator (replaces the reused live section): sources are attached only when it comes near
    function aivHtml() {
      if (!AIV) return '';
      var r = +AIV.ratio > 0 ? +AIV.ratio : 1;
      return '<div class="hh-aiv" data-ref="aiv"><div class="hh-aiv__box" style="aspect-ratio:' + (Math.round(r * 1000) / 1000) + '">' +
        (AIV.poster ? '<img class="hh-aiv__poster" src="' + esc(AIV.poster) + '" alt="" loading="lazy" decoding="async">' : '') +
        '<video class="hh-aiv__v" data-ref="aivV" muted loop playsinline autoplay preload="none" aria-hidden="true">' + videoSources(AIV, true) + '</video>' +
        '<button type="button" class="hh-aiv__play" data-act="aiv-play" data-ref="aivPlay" aria-label="' + esc(t('story.play')) + '" hidden>' + ICON.play + '</button>' +
        '</div></div>';
    }
    function ratingChip(cls) {
      if (!D.rating || !(+D.rating.count > 0)) return '';
      var rv = (Math.round(parseFloat(D.rating.value) * 10) / 10).toFixed(1).replace('.', ',');
      return '<button type="button" class="hh-rating ' + cls + '" data-act="to-reviews" aria-label="' + esc(t('rating.aria', { r: rv, n: D.rating.count })) + '">' +
        '<span class="hh-stars" aria-hidden="true">' + (cls === 'hh-stage__rating' ? '★' : '★★★★★') + '</span><span>' + esc(cls === 'hh-stage__rating' ? rv + ' (' + D.rating.count + ')' : t('rating', { r: rv, n: D.rating.count })) + '</span></button>';
    }
    function stepHtml(n, kind, inner) {
      return '<section class="hh-step" data-step="' + n + '" data-kind="' + kind + '" data-ref="step' + n + '" aria-labelledby="' + HEAD[kind] + '">' +
        '<button type="button" class="hh-step__row" data-act="goto" data-step="' + n + '" data-ref="row' + n + '"></button>' +
        '<div class="hh-step__body"><div class="hh-step__inner">' + inner + '</div></div></section>';
    }
    function barHtml() {
      return '<div class="hh-bar is-pre" data-ref="bar"><div class="hh-bar__in">' +
        '<div data-ref="err" role="alert"></div>' +
        '<div class="hh-bar__total" data-ref="barTotal" hidden></div>' +
        '<div class="hh-bar__row">' +
          '<div class="hh-bar__price"><div class="hh-price"><span class="hh-price__now" data-ref="priceNow"><span class="hh-roll"></span></span><s class="hh-price__was" data-ref="priceWas"></s></div>' +
          '<div class="hh-bar__label" data-ref="barLabel"></div></div>' +
          '<button type="button" class="hh-btn hh-bar__cta hh-btn--hearth" data-ref="barCta"></button>' +
        '</div></div></div>';
    }
    function editionHtml() {
      var n = CFG.editionsSold, items = '';
      for (var i = 1; i <= n; i++) {
        items += '<li class="hh-ed__t is-sold"><span class="hh-ed__kn"><span class="hh-ed__k">' + esc(t('ed.k')) + '</span><span class="hh-ed__n">' + i + '</span></span>' +
          '<span class="hh-ed__stamp" data-stamp>' + esc(t('ed.sold')) + '</span></li>';
      }
      var liveN = n + 1;
      items += '<li class="hh-ed__t is-live"><span class="hh-ed__kn"><span class="hh-ed__k">' + esc(t('ed.k')) + '</span><span class="hh-ed__n">' + liveN + '</span></span>' +
        '<span class="hh-ed__live"><i class="hh-ed__dot" aria-hidden="true"></i>' + esc(t('ed.live')) + '</span></li>';
      // edition counter (Luis, 16 Oct): bar "X von 1.129 schon reserviert" only once X >= "Balken ab reserviert";
      // below that "Auflage 4 · 1.129 Hoodies · nur noch {n} frei" (never "0 reserviert"); after a restock (left > size) "Nur noch {n} verfügbar"
      var left = editionLeft(), size = CFG.editionSize, meta = '';
      var r = Math.max(0, size - left);
      if (size > 0 && left <= size && r >= CFG.barMin) {
        meta = '<span class="hh-ed__left"><span class="hh-ed__bar"><i data-ref="edbar" data-w="' + Math.round(r / size * 100) + '"></i></span><span>' +
          t('ed.reserved', { r: grp(r), size: grp(size), n: grp(left) }).replace(' · ', '<span class="hh-ed__opt"> · ') + '</span></span></span>';
      } else if (size > 0 && left <= size) {
        meta = '<span class="hh-ed__left"><span>' + t('ed.edition', { batch: '<span class="hh-ed__opt2">' + esc(CFG.batch) + ' · </span>', size: grp(size), n: grp(left) }).replace('</span> · ', '</span>') + '</span></span>';
      } else {
        meta = '<span class="hh-ed__left"><span>' + t('ed.left', { n: grp(left) }) + '</span></span>';
      }
      var d = daysToShip();
      var right = '';
      if (CFG.showCountdown && d != null && d > 1) right = t('ed.days', { d: d });
      else if (CFG.showCountdown && d === 1) right = t('ed.day1');
      else right = t('ed.date', { date: esc(CFG.shipDate) });
      return '<div class="hh-ed" data-ref="ed"><ol class="hh-ed__row" aria-label="Auflagen">' + items + '</ol>' +
        '<div class="hh-ed__meta">' + meta + '<span class="hh-ed__right">' + ICON.truck + '<span>' + right + '</span></span></div></div>';
    }
    function daysToShip() {
      if (!CFG.shipIso || !/^\d{4}-\d{2}-\d{2}$/.test(CFG.shipIso)) return null;
      var p = CFG.shipIso.split('-'), ship = new Date(+p[0], +p[1] - 1, +p[2]);
      var now = window.HHCFG_NOW ? new Date(window.HHCFG_NOW) : new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var d = Math.round((ship - today) / 86400000);
      return d >= 0 ? d : null;
    }

    var payTpl = q('template[data-hh-pay]', root), PAY = payTpl ? payTpl.innerHTML.trim() : '';
    root.innerHTML = shell();
    var $ = {};
    qa('[data-ref]', root).forEach(function (el) { $[el.getAttribute('data-ref')] = el; });
    if (RM()) root.classList.add('is-rm');
    root.classList.toggle('is-mfirst', ORDER_ID === 'm1');   // Liquid sets it server-side too (stage height, no shift)

    /* ───────────────────────── renderers ───────────────────────── */
    function renderProgress() {
      // v4: labels by kind ("Farbe & Größe" does not fit the 375 px bar, so the hoodie stays "Hoodie" there)
      var labels = ORDER.map(function (k) { return t(k === 'hoodie' ? 'prog.1' : (k === 'moochie' ? 'prog.2' : 'prog.3')); });
      var dn = [kindDone(ORDER[0]), kindDone(ORDER[1]) && kindDone(ORDER[0]), false];
      var html = '<ol class="hh-prog">';
      for (var i = 1; i <= 3; i++) {
        var active = S.step === i, isDone = dn[i - 1] && !active, reach = i <= S.maxStep || canGoto(i);
        var cls = 'hh-prog__b' + (active ? ' is-active' : '') + (isDone ? ' is-done' : '');
        html += '<li class="hh-prog__li"><button type="button" class="' + cls + '" data-act="goto" data-step="' + i + '"' +
          (active ? ' aria-current="step"' : '') + (reach ? '' : ' aria-disabled="true"') + ' aria-label="Schritt ' + i + ' von 3: ' + esc(labels[i - 1]) + '">' +
          '<span class="hh-prog__dot">' + (isDone ? ICON.check : i) + '</span><span class="hh-prog__l">' + esc(labels[i - 1]) + '</span></button></li>';
        if (i < 3) html += '<li class="hh-prog__line' + (dn[i - 1] ? ' is-done' : '') + '" aria-hidden="true"><i></i></li>';
      }
      html += '</ol>';
      $.progM.innerHTML = html; $.progD.innerHTML = html;
    }

    function stockBadge(c) {
      var s = set0().size;
      if (!colorAvail(c)) return { txt: t('color.sold'), low: true };
      if (s) {
        var v = resolve(c, s);
        if (!v) return { txt: t('color.sizeSold', { s: s }), low: true };
        var n = qtyOf(v); if (n == null) return null;
        return { txt: t('color.sizeLeft', { s: s, n: grp(n) }), low: n <= CFG.warn };
      }
      var cq = colorQty(c); if (cq == null) return null;
      // real numbers always (Luis); emphasis only where the colour is really getting scarce
      var lowC = cq <= CFG.colorLow;
      return { txt: t(lowC ? 'color.leftLow' : 'color.left', { n: grp(cq) }), low: lowC };
    }
    function colorCards(selected, act, small) {
      return COLORS.map(function (c) {
        var b = small ? null : stockBadge(c.name), sel = c.name === selected, sold = !colorAvail(c.name);
        var aria = c.name + (b ? ', ' + b.txt : '');
        return '<button type="button" class="hh-ccard' + (sold ? ' is-sold' : '') + '" data-act="' + act + '" data-color="' + esc(c.name) + '" aria-pressed="' + sel + '" aria-label="' + esc(aria) + '">' +
          '<span class="hh-check" aria-hidden="true">' + ICON.check + '</span>' +
          '<span class="hh-ccard__img"><img src="' + esc(c.thumb) + '" alt="" width="120" height="120" decoding="async"></span>' +
          '<span class="hh-ccard__name">' + esc(c.name) + '</span>' +
          (b ? '<span class="hh-ccard__stock' + (b.low ? '' : ' is-calm') + '" data-stock>' + esc(b.txt) + '</span>' : '') +
          '</button>';
      }).join('');
    }
    function sizePills(color, selected, act) {
      var hasLow = false;
      var html = SIZES.map(function (s) {
        var v = resolve(color, s), n = qtyOf(v), sold = !v, sel = s === selected && !sold;
        var low = !sold && n != null && n <= CFG.warn;
        if (low) hasLow = true;
        // low stock = a small second line INSIDE the button (v2: the old badge hung below the button into the stock box)
        return '<button type="button" class="hh-size' + (sold ? ' is-sold' : '') + (low ? ' is-low' : '') + '" data-act="' + act + '" data-size="' + esc(s) + '" aria-pressed="' + sel + '"' +
          (sold ? ' aria-label="' + esc(t('size.soldAria', { s: s })) + '"' : (low ? ' aria-label="' + esc(s + ', ' + t('size.low', { n: n })) + '"' : '')) + '><span class="hh-size__s">' + esc(s) + '</span>' +
          (low ? '<span class="hh-size__low" aria-hidden="true">' + esc(t('size.low', { n: n })) + '</span>' : '') + '</button>';
      }).join('');
      return { html: html, hasLow: hasLow };
    }

    // rating chip (desktop) or the batch eyebrow above the page title: it sits in whichever panel is step 1
    function headrowHtml() {
      var rating = ratingChip('hh-rating--steps');
      return '<div class="hh-headrow">' + (rating || '<p class="hh-eyebrow">' + esc(t('s1.eyebrow', { batch: CFG.batch })) + '</p>') + '</div>';
    }
    // v4: the hoodie sub-line follows the Moochie that is already in the pocket when the hoodie step comes second
    function hoodieSub() {
      if (posOf('hoodie') === 1) return t('s1.sub');
      var m = set0().moochie;
      if (m && m !== 'none' && MBY[m]) return t('s1.subM', { m: MBY[m].title });
      if (m === 'none') return t('s1.sub0');
      return t('s1.sub');
    }
    function updateHoodieSub() { if ($.s1sub) { var x = hoodieSub(); if ($.s1sub.textContent !== x) $.s1sub.textContent = x; } }
    function renderStep1() {
      var s0 = set0();
      var first = posOf('hoodie') === 1;
      var ugc = '';
      if (UGC.length) {
        ugc = '<div class="hh-ugc"><div class="hh-label"><span class="hh-label__k">' + esc(t('ugc.k')) + '</span></div><div class="hh-ugc__row">' +
          UGC.map(function (u, i) {
            var cap = u.caption || u.color || t('ugc.cap');
            return '<button type="button" class="hh-bub" data-act="story" data-i="' + i + '" aria-label="' + esc(t('ugc.aria', { c: cap })) + '">' +
              '<span class="hh-bub__ring' + (hasVideo(u) ? ' hh-bub__play' : '') + '"><span class="hh-bub__in"><img src="' + esc(u.poster) + '" alt="" loading="lazy" decoding="async" width="64" height="64"></span></span>' +
              '<span class="hh-bub__cap">' + esc(cap) + '</span></button>';
          }).join('') + '</div></div>';
      }
      var sp = sizePills(s0.color, s0.size, 'size');
      $.s1.innerHTML = '' +
        (first ? headrowHtml() + '<h1 class="hh-h1" id="hh-s1-h" tabindex="-1">' + esc(t('s1.title')) + '</h1>'
          : '<h2 class="hh-h2" id="hh-s1-h" tabindex="-1">' + esc(t('s1.title')) + '</h2>') +
        '<p class="hh-sub hh-s1sub" data-ref="s1sub">' + esc(hoodieSub()) + '</p>' +
        '<div class="hh-label hh-label--color"><span class="hh-label__k" data-ref="colorK">' + esc(t('color.k')) + ' — <span class="hh-label__v" data-ref="colorV">' + esc(s0.color) + '</span></span></div>' +
        '<fieldset><legend class="hh-vh">' + esc(t('color.k')) + '</legend><div class="hh-colors" data-ref="colors">' + colorCards(s0.color, 'color') + '</div></fieldset>' +
        '<div data-ref="soldColor"></div>' +
        ugc +
        '<div class="hh-label"><span class="hh-label__k" data-ref="sizeK">' + esc(t('size.k')) + ' — <span class="hh-label__v" data-ref="sizeV">' + esc(s0.size || '–') + '</span></span>' +
          '<button type="button" class="hh-link" data-act="sizehelp" data-mode="chart">' + esc(t('sf.chart')) + '</button></div>' +
        '<fieldset><legend class="hh-vh">' + esc(t('size.k')) + '</legend><div class="hh-sizes" data-ref="sizes"><span class="hh-loz" data-ref="loz" aria-hidden="true"></span>' + sp.html + '</div></fieldset>' +
        '<button type="button" class="hh-sfbtn" data-act="sizehelp" data-mode="find" aria-haspopup="dialog">' + ICON.ruler + '<span>' + esc(t('sf.open')) + '</span><span class="hh-arr" aria-hidden="true">→</span></button>' +
        '<div class="hh-stock" data-ref="stock"><span class="hh-stock__dot" aria-hidden="true"></span><p class="hh-stock__line" data-ref="stockLine"></p></div>' +
        '<div data-ref="soldMsg"></div>' +
        '<button type="button" class="hh-btn hh-btn--embrace hh-btn--block hh-inline-next" data-act="next" data-ref="next1" hidden></button>' +
        '<p class="hh-trust"><span>' + ICON.truck + esc(t('trust.1')) + '</span><span>' + ICON.undo + esc(t('trust.2')) + ' · ' + esc(t('trust.3')) + '</span></p>' +
        galleryHtml();
      qa('[data-ref]', $.s1).forEach(function (el) { $[el.getAttribute('data-ref')] = el; });
      updateStep1(true);
    }
    /* ── product photos: "So sieht er in echt aus" (lazy strip, ordered by the chosen colour, tap = full screen) ── */
    var galOrder = GAL.slice();
    function orderGallery(color) {
      var a = [], b = [];
      GAL.forEach(function (g) { (g.color && g.color === color ? a : b).push(g); });
      return a.concat(b);
    }
    // square-crop focus of a photo ("50% 55%" = x y): portrait photos (v3: the Midnight Black one) keep face + pocket in the card
    function galPos(p) { var m = /^\s*(\d{1,3}(?:\.\d+)?)%\s+(\d{1,3}(?:\.\d+)?)%\s*$/.exec(p || ''); return m ? m[1] + '% ' + m[2] + '%' : ''; }
    function galleryHtml() {
      if (!GAL.length) return '';
      return '<div class="hh-gal"><div class="hh-label"><span class="hh-label__k">' + esc(t('gal.k')) + '</span></div>' +
        '<div class="hh-gal__row" data-ref="gal"></div></div>';
    }
    function renderGallery() {
      if (!$.gal) return;
      var next = orderGallery(set0().color);
      var same = next.length === galOrder.length && next.every(function (g, i) { return g === galOrder[i]; });
      if (same && $.gal.firstChild) return;
      galOrder = next;
      $.gal.innerHTML = galOrder.map(function (g, i) {
        var set = [g.s400 ? esc(g.s400) + ' 400w' : '', esc(g.src) + ' 600w', g.s900 ? esc(g.s900) + ' 900w' : ''].filter(Boolean).join(', ');
        return '<button type="button" class="hh-gal__card" data-act="photo" data-i="' + i + '" aria-label="' + esc(t('gal.aria', { n: i + 1, t: galOrder.length }) + ': ' + (g.alt || '')) + '">' +
          '<img src="' + esc(g.src) + '" srcset="' + set + '" sizes="(min-width:1024px) 230px, 62vw" alt="' + esc(g.alt || '') + '" width="' + (g.w || 600) + '" height="' + (g.h || 600) + '"' +
            (galPos(g.pos) ? ' style="object-position:' + galPos(g.pos) + '"' : '') + ' loading="lazy" decoding="async">' +
          '<span class="hh-gal__zoom" aria-hidden="true">' + ICON.zoom + '</span></button>';
      }).join('');
      $.gal.scrollLeft = 0;
    }
    function updateStep1(noAnim) {
      var s0 = set0();
      // colour cards
      qa('.hh-ccard', $.colors).forEach(function (b) {
        var c = b.getAttribute('data-color'), badge = stockBadge(c), el = q('[data-stock]', b);
        b.setAttribute('aria-pressed', String(c === s0.color));
        b.setAttribute('aria-label', c + (badge ? ', ' + badge.txt : ''));
        if (badge) {
          if (!el) { el = document.createElement('span'); el.setAttribute('data-stock', ''); b.appendChild(el); }
          el.className = 'hh-ccard__stock' + (badge.low ? '' : ' is-calm'); el.textContent = badge.txt;
        } else if (el) el.remove();
      });
      // sizes
      var sp = sizePills(s0.color, s0.size, 'size');
      var keepLoz = $.loz;
      $.sizes.innerHTML = sp.html; $.sizes.insertBefore(keepLoz, $.sizes.firstChild);
      $.sizeV.textContent = s0.size || '–';
      moveLoz(noAnim);
      // stock line
      renderStock($.stock, $.stockLine, s0.color, s0.size);
      // sold-out msg
      var soldHtml = '';
      if (s0.size && !resolve(s0.color, s0.size)) {
        var alts = COLORS.filter(function (c) { return c.name !== s0.color && resolve(c.name, s0.size); });
        soldHtml = '<div class="hh-soldmsg" role="status">' + esc(t('sold.size', { s: s0.size, c: s0.color })) +
          (alts.length ? '<div class="hh-soldmsg__alts"><span style="font-size:12.5px;color:var(--ink-mid);align-self:center">' + esc(t('sold.alts')) + '</span>' +
            alts.map(function (c) { return '<button type="button" class="hh-chipbtn" data-act="color" data-color="' + esc(c.name) + '"><i style="background:' + esc(c.swatch) + '"></i>' + esc(c.name) + '</button>'; }).join('') + '</div>'
            : '<div style="margin-top:6px">' + esc(t('sold.none')) + '</div>') + '</div>';
      }
      $.soldMsg.innerHTML = soldHtml;
      $.soldColor.innerHTML = colorAvail(s0.color) ? '' : '<div class="hh-soldmsg" role="status">' + esc(t('sold.color', { c: s0.color })) + '</div>';
      // inline next
      // inline next step: large, right under the decision (v2: was hidden in v1, only the sticky bar had it)
      var showNext = hoodieDone(), wasHidden = $.next1.hidden;
      $.next1.hidden = !showNext;
      $.next1.innerHTML = esc((S.maxStep >= 3 || (!firstMissingKind() && S.maxStep > posOf('hoodie'))) ? t('cta.back') : t(NEXT_IN[kindAt(posOf('hoodie') + 1)])) + ARR;
      if (showNext && wasHidden && !noAnim) anim($.next1, [{ opacity: 0, transform: 'translateY(8px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: EASE.spring });
      updateHoodieSub();
      renderGallery();
    }
    function renderStock(box, line, color, size) {
      box.className = 'hh-stock';
      var v = size ? resolve(color, size) : null;
      if (size && !v) {
        box.classList.add('is-sold'); line.textContent = t('stock.sold'); return;
      }
      if (!size) {
        var cq = colorQty(color);
        if (cq == null || !colorAvail(color)) { box.hidden = true; return; }
        box.hidden = false; box.classList.add('is-pre');
        line.innerHTML = esc(t('stock.prefix')) + ' <em>' + grp(cq) + '</em> ' + esc(t('stock.color', { c: color }));
        return;
      }
      var n = qtyOf(v);
      if (n == null) { box.hidden = true; return; }
      box.hidden = false;
      var pre = iF >= 0 && v.options[iF] === PREVAL;
      if (pre) box.classList.add('is-pre');
      if (n <= CFG.warn) box.classList.add('is-low');
      var em = q('em', line), prev = em ? em.textContent : null;
      line.innerHTML = esc(t('stock.prefix')) + ' <em>' + grp(n) + '</em> ' + esc(pre ? t('stock.pre') : t('stock.ships'));
      if (prev !== null && prev !== grp(n)) anim(q('em', line), [{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 500, easing: EASE.out });
    }
    var lozRect = null;
    function moveLoz(noAnim, container, lozEl, selected) {
      container = container || $.sizes; lozEl = lozEl || $.loz;
      if (!container || !lozEl) return;
      var btn = q('.hh-size[aria-pressed="true"]', container);
      if (!btn) { lozEl.classList.remove('is-on'); return; }
      var cr = container.getBoundingClientRect(), br = btn.getBoundingClientRect();
      if (!cr.width) { requestAnimationFrame(function () { moveLoz(noAnim, container, lozEl); }); return; }
      var x = br.left - cr.left, w = br.width;
      var was = lozEl.classList.contains('is-on');
      var from = lozEl.__pos;
      lozEl.style.width = w + 'px';
      lozEl.style.transform = 'translateX(' + x + 'px)';
      lozEl.classList.add('is-on');
      if (was && from && !noAnim) {
        anim(lozEl, [{ transform: 'translateX(' + from.x + 'px)', width: from.w + 'px' }, { transform: 'translateX(' + x + 'px)', width: w + 'px' }], { duration: 300, easing: EASE.snap });
      } else if (!was && !noAnim) {
        anim(lozEl, [{ transform: 'translateX(' + x + 'px) scale(.8)', opacity: 0 }, { transform: 'translateX(' + x + 'px) scale(1)', opacity: 1 }], { duration: 260, easing: EASE.spring });
      }
      lozEl.__pos = { x: x, w: w };
    }

    function renderStep2() {
      var s0 = set0(), u = MOO[0] ? MOO[0].price : 3800;
      var w = Math.round(u * (1 - CFG.mpct / 100));
      var m = model(S.sets);
      var sub;
      // driven by the price model, so the copy can never promise more free Moochies than the cart gives
      if (S.sets.length >= 2 && m.tier > 0) sub = t('s2.subFree', { h: S.sets.length, n: Math.min(m.tier, S.sets.length) });
      else sub = CFG.mdisc ? t('s2.sub', { w: fmtShort(w), u: fmtShort(u) }) : t('s2.subOff');
      // v4: as step 1 the Moochie panel carries the page title (h1), the rating/eyebrow row and the trust line
      var first = posOf('moochie') === 1, ttl = esc(t('s2.title')) + (CFG.mdisc ? '<span class="hh-badge">' + esc(t('s2.badge', { p: CFG.mpct })) + '</span>' : '');
      $.s2.innerHTML = '' +
        (first ? headrowHtml() + '<h1 class="hh-h1" id="hh-s2-h" tabindex="-1">' + ttl + '</h1>' : '<h2 class="hh-h2" id="hh-s2-h" tabindex="-1">' + ttl + '</h2>') +
        '<p class="hh-sub">' + esc(sub) + '</p>' +
        '<div class="hh-info"><button type="button" class="hh-link" data-act="info" aria-expanded="false" style="padding-left:0">' + esc(t('s2.info')) + '</button>' +
        '<div class="hh-pop" data-ref="pop" hidden>' + esc(t('s2.infoBody')) + '</div></div>' +
        '<fieldset><legend class="hh-vh">Moochie</legend><div class="hh-mgrid" data-ref="mgrid">' + moochieCards(S.sets, 0, 'moochie') + '</div></fieldset>' +
        '<button type="button" class="hh-none" data-act="none" aria-pressed="' + (s0.moochie === 'none') + '" data-ref="none"><span class="hh-check" aria-hidden="true">' + ICON.check + '</span>' + esc(t('m.none')) + '<small>' + esc(t('m.noneSub')) + '</small></button>' +
        '<button type="button" class="hh-btn hh-btn--embrace hh-btn--block hh-inline-next" data-act="next" data-ref="next2" hidden></button>' +
        (first ? '<p class="hh-trust"><span>' + ICON.truck + esc(t('trust.1')) + '</span><span>' + ICON.undo + esc(t('trust.2')) + ' · ' + esc(t('trust.3')) + '</span></p>' : '');
      qa('[data-ref]', $.s2).forEach(function (el) { $[el.getAttribute('data-ref')] = el; });
      updateStep2();
      watchNext();
      void m;
    }
    function moochieCards(sets, i, act) {
      var cur = sets[i] ? sets[i].moochie : null;
      return MOO.map(function (mo) {
        var line = moochieCardPrice(sets, i, mo.handle), p = line ? line.price : mo.price;
        var priceHtml = p === 0 ? '<span class="hh-mcard__price is-free">' + esc(t('m.free')) + '<s>' + fmt(mo.price) + '</s></span>'
          : (p < mo.price ? '<span class="hh-mcard__price">' + fmt(p) + '<s>' + fmt(mo.price) + '</s></span>' : '<span class="hh-mcard__price">' + fmt(p) + '</span>');
        var aria = t('m.aria', { m: mo.title, p: p === 0 ? t('m.free') : fmt(p) });
        return '<button type="button" class="hh-mcard" data-act="' + act + '" data-handle="' + esc(mo.handle) + '" aria-pressed="' + (cur === mo.handle) + '" aria-label="' + esc(aria) + '">' +
          '<span class="hh-check" aria-hidden="true">' + ICON.check + '</span>' +
          (i === 0 && act === 'moochie' && mo.handle === SHOW ? '<span class="hh-mcard__peek" data-peek="' + esc(mo.handle) + '" hidden>' + esc(t('m.peek')) + '</span>' : '') +
          '<span class="hh-mcard__img"><img src="' + esc(mo.img) + '" alt="" loading="lazy" decoding="async" width="150" height="150"></span>' +
          '<span class="hh-mcard__name">' + esc(mo.title) + '</span>' + priceHtml + '</button>';
      }).join('');
    }
    function updateStep2() {
      var s0 = set0();
      qa('.hh-mcard', $.mgrid).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-handle') === s0.moochie)); });
      $.none.setAttribute('aria-pressed', String(s0.moochie === 'none'));
      updatePeek();
      var wasHidden = $.next2.hidden;
      $.next2.hidden = !moochieDone();
      $.next2.innerHTML = esc((S.maxStep >= 3 || (!firstMissingKind() && S.maxStep > posOf('moochie'))) ? t('cta.back') : t(NEXT_IN[kindAt(posOf('moochie') + 1)])) + ARR;
      updateHoodieSub();
      if (!$.next2.hidden && wasHidden && kindAt(S.step) === 'moochie') anim($.next2, [{ opacity: 0, transform: 'translateY(8px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: EASE.spring });
    }

    function renderStep3() {
      var m = model(S.sets);
      var blocks = S.sets.map(function (set, i) {
        var v = vOf(set) || anyVariantOf(set.color), c = CBY[set.color] || COLORS[0];
        var pre = iF >= 0 && v.options[iF] === PREVAL;
        var head = S.sets.length > 1 ? '<div class="hh-sum__sethead"><span>' + esc(t('sum.set', { n: i + 1 })) + '</span>' +
          (i > 0 ? '<span><button type="button" class="hh-tbtn" data-act="set-edit" data-i="' + i + '">Ändern</button> <button type="button" class="hh-tbtn" data-act="set-remove" data-i="' + i + '">' + esc(t('sum.remove')) + '</button></span>' : '') + '</div>' : '';
        var hv = '<div class="hh-sumrow__val">' + fmt(v.price) + (CFG.showCompare && v.compare > v.price ? '<s>' + fmt(v.compare) + '</s>' : '') + (pre ? '<small>' + esc(t('sum.pre')) + '</small>' : '') + '</div>';
        var hrow = '<div class="hh-sumrow"><span class="hh-sumrow__img"><img src="' + esc(c.thumb) + '" alt="" width="44" height="44"></span>' +
          '<span class="hh-sumrow__txt">' + esc(t('sum.hoodie')) + '<small>' + esc(t('sum.hmeta', { c: set.color, s: set.size || '?' })) + '</small>' +
          (i === 0 ? '<button type="button" class="hh-tbtn hh-edit" data-act="goto" data-step="' + posOf('hoodie') + '">Ändern</button>' : '') + '</span>' + hv + '</div>';
        var line = lineFor(m, i), mrow;
        if (line) {
          var mo = MBY[line.handle], meta = line.kind === 'free' ? t('sum.mFree') : (line.kind === 'half' ? t('sum.mHalf', { p: CFG.mpct }) : t('sum.mFull'));
          var val = line.price === 0 ? '<div class="hh-sumrow__val is-free">' + esc(t('m.free')) + '<s>' + fmt(line.unit) + '</s></div>'
            : '<div class="hh-sumrow__val">' + fmt(line.price) + (line.price < line.unit ? '<s>' + fmt(line.unit) + '</s>' : '') + '</div>';
          mrow = '<div class="hh-sumrow"><span class="hh-sumrow__img is-round"><img src="' + esc(mo.img) + '" alt="" width="44" height="44"></span>' +
            '<span class="hh-sumrow__txt">' + esc(t('sum.m', { m: mo.title })) + '<small>' + esc(meta) + '</small>' +
            (i === 0 ? '<button type="button" class="hh-tbtn hh-edit" data-act="goto" data-step="' + posOf('moochie') + '">Ändern</button>' : '') + '</span>' + val + '</div>';
        } else {
          mrow = '<div class="hh-sumrow"><span class="hh-sumrow__img is-icon">' + ICON.heart + '</span><span class="hh-sumrow__txt">' + esc(t('sum.none')) +
            (i === 0 ? '<small><button type="button" class="hh-tbtn" data-act="goto" data-step="' + posOf('moochie') + '" style="padding-left:0">' + esc(t('cta.moochie')) + '</button></small>' : '') +
            '</span><div class="hh-sumrow__val is-muted">–</div></div>';
        }
        var brow = '<div class="hh-sumrow"><span class="hh-sumrow__img is-icon">' + ICON.bottle + '</span><span class="hh-sumrow__txt">' + esc(t('sum.bottle')) +
          '<small>' + esc(t('sum.bottleMeta')) + '</small></span><div class="hh-sumrow__val is-muted">' + esc(t('sum.bottleVal')) + '</div></div>';
        return '<div class="hh-sum__set">' + head + hrow + mrow + brow + '</div>';
      }).join('');
      var ship = xmSummaryHtml(m) + '<div class="hh-sumrow"><span class="hh-sumrow__img is-icon">' + ICON.truck + '</span><span class="hh-sumrow__txt">' + esc(t('sum.ship')) + '</span><div class="hh-sumrow__val is-free">' + esc(t('sum.shipVal')) + '</div></div>';
      var save = m.compare > m.total ? '<span class="hh-save">' + esc(t('sum.save', { v: fmt(m.compare - m.total) })) + '</span>' : '';
      var total = '<hr class="hh-sum__div"><div class="hh-sum__total"><div class="hh-sum__total-k">' + esc(t('sum.total')) + '<small>' + esc(t('sum.vat')) + '</small></div>' +
        '<div class="hh-sum__total-v">' + (m.compare > m.total ? '<s>' + fmt(m.compare) + '</s>' : '') + '<b>' + fmt(m.total) + '</b></div></div>' + save;
      var freeLeft = '';
      var freeSlots = m.tier ? Math.min(m.tier, S.sets.length) - m.free : 0;
      if (freeSlots > 0) {
        var target = -1; S.sets.forEach(function (s, i) { if (target < 0 && (!s.moochie || s.moochie === 'none')) target = i; });
        freeLeft = '<div class="hh-freeleft"><span>' + esc(freeSlots === 1 ? t('sum.free1') : t('sum.freeN', { k: freeSlots })) + '</span>' +
          '<button type="button" class="hh-tbtn" data-act="' + (target === 0 ? 'goto' : 'set-edit') + '" data-step="' + posOf('moochie') + '" data-i="' + target + '">' + esc(t('sum.freeCta')) + '</button></div>';
      }
      var allPre = S.sets.every(function (s) { var v = vOf(s); return !v || (iF >= 0 && v.options[iF] === PREVAL); });
      var seal = allPre ? '<div class="hh-seal" aria-hidden="true"><span>' + esc(t('seal.k')) + '</span><b>' + (CFG.editionsSold + 1) + '</b><span>' + esc(t('seal.s')) + '</span></div>' : '';
      var pre = '<div class="hh-pre"><span class="hh-pre__ico">' + ICON.cal + '</span><div><div class="hh-pre__k">' + esc(t('pre.k', { batch: CFG.batch })) + '</div>' +
        '<div class="hh-pre__d">' + esc(allPre ? t('pre.d', { date: CFG.shipDate }) : t('pre.now')) + '</div><div class="hh-pre__s">' + esc(t('pre.s')) + '</div></div></div>';
      var up = upsellHtml();
      // the buying action sits right under the total (not only in the sticky bar), then the payment icons of the live PDP
      // (Liquid: settings.cart_payment__items). v3 (Luis): "Zur Kasse" is the ONLY buying action, no "In den Warenkorb".
      // v4 (data result 23 Oct): the drawer's reassurance moves next to the button – the real rating above it,
      // free shipping + 30-day return right below it, then the payment icons (no extra screen before the checkout)
      var rateLine = '';
      if (D.rating && +D.rating.count > 0) {
        var rv = (Math.round(parseFloat(D.rating.value) * 10) / 10).toFixed(1).replace('.', ',');
        rateLine = '<p class="hh-act__rating"><span class="hh-stars" aria-hidden="true">★★★★★</span><span>' + esc(t('rating', { r: rv, n: D.rating.count })) + '</span></p>';
      }
      var actions = '<div class="hh-actions" data-ref="actions">' + rateLine +
        '<button type="button" class="hh-btn hh-btn--embrace hh-btn--block hh-act__checkout" data-act="submit" data-mode="' + CFG.mode + '" data-ref="actCheckout">' + esc(cashLabel()) + ARR + '</button>' +
        '<p class="hh-act__trust">' + ICON.truck + '<span>' + esc(t('act.trust')) + '</span></p>' +
        (PAY ? '<div class="hh-pay" role="list" aria-label="Zahlungsarten">' + PAY + '</div>' : '') + '</div>';
      $.s3.innerHTML = '<div class="hh-s3head"><div><h2 class="hh-h2" id="hh-s3-h" tabindex="-1">' + esc(t('s3.title')) + '</h2></div>' + seal + '</div>' +
        pre + '<div class="hh-sumcard">' + blocks + ship + total + freeLeft + '</div>' + up + actions;
      qa('[data-ref]', $.s3).forEach(function (el) { $[el.getAttribute('data-ref')] = el; });
      if ($.bar) { renderActions(); watchActions(); }
    }
    // while the summary's own "Zur Kasse" is on screen, the sticky bar steps aside (one buy button at a time);
    // it comes back as soon as they scroll away, and always for errors
    var actIO = null;
    function watchActions() {
      if (!('IntersectionObserver' in window) || !$.actCheckout) return;
      if (!actIO) actIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { S.actVis = e.isIntersecting; }); tuckBar();
      }, { rootMargin: '0px 0px -90px 0px', threshold: 0.6 });
      actIO.disconnect(); S.actVis = false; tuckBar();
      actIO.observe($.actCheckout);
    }
    // v2 review: same rule for the big inline "Weiter" buttons of steps 1 and 2 (one pink button per action on screen)
    var nextIO = null, nextVis = {};
    function watchNext() {
      if (!('IntersectionObserver' in window)) return;
      if (!nextIO) nextIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { nextVis[e.target.getAttribute('data-ref')] = e.isIntersecting && !e.target.hidden; });
        S.nextVis = !!((kindAt(S.step) === 'hoodie' && nextVis.next1) || (kindAt(S.step) === 'moochie' && nextVis.next2)); tuckBar();
      }, { rootMargin: '0px 0px -90px 0px', threshold: 0.6 });
      nextIO.disconnect(); nextVis = {}; S.nextVis = false;
      ['next1', 'next2'].forEach(function (k) { if ($[k]) nextIO.observe($[k]); });
    }
    function tuckBar() {
      if (!$.bar) return;
      var k = kindAt(S.step);
      S.nextVis = !!((k === 'hoodie' && nextVis.next1 && $.next1 && !$.next1.hidden) || (k === 'moochie' && nextVis.next2 && $.next2 && !$.next2.hidden));
      $.bar.classList.toggle('is-tucked', ((!!S.actVis && S.step === 3) || (S.nextVis && S.step < 3 && S.submit !== 'adding')) && !S.error);
    }
    function upsellHtml() {
      var n = S.sets.length, rows = '';
      var thumbs = function (k) {
        var c = CBY[set0().color] || COLORS[0], im = '';
        for (var i = 0; i < k; i++) im += '<img src="' + esc((CBY[(S.sets[i] && S.sets[i].color) || c.name] || c).thumb) + '" alt="">';
        if (MOO[0]) im += '<img class="hh-tier__m" src="' + esc(MOO[0].img) + '" alt="">';
        return '<span class="hh-tier__vis" aria-hidden="true">' + im + '</span>';
      };
      if (CFG.tier2 && n === 1) rows += '<button type="button" class="hh-tier" data-act="tier" data-tier="2">' + thumbs(2) +
        '<span class="hh-tier__txt"><span class="hh-tier__t">' + esc(t('up.t2')) + '<span class="hh-tier__pop">' + esc(t('up.pop')) + '</span></span><span class="hh-tier__s" style="display:block">' + t('up.t2s', { d: fmt(tierDelta(2)) }) + '</span></span><span class="hh-tier__plus">' + ICON.plus + '</span></button>';
      if (CFG.tier3 && n === 1) rows += '<button type="button" class="hh-tier" data-act="tier" data-tier="3">' + thumbs(3) +
        '<span class="hh-tier__txt"><span class="hh-tier__t">' + esc(t('up.t3')) + '</span><span class="hh-tier__s" style="display:block">' + t('up.t3s', { d: fmt(tierDelta(3)) }) + '</span></span><span class="hh-tier__plus">' + ICON.plus + '</span></button>';
      if (CFG.tier3 && n === 2) rows += '<button type="button" class="hh-tier" data-act="tier" data-tier="3">' + thumbs(3) +
        '<span class="hh-tier__txt"><span class="hh-tier__t">' + esc(t('up.t3from2')) + '</span><span class="hh-tier__s" style="display:block">' + t('up.t3from2s', { d: fmt(tierDelta(3)) }) + '</span></span><span class="hh-tier__plus">' + ICON.plus + '</span></button>';
      if (!rows) return '';
      if (!S._upViewed) { S._upViewed = true; track('hh_cfg_upsell_view', {}); }
      return '<div class="hh-up"><p class="hh-eyebrow">' + esc(t('up.k')) + '</p><h3 class="hh-up__title">' + esc(t('up.title')) + '</h3>' + rows + '</div>';
    }

    function renderRows() {
      var s0 = set0(), lab = { hoodie: t('prog.1'), moochie: t('prog.2'), sum: t('prog.3') };
      for (var n = 1; n <= 3; n++) {
        var k = kindAt(n), row = $['row' + n], st = $['step' + n];
        var isOpen = S.step === n, reached = n <= S.maxStep;
        var wasOpen = st.classList.contains('is-open');
        if (isOpen && !wasOpen) {
          st.classList.add('is-open');
          clearTimeout(st.__settle);
          // after the open animation the body leaves grid mode, so a stalled/skipped transition can never hide content
          (function (el) { el.__settle = setTimeout(function () { if (el.classList.contains('is-open')) el.classList.add('is-settled'); }, RM() || el.classList.contains('no-trans') ? 0 : 480); })(st);
        } else if (!isOpen && wasOpen) {
          clearTimeout(st.__settle);
          st.classList.remove('is-settled');
          void st.offsetHeight;
          st.classList.remove('is-open');
        }
        st.classList.toggle('is-locked', !reached && !isOpen);
        // v4b: a collapsed panel is only clipped – take it out of the tab order and the accessibility tree
        var bd = q('.hh-step__body', st);
        if (bd) { if ('inert' in bd) bd.inert = !isOpen; if (isOpen) bd.removeAttribute('aria-hidden'); else bd.setAttribute('aria-hidden', 'true'); }
        var txt;
        // v4: by kind; a hoodie step that was never opened says what waits there ("Farbe & Größe"), not the default colour
        if (k === 'hoodie') txt = lab.hoodie + ' · <small>' + ((reached || s0.size) ? esc(s0.color) + (s0.size ? ' · ' + esc(s0.size) : '') : esc(t('row.hoodie0'))) + '</small>';
        else if (k === 'moochie') txt = lab.moochie + (s0.moochie ? ' · <small>' + esc(s0.moochie === 'none' ? t('sum.none') : MBY[s0.moochie].title) + '</small>' :
          (CFG.mdisc && !reached ? ' <span class="hh-badge hh-badge--row">' + esc(t('row2.teaser', { p: CFG.mpct })) + '</span>' : ''));
        else txt = lab.sum;
        var doneN = kindDone(k);
        var ico = (reached && doneN) ? '<span class="hh-step__row-ico">' + ICON.check + '</span>' : '<span class="hh-step__row-ico is-locked">' + n + '</span>';
        row.innerHTML = ico + '<span class="hh-step__row-txt">' + txt + '</span>' + (reached ? '<span class="hh-step__row-edit">Ändern</span>' : '');
        // locked rows stay tappable: gotoStep() routes to whatever is missing (no grey dead ends)
        row.removeAttribute('aria-disabled');
        row.setAttribute('aria-label', reached && doneN ? lab[k] + ' – erledigt, zum Ändern tippen' : 'Schritt ' + n + ' von 3: ' + lab[k]);
      }
      if (typeof onScroll === 'function' && $.grid) onScroll();
    }

    /* ── stage ── */
    var stageColor = null, sweepAnims = [];
    function colorImg(c, big) { var x = CBY[c] || COLORS[0]; return big && isDesk() ? (x.img2x || x.img) : x.img; }

    /* ── pocket stage: the chosen Moochie sits IN the zip pocket. Layers (Settings → Files, hgp3_*.png) lie over the
       unchanged product photo: zip (opened zip) → body → front (lower lip) → shadow → paws. A colour or Moochie without
       layers, or a layer that does not load, falls back to the round sticker. ── */
    var PK = D.pocket && D.pocket.colors ? D.pocket : null;
    var PKOK = {}, PKBAD = {}, PKLOAD = {};
    var pkCur = null, stageMoo = null, pkTok = 0, pkFly = 0, pkLeave = 0;   // layers in the front scene, Moochie in its pocket, newest stage op, pick in flight
    function curMoo() { var m = set0().moochie; return m && m !== 'none' && MBY[m] ? m : null; }
    // preview Moochie: sits in the pocket while nothing is chosen yet (not selected, not in the price). ?zeige=<handle|name> wins
    // over the section setting, so an ad with Rainy can land on a hoodie with Rainy in the pocket.
    var SHOW = (function () {
      if (!PK) return null;
      var want = [], z = null;
      try { z = new URLSearchParams(location.search).get('zeige'); } catch (e) {}
      if (z) want.push(z);
      if (PK.showcase) want.push(PK.showcase);
      for (var i = 0; i < want.length; i++) {
        var w = slug(want[i]), hit = null;
        MOO.forEach(function (m) { if (!hit && (m.handle === want[i] || slug(m.handle) === w || slug(m.title) === w)) hit = m; });
        if (hit && hit.pk) return hit.handle;
      }
      return null;
    })();
    // the Moochie the stage should show: the chosen one, else the preview while undecided ('none' = empty pocket)
    function stageWant() { var m = set0().moochie; if (m && m !== 'none') return MBY[m] ? m : null; return m == null && SHOW && MBY[SHOW] ? SHOW : null; }
    function pkLayers(c, h) {
      var pc = PK && PK.colors[c], mo = h && MBY[h], pm = mo && mo.pk, big = isDesk();
      if (!pc || !pm || !pc.zip || !pc.front || !pm.body) return null;
      var L = { zip: big ? pc.zip2x || pc.zip : pc.zip, body: big ? pm.body2x || pm.body : pm.body, front: big ? pc.front2x || pc.front : pc.front,
        shadow: pm.shadow || '', paws: (big ? pm.paws2x : '') || pm.paws || '' };
      for (var k in L) if (L[k] && PKBAD[L[k]]) return null;
      return L;
    }
    function pkLoad(url) {
      if (!url || PKOK[url]) return Promise.resolve(true);
      if (!PKLOAD[url]) PKLOAD[url] = new Promise(function (res) {
        var i = new Image(); i.decoding = 'async';
        i.onload = function () { (i.decode ? i.decode().catch(function () {}) : Promise.resolve()).then(function () { PKOK[url] = true; res(true); }); };
        i.onerror = function () { PKBAD[url] = true; res(false); };
        i.src = url;
      });
      return PKLOAD[url];
    }
    function pkOK(L) { for (var k in L) if (L[k] && !PKOK[L[k]]) return false; return true; }
    // true once every layer is decoded; false on a load error or after ms
    function pkReady(L, ms) {
      if (!L) return Promise.resolve(false);
      var all = Promise.all(Object.keys(L).map(function (k) { return pkLoad(L[k]); })).then(function (r) { return r.every(Boolean); });
      return ms ? Promise.race([all, sleep(ms).then(function () { return false; })]) : all;
    }
    function pkStop(pk) { [pk].concat(qa('*', pk)).forEach(function (el) { if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); }); }); }
    function pkFill(pk, L) {
      pkStop(pk);
      qa('[data-l]', pk).forEach(function (im) {
        var u = L && L[im.getAttribute('data-l')];
        if (u) { if (im.getAttribute('src') !== u) im.setAttribute('src', u); im.hidden = false; }
        else { im.removeAttribute('src'); im.hidden = true; }
      });
      pk.hidden = !L;
    }
    function pkG() { return { back: q('.hh-pk__back', $.pkA), fx: q('.hh-pk__fx', $.pkA), open: qa('[data-l="zip"],[data-l="front"]', $.pkA) }; }
    function pkDock(h) {
      if ($.tag.getAnimations) $.tag.getAnimations().forEach(function (a) { a.cancel(); });
      $.dock.classList.add('is-pk'); $.tag.textContent = MBY[h].title; $.sticker.style.visibility = ''; $.dock.hidden = false;
    }
    function stageAlt() {
      var a = t('stage.alt', { c: stageColor });
      if (!stageMoo || !MBY[stageMoo]) return a;
      return a + ', ' + t(stageMoo === curMoo() ? 'stage.malt' : 'stage.mpeek', { m: MBY[stageMoo].title });   // the preview is not part of the order
    }
    function pkOpenOnly(L) { return L ? { zip: L.zip, front: L.front } : null; }   // open pocket without a Moochie
    function pkPut(L, h) { pkFill($.pkA, L); pkCur = L; stageMoo = L ? h : null; if (L) pkDock(h); else $.dock.classList.remove('is-pk'); $.imgA.alt = stageAlt(); updatePeek(); updateChip(); }
    // back to no pocket; the tag-only dock of the pocket mode is hidden (the sticker path shows its own dock)
    function pkClear() { var wasPk = $.dock.classList.contains('is-pk'); if (pkCur || stageMoo) pkPut(null); if (wasPk) { $.dock.classList.remove('is-pk'); $.dock.hidden = true; } }
    // the Moochie pops up out of the pocket (and the zip opens first if it was closed)
    function pkPop(opening, quiet) {
      var g = pkG();
      if (opening) g.open.forEach(function (el) { anim(el, [{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: EASE.out }); });
      var kf = [{ transform: 'translateY(5%) scale(.9)', opacity: 0 }, { transform: 'translateY(-1.2%) scale(1.03)', opacity: 1, offset: .6 }, { transform: 'none', opacity: 1 }];
      var o = { duration: 460, delay: opening ? 110 : 0, easing: EASE.out, fill: 'backwards' };
      anim(g.back, kf, o); anim(g.fx, kf, o);
      tagPop(o.delay + 260);
      anim($.box, [{ transform: 'translate(-50%,-50%)' }, { transform: 'translate(-50%,calc(-50% + 2px))' }, { transform: 'translate(-50%,-50%)' }], { duration: 180, delay: o.delay + 120 });
      if (!quiet) vibrate(8);
    }
    // name tag: pops in beside the pocket, stays ~2 s, fades (the chip at the top keeps the name)
    function tagPop(delay) {
      anim($.tag, [{ transform: 'translate(-50%,-50%) scale(.6) rotate(-12deg)', opacity: 0 }, { transform: 'translate(-50%,-50%) scale(1) rotate(0deg)', opacity: 1, offset: .12 },
        { transform: 'translate(-50%,-50%) scale(1) rotate(0deg)', opacity: 1, offset: .85 }, { transform: 'translate(-50%,calc(-50% - 6px)) scale(.96) rotate(0deg)', opacity: 0 }],
        { duration: 2600, delay: delay || 0, easing: EASE.out });
    }
    // the preview Moochie gets picked: it is already in the pocket, so it just hops
    function pkHop() {
      var g = pkG(), kf = [{ transform: 'none' }, { transform: 'translateY(-2.5%) scale(1.05)', offset: .4 }, { transform: 'none' }];
      anim(g.back, kf, { duration: 440, easing: EASE.spring }); anim(g.fx, kf, { duration: 440, easing: EASE.spring });
      tagPop(80);
      anim($.box, [{ transform: 'translate(-50%,-50%)' }, { transform: 'translate(-50%,calc(-50% + 2px))' }, { transform: 'translate(-50%,-50%)' }], { duration: 180, delay: 140 });
      vibrate(8);
    }
    // first view: once the photo is there the zip opens and the Moochie pops up and wiggles – the preview (nothing chosen
    // yet) or, v4, the Moochie that came with the ad link (?moochie=). A chosen one falls back to the sticker without layers.
    function pkIntro(h0) {
      var tok = ++pkTok, h = h0 || SHOW;
      var img = $.imgA, chosen = h === curMoo();
      var photo = img.complete && img.naturalWidth ? Promise.resolve() : new Promise(function (r) { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); });
      // v4b: a Moochie from the ad link must show quickly even on a slow connection: cap the waits, then the sticker
      // (fallback → showSticker → pkSettle puts it into the pocket as soon as the layers arrive)
      if (chosen) photo = Promise.race([photo, sleep(1200)]);
      var fallback = function () { if (h === curMoo() && stageWant() === h) showSticker(h, false); };
      pkReady(pkLayers(stageColor, h));
      photo.then(function () { return sleep(RM() ? 0 : 700); }).then(function () {
        if (tok !== pkTok || stageWant() !== h || stageMoo === h) return;
        var L = pkLayers(stageColor, h); if (!L) { fallback(); return; }
        pkReady(L, chosen ? 1500 : 5000).then(function (ok) {
          if (tok !== pkTok || stageWant() !== h || stageMoo === h) return;
          L = pkLayers(stageColor, h); if (!ok || !L || !pkOK(L)) { fallback(); return; }
          pkPut(L, h);
          track(h === curMoo() ? 'hh_cfg_intro' : 'hh_cfg_peek', { moochie: h, order: ORDER_ID });
          if (RM()) return;
          pkPop(true, true);
          var g = pkG();
          [g.back, g.fx].forEach(function (el) { anim(el, [0, -3, 2.5, -1.5, 0].map(function (d) { return { transform: 'rotate(' + d + 'deg)' }; }), { duration: 700, delay: 950, easing: EASE.out }); });
        });
      });
    }
    // step-2 card of the preview Moochie: "In der Tasche" while nothing is chosen and it sits in the pocket
    function updatePeek() {
      if (!$.mgrid) return;
      var on = set0().moochie == null && stageMoo && stageMoo === SHOW;
      qa('[data-peek]', $.mgrid).forEach(function (el) { el.hidden = !(on && el.getAttribute('data-peek') === stageMoo); });
    }
    // final stage state for Moochie h on the colour shown: pocket when its layers are ready; on a slow network the sticker
    // after 400 ms and the pocket as soon as the layers are there
    function pkSettle(h, tok, late) {
      if (tok !== pkTok || stageWant() !== h) return Promise.resolve();
      var L = pkLayers(stageColor, h);
      if (L && pkOK(L)) {
        pkPut(L, h);
        if (late) anim($.pkA, [{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: EASE.out });
        return Promise.resolve();
      }
      if (!L) { pkClear(); return h === curMoo() ? stickerShow(h, false) : Promise.resolve(); }
      if (stageMoo && stageMoo !== h && pkCur) {           // the previous Moochie leaves at once, the zip stays open
        pkCur = pkOpenOnly(pkCur); pkFill($.pkA, pkCur); stageMoo = null; $.dock.classList.remove('is-pk'); $.dock.hidden = true;
      }
      return pkReady(L, 400).then(function (ok) {
        if (tok !== pkTok || stageWant() !== h) return;
        if (ok) return pkSettle(h, tok, true);
        pkClear();
        pkReady(L, 15000).then(function (r) { if (r) pkUpgrade(h, tok); });
        return h === curMoo() ? stickerShow(h, false) : Promise.resolve();
      });
    }
    // layers that were late arrived: put the Moochie into the pocket now (only if nothing newer happened meanwhile)
    function pkUpgrade(h0, tok0) {
      var h = stageWant();
      if (!h || h !== h0 || tok0 !== pkTok || pkFly === pkTok || stageMoo === h || set0().color !== stageColor) return;
      var L = pkLayers(stageColor, h); if (!L || !pkOK(L)) return;
      pkPut(L, h);
      anim($.pkA, [{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: EASE.out });
    }
    // fade the name tag from wherever its pop animation is (in pocket mode its resting opacity is 0)
    function tagOut() { var op = +getComputedStyle($.tag).opacity || 0; if ($.tag.getAnimations) $.tag.getAnimations().forEach(function (a) { a.cancel(); }); if (op > 0.02) anim($.tag, [{ opacity: op }, { opacity: 0 }], { duration: 140, fill: 'forwards' }); }
    function pkWarm() {
      if (!PK) return;
      var big = isDesk(), urls = [];
      COLORS.forEach(function (c) { var pc = PK.colors[c.name]; if (pc) urls.push(big ? pc.zip2x : pc.zip, big ? pc.front2x : pc.front); });
      MOO.forEach(function (m) { var pm = m.pk; if (pm) urls.push(big ? pm.body2x : pm.body, pm.shadow, big ? pm.paws2x || pm.paws : pm.paws); });
      urls.forEach(function (u) { if (u && !PKOK[u]) { var i = new Image(); i.decoding = 'async'; i.src = u; } });
    }
    function pkTarget() {
      var b = $.box.getBoundingClientRect(), w = b.width * 0.24;
      return { left: b.left + b.width * 0.493 - w / 2, top: b.top + b.height * 0.53 - w / 2, width: w, height: w };
    }

    function renderStageInitial() {
      var c = set0().color;
      $.imgA.src = colorImg(c, true);
      stageColor = c; $.imgA.alt = stageAlt();
      updateDots();
      updateChip();
      var w = stageWant(), cm = curMoo();
      if (w && ((w === SHOW && !cm) || (cm && S.introChosen))) pkIntro(w); else if (w) showSticker(w, false);
      renderExtras(false);
    }
    function updateDots() {
      var idx = COLORS.findIndex(function (c) { return c.name === set0().color; });
      qa('i', $.dots).forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    }
    function updateChip() {
      var s0 = set0(), txt, cm = curMoo();
      if (ORDER_ID === 'm1' && !s0.size) {
        // v4 Moochie first: no "Größe?" before the size step; the preview is named as a preview, not as the choice
        if (s0.moochie == null) txt = stageMoo && stageMoo === SHOW && MBY[SHOW] ? t('stage.chipPeek', { m: MBY[SHOW].title }) : s0.color;
        else txt = cm ? t('stage.chipMC', { m: MBY[cm].title, c: s0.color }) : s0.color;
      }
      else if (!s0.size) txt = t('stage.nosize', { c: s0.color });
      else if (cm) txt = t('stage.chipM', { c: s0.color, s: s0.size, m: MBY[cm].title });
      else txt = t('stage.chip', { c: s0.color, s: s0.size });
      if ($.chip.textContent === txt) return;
      $.chip.innerHTML = '<span>' + esc(txt) + '</span>';
      anim($.chip.firstChild, [{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 220, easing: EASE.out });
    }
    function sweepTo(c, origin) {
      if (c === stageColor) return;
      stageColor = c;
      sweepAnims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); sweepAnims = [];
      var front = $.scA, back = $.scB;
      // back becomes the old picture (photo + pocket), front gets the new one
      $.imgB.src = $.imgA.src; $.imgB.alt = '';
      pkFill($.pkB, pkCur && stageMoo && stageMoo === stageWant() && pkFly !== pkTok ? pkCur : (pkCur && stageWant() ? pkOpenOnly(pkCur) : null));
      back.style.clipPath = ''; back.style.transform = ''; back.style.opacity = '';
      front.style.clipPath = 'circle(0% at 50% 50%)';
      var src = colorImg(c, true);
      var h = stageWant(), L = h ? pkLayers(c, h) : null;
      var pre = new Image(); pre.src = src;
      var go = function () {
        if (c !== stageColor) return;                       // a newer colour took over
        $.imgA.src = src;
        var hn = stageWant(), Ln = hn ? pkLayers(c, hn) : null;
        if (hn && pkFly === pkTok) {
          // a picked Moochie is still flying: only the new colour's open pocket now, the landing puts the Moochie in
          var O = Ln && pkOK(pkOpenOnly(Ln)) ? pkOpenOnly(Ln) : null; pkFill($.pkA, O); pkCur = O;
        } else if (hn && stageMoo === hn && pkCur && pkCur.body && Ln && pkCur.zip === Ln.zip) {
          // a newer operation already put this Moochie into this colour's pocket
        } else if (hn && Ln && pkOK(Ln)) {
          pkFill($.pkA, Ln); pkCur = Ln; if (stageMoo !== hn) { stageMoo = hn; pkDock(hn); }
        } else {
          pkFill($.pkA, null); pkCur = null;
          if (hn) {
            if (stageMoo || $.dock.classList.contains('is-pk')) { stageMoo = null; $.dock.classList.remove('is-pk'); $.dock.hidden = true; if (hn === curMoo()) stickerShow(hn, false); }
            if (Ln) { var tk = pkTok; pkReady(Ln, 15000).then(function (ok) { if (ok) pkUpgrade(hn, tk); }); }
          } else stageMoo = null;
        }
        $.imgA.alt = stageAlt(); updatePeek();
        var bx = $.box.getBoundingClientRect();
        var X = 50, Y = 100;
        if (origin && origin.x != null && bx.width) { X = Math.max(-20, Math.min(120, (origin.x - bx.left) / bx.width * 100)); Y = origin.y != null ? Math.max(-20, Math.min(130, (origin.y - bx.top) / bx.height * 100)) : 100; }
        var clean = function () { $.imgB.removeAttribute('src'); pkFill($.pkB, null); };
        if (RM()) {
          front.style.clipPath = '';
          var f = front.animate ? front.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 120 }) : null;
          done(f).then(function () { if (c === stageColor) clean(); });
          return;
        }
        var supportsClip = window.CSS && CSS.supports && CSS.supports('clip-path', 'circle(10% at 50% 50%)');
        if (supportsClip && front.animate) {
          var a1 = front.animate([{ clipPath: 'circle(0% at ' + X + '% ' + Y + '%)', transform: 'scale(1.035)' }, { clipPath: 'circle(150% at ' + X + '% ' + Y + '%)', transform: 'scale(1)' }],
            { duration: 560, easing: EASE.inout });
          var a2 = back.animate([{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(.985)', opacity: .6 }], { duration: 560, easing: EASE.inout });
          sweepAnims = [a1, a2];
          front.style.clipPath = '';
          a1.finished.then(function () { if (c === stageColor) clean(); }).catch(function () {});
        } else {
          front.style.clipPath = '';
          clean();
          anim(front, [{ opacity: 0, transform: 'scale(1.02)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 360, easing: EASE.out });
        }
        if (!$.dock.hidden && !$.dock.classList.contains('is-pk')) anim($.sticker, [{ transform: 'translate(-50%,-50%) rotate(-6deg)' }, { transform: 'translate(-50%,calc(-50% - 4px)) rotate(-6deg)' }, { transform: 'translate(-50%,-50%) rotate(-6deg)' }], { duration: 360, delay: 180, easing: EASE.spring });
      };
      // wait for the photo (and the pocket layers of the new colour) — at most 300 ms, 900 ms with a Moochie in the pocket
      var waits = pre.decode ? [pre.decode().catch(function () {})] : [];
      if (L) waits.push(pkReady(L));
      if (!waits.length) go(); else Promise.race([Promise.all(waits), sleep(L ? 900 : 300)]).then(go);
      updateDots();
    }
    // Moochie picked: into the pocket when this colour has layers for it, else the round sticker
    function showSticker(handle, animate, fromEl) {
      if (!MBY[handle]) return Promise.resolve();
      if (!pkLayers(stageColor || set0().color, handle)) { ++pkTok; pkClear(); return stickerShow(handle, animate, fromEl); }
      return pkShow(handle, animate, fromEl);
    }
    function pkShow(h, animate, fromEl) {
      if (stageMoo === h && pkCur && pkCur.body && pkFly !== pkTok && pkLeave !== pkTok) {   // already sitting in the pocket (the preview)
        ++pkTok; pkPut(pkCur, h);                           // pkFill also cancels any leftover fill animation
        if (animate && !RM()) { pkHop(); return sleep(260); }
        return Promise.resolve();
      }
      var tok = ++pkTok, mo = MBY[h];
      if (!animate || RM()) {
        pkSettle(h, tok, false);                            // layer loading must not hold back the price roll / scroll
        if (animate && stageMoo === h) anim($.pkA, [{ opacity: .3 }, { opacity: 1 }], { duration: 160 });
        return Promise.resolve();
      }
      pkFly = tok;
      pkReady(pkLayers(stageColor, h));                     // start loading during the flight
      var steps = [], g = pkG();
      // the Moochie in the pocket dives down / a visible sticker drops off
      if (stageMoo) {
        var dk = [{ transform: 'translateY(6%) scale(.94)', opacity: 0 }];   // implicit start = current state (no flash on a 2nd dive)
        steps.push(done(anim(g.back, dk, { duration: 220, easing: EASE.drop, fill: 'forwards' })));
        anim(g.fx, dk, { duration: 180, easing: EASE.drop, fill: 'forwards' });
        tagOut();
      } else if (!$.dock.hidden && !$.dock.classList.contains('is-pk')) {
        var sd = anim($.sticker, [{ transform: 'translate(-50%,-50%) rotate(-6deg)', opacity: 1 }, { transform: 'translate(-50%,calc(-50% + 24px)) rotate(18deg) scale(.7)', opacity: 0 }], { duration: 240, easing: EASE.drop, fill: 'forwards' });
        anim($.tag, [{ opacity: 1 }, { opacity: 0 }], { duration: 140, fill: 'forwards' });
        steps.push(done(sd).then(function () { if (sd) sd.cancel(); if (tok === pkTok) $.sticker.style.visibility = 'hidden'; }));
      }
      var land = function () {
        if (tok !== pkTok || stageWant() !== h) { if (pkFly === tok) pkFly = 0; return; }
        var L = pkLayers(stageColor, h);
        var fin = function (ok) {
          if (pkFly === tok) pkFly = 0;
          if (tok !== pkTok || stageWant() !== h) return;
          L = pkLayers(stageColor, h);
          [$.tag, $.sticker].forEach(function (el) { if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); }); });
          if (!ok || !L || !pkOK(L)) {                       // layers missing: sticker instead
            pkClear(); $.sticker.style.visibility = '';
            if (L) pkReady(L, 15000).then(function (r) { if (r) pkUpgrade(h, tok); });
            return stickerShow(h, true);
          }
          var zo = pkCur ? +getComputedStyle(pkG().open[0]).opacity : 0;
          var opening = !pkCur || !(zo > 0.5);              // closed, or an interrupted close left it shut
          pkPut(L, h);
          pkPop(opening);
        };
        if (L && pkOK(L)) return fin(true);
        return pkReady(L, 1500).then(fin);
      };
      var srcImg = fromEl && q('img', fromEl);
      var stageR = $.stage.getBoundingClientRect();
      var visible = stageR.bottom > 0 && stageR.top < window.innerHeight;
      if (!srcImg || !visible) return Promise.all(steps).then(function () { land(); });
      var A = srcImg.getBoundingClientRect(), B = pkTarget();
      var clone = document.createElement('img');
      clone.src = mo.img; clone.alt = ''; clone.setAttribute('aria-hidden', 'true');
      clone.style.cssText = 'position:fixed;left:' + B.left + 'px;top:' + B.top + 'px;width:' + B.width + 'px;height:' + B.height + 'px;border-radius:50%;object-fit:cover;z-index:2147483002;pointer-events:none;border:3px solid #fff;box-shadow:0 10px 24px rgba(192,85,128,.35);margin:0';
      document.body.appendChild(clone);
      var dx0 = (A.left + A.width / 2) - (B.left + B.width / 2), dy0 = (A.top + A.height / 2) - (B.top + B.height / 2);
      var midY = Math.min(dy0, 0) - 60;
      var s0 = A.width / B.width;
      // flies over, then dives into the pocket
      var fl = clone.animate([
        { transform: 'translate(' + dx0 + 'px,' + dy0 + 'px) scale(' + s0 + ') rotate(-12deg)', borderRadius: '30%', opacity: 1, easing: EASE.out },
        { offset: .55, transform: 'translate(' + (dx0 * .45) + 'px,' + midY + 'px) scale(1.08) rotate(8deg)', borderRadius: '50%', opacity: 1, easing: EASE.fall },
        { offset: .82, transform: 'translate(0,0) scale(.82) rotate(-4deg)', borderRadius: '50%', opacity: 1, easing: EASE.drop },
        { transform: 'translate(0,' + (B.height * .28) + 'px) scale(.5) rotate(0deg)', borderRadius: '50%', opacity: 0 }
      ], { duration: 700, fill: 'forwards' });
      return Promise.all([done(fl)].concat(steps)).then(function () { clone.remove(); land(); });   // resolves on landing; layers may follow
    }
    function stickerTarget() {
      var was = $.dock.hidden; $.dock.hidden = false;
      var r = $.sticker.getBoundingClientRect();
      if (was) $.dock.hidden = true;
      return r;
    }
    function stickerShow(handle, animate, fromEl) {
      var mo = MBY[handle]; if (!mo) return Promise.resolve();
      $.dock.classList.remove('is-pk');
      var prevVisible = !$.dock.hidden;
      var stok = pkTok;
      var land = function () {
        if (stok !== pkTok) return;
        [$.tag, $.sticker].forEach(function (el) { if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); }); });
        $.stickerImg.src = mo.img; $.stickerImg.alt = t('stage.malt', { m: mo.title });
        $.tag.textContent = mo.title;
        $.dock.hidden = false; $.sticker.style.visibility = '';
        if (!animate) return;
        anim($.sticker, [
          { transform: 'translate(-50%,-50%) rotate(-6deg) scale(1.14,.86)' }, { transform: 'translate(-50%,-50%) rotate(-6deg) scale(.96,1.04)' }, { transform: 'translate(-50%,-50%) rotate(-6deg) scale(1)' }
        ], { duration: 320, easing: EASE.spring });
        anim($.ring, [{ transform: 'translate(-50%,-50%) scale(.6)', opacity: .55 }, { transform: 'translate(-50%,-50%) scale(1.7)', opacity: 0 }], { duration: 480, easing: EASE.out });
        anim($.box, [{ transform: 'translate(-50%,-50%)' }, { transform: 'translate(-50%,calc(-50% + 2px))' }, { transform: 'translate(-50%,-50%)' }], { duration: 180 });
        anim($.tag, [{ transform: 'translate(-50%,-50%) scale(.6) rotate(-12deg)', opacity: 0 }, { transform: 'translate(-50%,-50%) scale(1) rotate(0deg)', opacity: 1 }], { duration: 300, delay: 60, easing: EASE.spring, fill: 'backwards' });
        vibrate(8);
      };
      if (!animate || RM()) {
        if (animate && RM()) { land(); anim($.dock, [{ opacity: 0 }, { opacity: 1 }], { duration: 120 }); }
        else land();
        return Promise.resolve();
      }
      var srcImg = fromEl && q('img', fromEl);
      var stageR = $.stage.getBoundingClientRect();
      var visible = stageR.bottom > 0 && stageR.top < window.innerHeight;
      var flip = Promise.resolve();
      if (prevVisible) {
        var fo = anim($.sticker, [{ transform: 'translate(-50%,-50%) rotate(-6deg) rotateY(0deg)' }, { transform: 'translate(-50%,-50%) rotate(-6deg) rotateY(90deg)' }], { duration: 160, easing: 'ease-in' });
        flip = done(fo);
      }
      if (!srcImg || !visible) return flip.then(function () { land(); });
      var A = srcImg.getBoundingClientRect(), B = stickerTarget();
      var clone = document.createElement('img');
      clone.src = mo.img; clone.alt = ''; clone.setAttribute('aria-hidden', 'true');
      clone.style.cssText = 'position:fixed;left:' + B.left + 'px;top:' + B.top + 'px;width:' + B.width + 'px;height:' + B.height + 'px;border-radius:50%;object-fit:cover;z-index:2147483002;pointer-events:none;border:3px solid #fff;box-shadow:0 10px 24px rgba(192,85,128,.35);margin:0';
      document.body.appendChild(clone);
      var dx0 = (A.left + A.width / 2) - (B.left + B.width / 2), dy0 = (A.top + A.height / 2) - (B.top + B.height / 2);
      var midY = Math.min(dy0, 0) - 60;
      var s0 = A.width / B.width;
      $.sticker.style.visibility = 'hidden';
      if (prevVisible) $.dock.hidden = false;
      var fl = clone.animate([
        { transform: 'translate(' + dx0 + 'px,' + dy0 + 'px) scale(' + s0 + ') rotate(-12deg)', borderRadius: '30%', easing: EASE.out },
        { offset: .55, transform: 'translate(' + (dx0 * .45) + 'px,' + midY + 'px) scale(1.08) rotate(8deg)', borderRadius: '50%', easing: EASE.fall },
        { transform: 'translate(0,0) scale(1) rotate(-6deg)', borderRadius: '50%' }
      ], { duration: 620, fill: 'forwards' });
      return Promise.all([done(fl), flip]).then(function () { clone.remove(); land(); });
    }
    function dropSticker() {
      var tok = ++pkTok;
      pkLeave = tok;                                        // a re-pick during the dive takes the normal pop path
      if (stageMoo || pkCur) {
        // the Moochie dives into the pocket, then the zip closes
        var g = pkG(), kf = [{ transform: 'translateY(6%) scale(.92)', opacity: 0 }];
        var a0 = anim(g.back, kf, { duration: 240, easing: EASE.drop, fill: 'forwards' });
        anim(g.fx, kf, { duration: 200, easing: EASE.drop, fill: 'forwards' });
        tagOut();
        done(a0).then(function () {
          if (tok !== pkTok) return;
          var z = g.open.map(function (el) { return anim(el, [{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: EASE.out, fill: 'forwards' }); });
          return done(z[0]).then(function () {
            if (tok !== pkTok) return;
            pkPut(null); $.dock.hidden = true;
            if ($.tag.getAnimations) $.tag.getAnimations().forEach(function (x) { x.cancel(); });
          });
        });
        return;
      }
      if ($.dock.hidden) return;
      var a = anim($.sticker, [{ transform: 'translate(-50%,-50%) rotate(-6deg)', opacity: 1 }, { transform: 'translate(-50%,calc(-50% + 24px)) rotate(18deg) scale(.7)', opacity: 0 }], { duration: 260, easing: EASE.drop });
      anim($.tag, [{ opacity: 1 }, { opacity: 0 }], { duration: 140 });
      done(a).then(function () { if (set0().moochie === 'none' || !set0().moochie) $.dock.hidden = true; });
    }
    function renderExtras(animate) {
      var n = S.sets.length;
      if (n <= 1) { $.extras.hidden = true; $.extras.innerHTML = ''; return; }
      $.extras.hidden = false;
      $.extras.setAttribute('aria-label', t('stage.extra', { n: n }));
      var html = '';
      for (var i = n - 1; i >= 1; i--) {
        var s = S.sets[i], c = CBY[s.color] || COLORS[0], k = i - 1;
        var mo = s.moochie && s.moochie !== 'none' ? MBY[s.moochie] : null;
        html += '<span class="hh-xcard" style="transform:translate(' + (-k * 10) + 'px,' + (k * 8) + 'px) rotate(' + (k ? -3 : 4) + 'deg)"><img src="' + esc(c.thumb) + '" alt="">' +
          (mo ? '<span class="hh-xcard__m"><img src="' + esc(mo.img) + '" alt=""></span>' : '') + '</span>';
      }
      html += '<span class="hh-xbadge">×' + n + '</span>';
      $.extras.innerHTML = html;
      if (animate) anim($.extras, [{ transform: 'scale(.4) rotate(-20deg)', opacity: 0 }, { transform: 'scale(1.1) rotate(4deg)', opacity: 1, offset: .7 }, { transform: 'none', opacity: 1 }], { duration: 520, easing: EASE.out });
    }

    /* ── bar ── */
    var lastTotal = null, lastCta = '';
    function renderBar(opts) {
      opts = opts || {};
      var m = model(S.sets), s0 = set0();
      // price
      if (!opts.holdPrice) rollTo($.priceNow, fmt(m.total), lastTotal != null && m.total < lastTotal ? -1 : 1, opts.noRoll || lastTotal == null);
      if (!opts.holdPrice && lastTotal != null && lastTotal !== m.total) { announceTotal(fmt(m.total)); anim($.priceNow, [{ boxShadow: '0 0 0 0 rgba(240,200,232,0)' }, { boxShadow: '0 0 0 8px rgba(240,200,232,.8)' }, { boxShadow: '0 0 0 0 rgba(240,200,232,0)' }], { duration: 480 }); }
      if (!opts.holdPrice) { lastTotal = m.total; $.priceWas.textContent = m.compare > m.total ? fmt(m.compare) : ''; }
      var label = '';
      if (m.free >= 3) label = t('bar.free3'); else if (m.free >= 2) label = t('bar.free2');
      else if (m.half > 0) label = t('bar.half', { p: CFG.mpct }); else if (m.preorder) label = t('bar.pre');
      $.barLabel.textContent = label;
      // CTA
      var st = ctaState();
      var fin = st.fin;
      // checkout moment (v3: "Zur Kasse" is the only buying action): total + the pre-order date above one full-width button
      $.bar.classList.toggle('is-final', !!fin);
      $.barTotal.hidden = !fin;
      // a pre-order buyer must see the date before "Zur Kasse"; savings live in the summary card
      if (fin) $.barTotal.innerHTML = '<span>' + esc(t('bar.total')) + ' <b>' + fmt(m.total) + '</b>' + (m.compare > m.total ? '<s>' + fmt(m.compare) + '</s>' : '') + '</span>' +
        (m.preorder && CFG.shipShort ? '<span class="hh-bar__ship">' + ICON.cal + esc(t('bar.ship', { date: CFG.shipShort })) + '</span>' : '<span>' + esc(t('sum.vat')) + '</span>');
      var cta = $.barCta, key = st.kind + '|' + st.label;
      cta.className = 'hh-btn hh-bar__cta ' + (st.kind === 'embrace' ? 'hh-btn--embrace' : 'hh-btn--hearth');
      cta.setAttribute('data-act', st.act || '');
      if (st.mode) cta.setAttribute('data-mode', st.mode); else cta.removeAttribute('data-mode');
      if (st.i != null) cta.setAttribute('data-i', st.i); else cta.removeAttribute('data-i');
      if (st.step != null) cta.setAttribute('data-step', st.step); else cta.removeAttribute('data-step');
      cta.innerHTML = st.html || (esc(st.label) + (st.arrow ? ARR : ''));
      // v4: narrow phones with a long price (CHF + struck-through compare price): first the short label, then the bar drops
      // its struck-through price (the saving stays in "inkl. Moochie −50 %" and the summary) – never a cut-off button label
      $.bar.classList.remove('is-tight');
      if (!st.fin && cta.scrollWidth > cta.clientWidth + 1) {
        if (st.short) cta.innerHTML = esc(st.short) + (st.arrow ? ARR : '');
        if (cta.scrollWidth > cta.clientWidth + 1) $.bar.classList.add('is-tight');
      }
      if (st.busy) cta.setAttribute('aria-busy', 'true'); else cta.removeAttribute('aria-busy');
      if (lastCta && key !== lastCta && st.kind === 'embrace' && lastCta.indexOf('hearth') === 0 && !RM()) {
        cta.classList.remove('hh-pulse'); void cta.offsetWidth; cta.classList.add('hh-pulse');
      }
      lastCta = key;
      requestAnimationFrame(function () { try { document.body.style.setProperty('--hh-bar-space', ($.bar.offsetHeight || 78) + 'px'); } catch (e) {} });
      // errors
      if (S.error) {
        $.err.innerHTML = '<div class="hh-err"><span>' + esc(S.error.message) + '</span>' + (S.error.retry ? '<button type="button" class="hh-tbtn" data-act="retry">' + esc(t('err.retry')) + '</button>' : '') + '</div>';
      } else $.err.innerHTML = '';
      tuckBar();
      renderActions();
    }
    // the inline "Zur Kasse" in the summary mirrors the submit state of the bar
    function renderActions() {
      if (!$.actCheckout || !$.s3.contains($.actCheckout)) return;
      var busy = S.submit === 'adding';
      $.actCheckout.innerHTML = busy ? '<span class="hh-spin"></span> ' + esc(t('cta.adding')) : (S.submit === 'added' ? esc(t('cta.toCheckout')) : esc(cashLabel()) + ARR);
      if (busy || S.submit === 'added') $.actCheckout.setAttribute('aria-busy', 'true'); else $.actCheckout.removeAttribute('aria-busy');
    }
    // the buying label: "Zur Kasse" (direct checkout, default) or "In den Warenkorb" (drawer mode)
    function cashLabel() { return t(CFG.mode === 'drawer' ? 'cta.cart' : 'cta.checkout'); }
    // v4: by kind, so the same rules hold in both step orders (hoodie_first gives exactly the v3 labels)
    function ctaState() {
      var s0 = set0(), miss = firstMissingKind();
      if (S.submit === 'adding') return { kind: 'embrace', fin: S.step === 3 || S.below, html: '<span class="hh-spin"></span> ' + esc(t('cta.adding')), busy: true, label: 'adding' };
      if (S.submit === 'added') return { kind: 'embrace', fin: true, label: t('cta.toCheckout'), busy: true };
      // scrolled past the configurator (reviews, video, science = the persuasion zone): keep the forward action
      if (S.below && !allDone()) {
        if (miss === 'hoodie') return { kind: 'hearth', label: t(s0.size ? 'cta.sizeOther' : 'cta.sizeUp'), act: 'route' };
        if (miss === 'moochie') return posOf('moochie') === 1 ? { kind: 'hearth', label: t('cta.moochieUp'), act: 'route' }
          : { kind: 'embrace', label: t('cta.next1bar'), act: 'goto', step: posOf('moochie'), arrow: true };
        return { kind: 'embrace', label: t('cta.next2'), act: 'goto', step: 3, arrow: true };
      }
      var ready = allDone();
      if (S.step === 3 || (S.below && ready)) {
        if (miss === 'hoodie') return { kind: 'hearth', label: s0.size ? t('cta.sizeOther') : t('cta.size'), act: 'route' };
        if (miss === 'moochie') return { kind: 'hearth', label: t('cta.moochie'), act: 'route' };
        var inc = firstIncompleteExtra();
        if (inc > 0) return { kind: 'hearth', label: t('cta.finish', { n: inc + 1 }), act: 'set-edit', i: inc };
        return { kind: 'embrace', fin: true, label: cashLabel(), act: 'submit', mode: CFG.mode, arrow: true };
      }
      var k = kindAt(S.step);
      // an EARLIER step is still open (e.g. a size that sold out meanwhile): route back there first
      if (miss && posOf(miss) < S.step) return miss === 'hoodie' ? { kind: 'hearth', label: t(s0.size ? 'cta.sizeOther' : 'cta.sizeUp'), act: 'route' }
        : { kind: 'hearth', label: t('cta.moochieUp'), act: 'route' };
      if (k === 'hoodie') {
        if (!s0.size) return { kind: 'hearth', label: t(isDesk() ? 'cta.sizeUp' : 'cta.size'), act: 'route' };
        if (!resolve(s0.color, s0.size)) return { kind: 'hearth', label: t('cta.sizeOther'), act: 'route' };
      } else if (k === 'moochie') {
        if (s0.moochie === null) return { kind: 'hearth', label: t('cta.moochie'), act: 'route' };
      } else return { kind: 'hearth', label: '', act: '' };
      if (skipToSum()) return { kind: 'embrace', label: t('cta.back'), act: 'goto3', arrow: true };
      var nk = NEXT_BAR[kindAt(S.step + 1)];
      return { kind: 'embrace', label: t(nk), short: nk === 'cta.nextHbar' ? t('cta.nextHbarS') : null, act: 'next', arrow: true };
    }
    function rollTo(host, text, dir, instant) {
      var el = q('.hh-roll', host);
      var old = el.getAttribute('data-v') || el.textContent;
      if (old === text) return;
      el.setAttribute('data-v', text);
      clearTimeout(el.__t);
      if (instant || RM() || !el.animate) { el.textContent = text; return; }
      var w0 = host.getBoundingClientRect().width;
      var n = Math.max(old.length, text.length), a = old.padStart(n, ' '), b = text.padStart(n, ' ');
      el.innerHTML = '';
      var slots = [];
      for (var i = 0; i < n; i++) {
        var slot = document.createElement('span');
        if (a[i] === b[i]) { slot.textContent = b[i] === ' ' ? '' : b[i]; el.appendChild(slot); continue; }
        slot.style.cssText = 'display:inline-block;position:relative;overflow:hidden;vertical-align:top';
        var nw = document.createElement('span'); nw.style.display = 'inline-block'; nw.textContent = b[i] === ' ' ? '' : b[i];
        slot.appendChild(nw);
        var od = null;
        if (a[i] !== ' ') { od = document.createElement('span'); od.style.cssText = 'position:absolute;left:0;top:0'; od.textContent = a[i]; slot.appendChild(od); }
        el.appendChild(slot); slots.push({ nw: nw, od: od });
      }
      var w1 = host.getBoundingClientRect().width;
      if (Math.abs(w1 - w0) > 1) anim(host, [{ width: w0 + 'px' }, { width: w1 + 'px' }], { duration: 220, easing: EASE.out });
      var d = dir >= 0 ? 1 : -1;
      slots.reverse().forEach(function (sl, k) {
        var opt = { duration: 320, delay: k * 30, easing: EASE.out, fill: 'both' };
        anim(sl.nw, [{ transform: 'translateY(' + (100 * d) + '%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], opt);
        if (sl.od) anim(sl.od, [{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(' + (-100 * d) + '%)', opacity: 0 }], opt);
      });
      el.__t = setTimeout(function () { el.textContent = text; }, 380 + slots.length * 30);
    }
    var liveT;
    function announceTotal(p) { clearTimeout(liveT); liveT = setTimeout(function () { $.live.textContent = t('sr.total', { p: p }); }, 600); }
    function announce(msg) { $.live.textContent = ''; setTimeout(function () { $.live.textContent = msg; }, 30); }

    /* ── navigation between steps ── */
    // v4b: a position is reachable once every decision before it is made (back on the Moochie step with the hoodie
    // already chosen, the summary is one tap away – no dead dot/row, no detour through the finished step)
    function canGoto(n) {
      if (n <= S.maxStep) return true;
      for (var i = 1; i < n; i++) if (!kindDone(kindAt(i))) return false;
      return true;
    }
    // v4b: everything decided and a later step already visited: "Weiter" goes straight to the summary
    function skipToSum() { return S.maxStep >= 3 || (!firstMissingKind() && S.maxStep > S.step); }
    function stickyOffset() {
      var top = parseFloat(getComputedStyle(root).getPropertyValue('--hh-top-px')) || headerH();
      if (isDesk()) return top + 52;
      var c = parseFloat(getComputedStyle(root).getPropertyValue('--stage-c')) || 150;
      return top + c + 40 + 18;
    }
    function headerH() {
      var v = getComputedStyle(root).getPropertyValue('--hh-top').trim();
      if (/px$/.test(v)) return parseFloat(v);
      var d = document.createElement('div'); d.style.cssText = 'position:absolute;visibility:hidden;height:var(--hh-top)'; root.appendChild(d);
      var h = d.getBoundingClientRect().height; d.remove(); return h;
    }
    // own eased scroll (predictable in in-app webviews, cancellable by the user's finger/wheel)
    var scrollAnim = null, lastUserInput = 0;
    ['touchstart', 'wheel', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function () { lastUserInput = Date.now(); }, { passive: true }); });
    function smoothScrollTo(y, ms) {
      y = Math.max(0, Math.round(y));
      if (scrollAnim) scrollAnim.cancel();
      if (RM() || !window.requestAnimationFrame) { window.scrollTo(0, y); return; }
      var y0 = window.pageYOffset, dy = y - y0, t0 = null, dur = ms || Math.min(700, 280 + Math.abs(dy) * 0.35), alive = true;
      if (Math.abs(dy) < 2) return;
      var stop = function () { alive = false; off(); };
      var off = function () { window.removeEventListener('wheel', stop); window.removeEventListener('touchstart', stop); };
      window.addEventListener('wheel', stop, { passive: true }); window.addEventListener('touchstart', stop, { passive: true });
      scrollAnim = { cancel: stop };
      (function step(ts) {
        if (!alive) return;
        if (t0 == null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        window.scrollTo(0, y0 + dy * e);
        if (p < 1) requestAnimationFrame(step); else { off(); scrollAnim = null; }
      })(performance.now());
    }
    function scrollToEl(el, smooth) {
      if (!el) return;
      var y = el.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      if (smooth) smoothScrollTo(y); else window.scrollTo(0, Math.max(0, y));
      // settle: layout above may still be moving (stage compaction, step collapse) – correct once it has
      clearTimeout(el.__fix);
      var startedAt = Date.now();
      el.__fix = setTimeout(function () {
        if (scrollAnim || lastUserInput > startedAt) return;
        var y2 = el.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
        if (Math.abs(y2 - window.pageYOffset) > 4) smoothScrollTo(y2, 220);
      }, RM() ? 50 : 760);
    }
    var anchorT;
    function freezeAnchor(ms) {
      var de = document.documentElement, b = document.body;
      de.style.overflowAnchor = 'none'; if (b) b.style.overflowAnchor = 'none';
      clearTimeout(anchorT);
      anchorT = setTimeout(function () { de.style.overflowAnchor = ''; if (b) b.style.overflowAnchor = ''; }, ms || 700);
    }
    function gotoStep(n, opts) {
      opts = opts || {};
      freezeAnchor(900);
      if (!opts.force && !canGoto(n)) { routeMissing(); return; }
      var prev = S.step;
      var kn = kindAt(n);
      if (n === prev && !opts.force) { scrollToEl(q('#' + HEAD[kn], root), true); return; }
      // steps above the target collapse instantly so the scroll target does not move under the user
      for (var k = 1; k < n; k++) { $['step' + k].classList.add('no-trans'); }
      S.step = n; S.maxStep = Math.max(S.maxStep, n);
      // v4: render by kind (the hoodie panel also refreshes its "Weiter"/"Zur Übersicht" label and sub-line)
      if (kn === 'sum') renderStep3();
      else if (kn === 'moochie') renderStep2();
      else updateStep1(true);
      renderRows(); renderProgress();
      void root.offsetHeight; // commit the instant collapse before transitions are re-enabled
      requestAnimationFrame(function () {
        for (var k = 1; k <= 3; k++) $['step' + k].classList.remove('no-trans');
      });
      var head = q('#' + HEAD[kn], root);
      if (!opts.noScroll) setTimeout(function () { scrollToEl(head, true); }, 30);
      if (head && !opts.noFocus) setTimeout(function () { try { head.focus({ preventScroll: true }); } catch (e) {} }, 60);
      // fade up children
      if (!opts.noAnim) {
        var pad = $[PAD[kn]];
        qa(':scope > *', pad).slice(0, 6).forEach(function (ch, i) {
          anim(ch, [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 360, delay: 120 + i * 60, easing: EASE.out, fill: 'backwards' });
        });
      }
      if (prev < n) track('hh_cfg_step_complete', { step: prev, kind: kindAt(prev), order: ORDER_ID });
      renderBar(); persist();
      onScroll(); setTimeout(onScroll, 520);
      if (n === 3 && allDone() && !S.celebrated) setTimeout(celebrate, 450);
    }
    // v4: the FIRST open decision in the step order (Moochie first: Moochie, then size). The step opens without its own
    // heading scroll, so the late heading correction can never pull the view back up from the sizes / the Moochie cards.
    function routeMissing() {
      var miss = firstMissingKind();
      if (miss === 'hoodie') { routeHoodie(); return; }
      if (miss === 'moochie') { routeMoochie(); return; }
      var inc = firstIncompleteExtra();
      if (inc > 0) openSetSheet(inc);
    }
    function routeHoodie() {
      var p = posOf('hoodie'), here = S.step === p;
      if (!here) gotoStep(p, { force: true, noFocus: true, noScroll: true });
      setTimeout(function () {
        scrollToEl($.sizeK, true);
        var pills = $.sizes;
        if (RM()) { pills.classList.add('hh-flash-outline'); setTimeout(function () { pills.classList.remove('hh-flash-outline'); }, 1000); }
        else { pills.classList.remove('hh-shake'); void pills.offsetWidth; pills.classList.add('hh-shake'); }
        $.sizeK.classList.add('is-flash'); setTimeout(function () { $.sizeK.classList.remove('is-flash'); }, 600);
        announce(t('size.req'));
        var first = q('.hh-size:not(.is-sold)', pills); if (first) try { first.focus({ preventScroll: true }); } catch (e) {}
      }, here ? 0 : 80);
    }
    function routeMoochie() {
      var p = posOf('moochie');
      if (S.step !== p) gotoStep(p, { force: true, noFocus: true, noScroll: true });
      setTimeout(function () {
        scrollToEl($.mgrid, true);
        qa('.hh-mcard', $.mgrid).forEach(function (c, i) { anim(c, [{ transform: 'none' }, { transform: 'translateY(-6px)' }, { transform: 'none' }], { duration: 300, delay: i * 50, easing: EASE.out }); });
        announce(t('s2.req'));
        var fc = q('.hh-mcard[aria-pressed="true"]', $.mgrid) || q('.hh-mcard', $.mgrid);   // v4b: keyboard / screen reader land on the cards
        if (fc) try { fc.focus({ preventScroll: true }); } catch (e) {}
      }, 120);
    }

    /* ── compact stage (mobile) ── */
    function setCompact(on) {
      if (isDesk()) on = false;
      if (S.compact === on) return;
      S.compact = on; root.classList.toggle('is-compact', on);
    }
    var scrollRaf = 0;
    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = 0;
        if (!isDesk()) {
          // v2 review: the stage height follows the finger 1:1 (no snap, no blank band). The margin gives back exactly what the
          // stage lost, so the layout below never moves and the steps stay glued to the progress bar.
          if (!S.stageH) { S.stageH = $.stage.offsetHeight; S.stageC = parseFloat(getComputedStyle(root).getPropertyValue('--stage-c')) || 150; }
          var H = S.stageH, C = S.stageC;
          var dd = Math.max(0, (parseFloat(getComputedStyle($.stagewrap).top) || 0) - $.grid.getBoundingClientRect().top);
          var h = Math.max(C, H - dd);
          if (h !== S.stageCur) { S.stageCur = h; $.stage.style.height = h + 'px'; $.stagewrap.style.marginBottom = (H - h) + 'px'; }
          setCompact(h <= C + 0.5);
        } else if (S.stageCur != null) { S.stageCur = null; $.stage.style.height = ''; $.stagewrap.style.marginBottom = ''; }
        var gr = $.grid.getBoundingClientRect();
        var below = gr.bottom < window.innerHeight * 0.55;
        if (below !== S.below) { S.below = below; renderBar(); }
      });
    }

    /* ───────────────────────── actions ───────────────────────── */
    function selectColor(c, origin, source) {
      var s0 = set0();
      if (!CBY[c]) return;
      touch();
      var changed = s0.color !== c;
      s0.color = c;
      $.colorV.textContent = c;
      if (changed) anim($.colorV, [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 220, easing: EASE.out });
      sweepTo(c, origin);
      updateStep1();
      updateChip();
      if (!colorAvail(c)) track('hh_cfg_soldout_tap', { color: c });
      if (changed) { vibrate(8); track('hh_cfg_color_select', { color: c, source: source || 'card' }); }
      var btn = q('.hh-ccard[data-color="' + cssEsc(c) + '"]', $.colors);
      if (btn && changed) pressPop(btn);
      afterChange();
    }
    function selectSize(z) {
      var s0 = set0();
      touch();
      if (!resolve(s0.color, z)) {
        s0.size = z; // keep for the message, it is marked as sold out
        updateStep1(); updateChip();
        track('hh_cfg_soldout_tap', { color: s0.color, size: z });
        afterChange();
        return;
      }
      var first = !S.everStep1Done;
      s0.size = z;
      updateStep1(); updateChip();
      vibrate(8);
      track('hh_cfg_size_select', { size: z, color: s0.color });
      if (first && hoodieDone()) {
        S.everStep1Done = true;
        setTimeout(function () {
          if (kindAt(S.step) !== 'hoodie' || $.next1.hidden) return;
          var r = $.next1.getBoundingClientRect(), cover = bottomCover();
          if (r.bottom > window.innerHeight - cover) smoothScrollTo(window.pageYOffset + r.bottom - (window.innerHeight - cover) + 16);
        }, 200);
      }
      afterChange();
    }
    // height of what covers the bottom of the screen: the fixed bar (mobile) + a theme-preview bar
    function bottomCover() {
      var pb = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hh-pbar')) || 0;
      return (isDesk() ? 0 : ($.bar.offsetHeight || 80)) + pb;
    }
    function revealNext(btn) {
      setTimeout(function () {
        if (!btn || btn.hidden) return;
        var r = btn.getBoundingClientRect(), cover = bottomCover();
        if (r.bottom > window.innerHeight - cover) smoothScrollTo(window.pageYOffset + r.bottom - (window.innerHeight - cover) + 16);
      }, 240);
    }
    function selectMoochie(h, btn) {
      var s0 = set0();
      var firstPick = s0.moochie === null;
      touch();
      if (s0.moochie === h) { pressPop(btn); return; }
      s0.moochie = h; clearError();
      updateStep2(); updateChip();
      if (btn) { pressPop(btn); anim(q('img', btn), [{ transform: 'rotate(-4deg) scale(1.04)' }, { transform: 'none' }], { duration: 360, easing: EASE.spring }); }
      track('hh_cfg_moochie_select', { handle: h });
      var p = showSticker(h, true, btn);
      renderRows(); renderProgress();
      persist(); syncUrl();
      if (S.maxStep >= 3) renderStep3();
      // CTA updates now, the price rolls when the Moochie lands (cause, then effect)
      renderBar({ holdPrice: !RM() });
      // no auto-advance: the Moochie lands in the pocket, then "Weiter …" slides into view (they can still compare)
      p.then(function () { renderBar(); if (firstPick && S.step === posOf('moochie')) revealNext($.next2); });
    }
    function skipMoochie() {
      touch();
      var s0 = set0(), firstPick = s0.moochie === null;
      s0.moochie = 'none';
      updateStep2(); updateChip();
      dropSticker();
      track('hh_cfg_moochie_select', { handle: 'none' });
      afterChange();
      if (S.maxStep >= 3) renderStep3();
      if (firstPick && S.step === posOf('moochie')) revealNext($.next2);
    }
    function clearError() { if (S.error && S.submit !== 'adding') S.error = null; }
    function afterChange() {
      clearError();
      freezeAnchor(500);
      renderRows(); renderProgress(); renderBar(); persist(); syncUrl();
      if (S.maxStep >= 3 && S.step !== 3) renderStep3();
    }
    function pressPop(btn) { if (btn) anim(btn, [{ transform: 'scale(.97)' }, { transform: 'scale(1.02)' }, { transform: 'scale(1)' }], { duration: 360, easing: EASE.spring }); }
    function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
    function cycleColor(dir, source) {
      var idx = COLORS.findIndex(function (c) { return c.name === set0().color; });
      var n = COLORS.length, next = COLORS[(idx + dir + n) % n].name;
      var r = $.stage.getBoundingClientRect();
      selectColor(next, { x: dir > 0 ? r.right : r.left, y: r.top + r.height / 2 }, source || 'swipe');
    }

    /* ── persistence / URL ── */
    function persist() { ss('hh-cfg-v1', { sets: S.sets, extras: S.extras, step: S.step, maxStep: S.maxStep, order: ORDER_ID }); }   // v4: positions are only meaningful with their order
    function syncUrl() {
      try {
        var u = new URL(location.href), s0 = set0();
        u.searchParams.delete('variant');
        if (s0.color) u.searchParams.set('farbe', slug(s0.color));
        if (s0.size) u.searchParams.set('groesse', slug(s0.size)); else u.searchParams.delete('groesse');
        if (s0.moochie) u.searchParams.set('moochie', s0.moochie === 'none' ? 'ohne' : s0.moochie); else u.searchParams.delete('moochie');
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }

    /* ── celebration ── */
    function celebrate() {
      if (S.celebrated) return;
      S.celebrated = true; ss('hh-cfg-cele', 1);
      var withM = set0().moochie && set0().moochie !== 'none';
      $.cele.innerHTML = esc(withM ? t('cele.with') : t('cele.without')).replace('♥', '<span class="hh-heartc">♥</span>');
      $.stage.classList.add('is-cele');
      setTimeout(function () { $.stage.classList.remove('is-cele'); }, RM() ? 2000 : 2700);
      announce(t('sr.complete'));
      vibrate([10, 40, 14]);
      if (RM()) {
        $.cele.style.opacity = 1; setTimeout(function () { $.cele.style.opacity = 0; }, 2000);
        return;
      }
      anim($.scA, [{ transform: 'scale(1)' }, { transform: 'scale(1.03)' }, { transform: 'scale(1)' }], { duration: 560, easing: EASE.spring });
      var bx = $.box.getBoundingClientRect();
      var origin = { x: .5 * bx.width, y: .62 * bx.height };
      if (withM && stageMoo) {
        origin = { x: .493 * bx.width, y: .5 * bx.height };
        var gw = pkG();
        [gw.back, gw.fx].forEach(function (el) { anim(el, [0, -2.5, 2, -1.2, 0].map(function (d) { return { transform: 'rotate(' + d + 'deg)' }; }), { duration: 600, delay: 120 }); });
      } else if (withM && !$.dock.hidden) {
        var sr = $.sticker.getBoundingClientRect(); origin = { x: sr.left - bx.left + sr.width / 2, y: sr.top - bx.top + sr.height / 2 };
        anim($.sticker, [-6, 6, -4, 2, -6].map(function (d) { return { transform: 'translate(-50%,-50%) rotate(' + d + 'deg)' }; }), { duration: 600, delay: 120 });
      }
      var cols = ['#F0C8E8', '#E4A4CC', '#D4789A', '#E8D0C0'];
      for (var i = 0; i < 12; i++) {
        (function (i) {
          var hEl = document.createElement('span'); hEl.className = 'hh-heart'; hEl.innerHTML = ICON.heart;
          var sz = rand(10, 22); hEl.style.cssText = 'left:' + origin.x + 'px;top:' + origin.y + 'px;width:' + sz + 'px;height:' + sz + 'px;color:' + cols[i % 4];
          $.hearts.appendChild(hEl);
          var a = hEl.animate([
            { transform: 'translate(0,0) scale(.4)', opacity: 0 },
            { opacity: 1, offset: .15 },
            { opacity: 1, offset: .65 },
            { transform: 'translate(' + rand(-70, 70) + 'px,' + (-rand(100, 190)) + 'px) scale(1) rotate(' + rand(-25, 25) + 'deg)', opacity: 0 }
          ], { duration: rand(900, 1400), delay: 80 + i * 40, easing: EASE.out, fill: 'both' });
          a.finished.then(function () { hEl.remove(); }).catch(function () { hEl.remove(); });
        })(i);
      }
      $.cele.style.opacity = 1;
      anim($.cele, [{ opacity: 0, transform: 'translateX(-50%) rotate(-2deg) scale(.8)' }, { opacity: 1, transform: 'translateX(-50%) rotate(-2deg) scale(1)' }], { duration: 360, delay: 200, easing: EASE.spring, fill: 'backwards' });
      setTimeout(function () {
        anim($.cele, [{ opacity: 1 }, { opacity: 0 }], { duration: 400 });
        $.cele.style.opacity = 0;
      }, 2360);
    }

    /* ───────────────────────── sheets ───────────────────────── */
    var sheetState = null, xState = null, lastFocus = null, lockY = null;
    function unlockScroll() {
      document.documentElement.style.overflow = '';
      if (lockY != null && Math.abs(window.pageYOffset - lockY) > 2) window.scrollTo(0, lockY);
      lockY = null;
    }
    function openSheet(el, html, onOpen) {
      lastFocus = document.activeElement;
      lockY = window.pageYOffset;
      el.innerHTML = '<div class="hh-sheet__bd" data-act="sheet-close"></div><div class="hh-sheet__panel" role="dialog" aria-modal="true">' + html + '</div>';
      el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
      setTimeout(function () { var f = q('.hh-sheet__x', el); if (f) try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
      if (onOpen) onOpen();
      bindSwipeDown(el);
    }
    function closeSheet(el) {
      if (!el || el.hidden) return;
      el.classList.remove('is-open');
      unlockScroll();
      setTimeout(function () { el.hidden = true; el.innerHTML = ''; }, RM() ? 0 : 280);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      if (el === $.sheet) { sheetState = null; xState = null; }
    }
    function bindSwipeDown(el) {
      var panel = q('.hh-sheet__panel', el), y0 = null, dy = 0;
      var head = q('.hh-sheet__grab', el) ? q('.hh-sheet__head', el) : null;
      [q('.hh-sheet__grab', el), head].forEach(function (h) {
        if (!h) return;
        h.addEventListener('pointerdown', function (e) { y0 = e.clientY; dy = 0; try { h.setPointerCapture(e.pointerId); } catch (x) {} });
        h.addEventListener('pointermove', function (e) { if (y0 == null) return; dy = Math.max(0, e.clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; panel.style.transition = 'none'; });
        h.addEventListener('pointerup', function () { if (y0 == null) return; panel.style.transition = ''; panel.style.transform = ''; if (dy > 80) closeSheet(el); y0 = null; });
      });
    }
    function sheetHead(title, kick) {
      return '<div class="hh-sheet__grab" aria-hidden="true"></div><div class="hh-sheet__head"><div class="hh-sheet__ttl"><p class="hh-sheet__kick" id="hh-sheet-kick"' + (kick ? '' : ' hidden') + '>' + esc(kick || '') + '</p>' +
        '<h3 class="hh-sheet__title" id="hh-sheet-title">' + esc(title) + '</h3></div>' +
        '<button type="button" class="hh-sheet__x" data-act="sheet-close" aria-label="' + esc(t('close')) + '">' + ICON.x + '</button></div>';
    }
    // v3: the hoodie sheet carries the offer name ("Wärme zu zweit" / "Wärme zu dritt") of the bundle it builds
    function setSheetTitles(st) {
      var n = st.editing ? S.sets.length : Math.max(st.target, S.sets.length + 1);
      return {
        title: n >= 3 ? t('offer.3') : (n === 2 ? t('offer.2') : t('sheet.title', { n: st.i + 1 })),
        kick: n >= 2 ? (n > 2 && !st.editing ? t('sheet.of', { n: st.i + 1, t: n }) : t('sheet.title', { n: st.i + 1 })) : ''
      };
    }
    // extra hoodie sets
    function openSetSheet(i, target) {
      var editing = i < S.sets.length;
      var draft = editing ? Object.assign({}, S.sets[i]) : { color: set0().color, size: set0().size, moochie: null };
      if (draft.size && !resolve(draft.color, draft.size)) draft.size = null;
      xState = null;
      sheetState = { i: i, draft: draft, editing: editing, target: target || Math.max(S.sets.length + (editing ? 0 : 1), i + 1) };
      var tt = setSheetTitles(sheetState);
      openSheet($.sheet, sheetHead(tt.title, tt.kick) + '<div class="hh-sheet__body" data-ref-sheet="body"></div><div class="hh-sheet__foot" data-ref-sheet="foot"></div>');
      renderSheet();
      track('hh_cfg_upsell_open', { set: i + 1 });
    }
    function sheetSets() {
      var st = sheetState, sets = S.sets.slice();
      if (st.editing) sets[st.i] = st.draft; else sets.push(st.draft);
      return sets;
    }
    function renderSheet() {
      var st = sheetState; if (!st) return;
      var d = st.draft, body = q('[data-ref-sheet="body"]', $.sheet), foot = q('[data-ref-sheet="foot"]', $.sheet);
      var title = q('#hh-sheet-title', $.sheet), kickEl = q('#hh-sheet-kick', $.sheet), tt = setSheetTitles(st);
      if (title) title.textContent = tt.title;
      if (kickEl) { kickEl.textContent = tt.kick; kickEl.hidden = !tt.kick; }
      var sp = sizePills(d.color, d.size, 'sheet-size');
      var sets = sheetSets();
      var m = model(sets), line = lineFor(m, st.i);
      // only when THIS hoodie's Moochie really is free in the model (with any Moochie picked for it)
      var probe = lineFor(model(withSet(sets, st.i, { moochie: d.moochie && d.moochie !== 'none' ? d.moochie : (MOO[0] && MOO[0].handle) })), st.i);
      var freeHint = probe && probe.kind === 'free' ? '<div class="hh-sheet__hint">' + esc(t('sheet.hint', { n: st.i + 1 })) + '</div>' : '';
      body.innerHTML = '<div class="hh-label"><span class="hh-label__k">' + esc(t('color.k')) + ' — <span class="hh-label__v">' + esc(d.color) + '</span></span></div>' +
        '<div class="hh-colors">' + colorCards(d.color, 'sheet-color', true) + '</div>' +
        '<div class="hh-label"><span class="hh-label__k">' + esc(t('size.k')) + ' — <span class="hh-label__v">' + esc(d.size || '–') + '</span></span></div>' +
        '<div class="hh-sizes' + (sp.hasLow ? ' has-low' : '') + '" data-sheet-sizes><span class="hh-loz" data-sheet-loz aria-hidden="true"></span>' + sp.html + '</div>' +
        '<div class="hh-stock" data-sheet-stock><span class="hh-stock__dot" aria-hidden="true"></span><p class="hh-stock__line"></p></div>' +
        freeHint +
        '<div class="hh-mgrid">' + moochieCards(sets, st.i, 'sheet-moochie') + '</div>' +
        '<button type="button" class="hh-none" data-act="sheet-none" aria-pressed="' + (d.moochie === 'none') + '"><span class="hh-check" aria-hidden="true">' + ICON.check + '</span>' + esc(t('m.none')) + '<small>' + esc(t('m.noneSub')) + '</small></button>';
      var stockBox = q('[data-sheet-stock]', body); renderStock(stockBox, q('.hh-stock__line', stockBox), d.color, d.size);
      moveLoz(true, q('[data-sheet-sizes]', body), q('[data-sheet-loz]', body));
      var delta = model(sets).total - model(S.sets).total;
      // v2: one big, always-visible confirm in the sticky sheet footer ("Hinzufügen" + the real price delta)
      var ready = !!(d.size && resolve(d.color, d.size) && d.moochie !== null);
      var lbl = st.editing ? esc(t('sheet.save')) : esc(t('sheet.addK')) + '<span class="hh-sheet__delta">+' + esc(fmt(delta)) + '</span>';
      foot.innerHTML = '<button type="button" class="hh-btn hh-btn--embrace hh-sheet__ok' + (ready ? ' is-ready' : '') + '" data-act="sheet-confirm">' + lbl + '</button>' +
        '<button type="button" class="hh-sheet__cancel" data-act="sheet-close">' + esc(t('sheet.cancel')) + '</button>';
      if (ready && !st.wasReady) { var ok = q('.hh-sheet__ok', foot); anim(ok, [{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }], { duration: 420, easing: EASE.spring }); }
      st.wasReady = ready;
      void line;
    }
    function sheetConfirm() {
      var st = sheetState; if (!st) return;
      var d = st.draft, body = q('[data-ref-sheet="body"]', $.sheet);
      // v2 review: scroll the sheet BODY so the thing to fix sits 8 px below the sheet header (scrollIntoView centred it,
      // which put the Moochie hint under the header at 360x640)
      var bodyTo = function (el) {
        if (!el || !body) return;
        var y = body.scrollTop + el.getBoundingClientRect().top - body.getBoundingClientRect().top - 8;
        try { body.scrollTo({ top: Math.max(0, y), behavior: RM() ? 'auto' : 'smooth' }); } catch (e) { body.scrollTop = Math.max(0, y); }
      };
      if (!d.size || !resolve(d.color, d.size)) {
        var sz = q('[data-sheet-sizes]', body); sz.classList.remove('hh-shake'); void sz.offsetWidth; sz.classList.add('hh-shake');
        bodyTo(sz.previousElementSibling || sz);
        announce(t('size.req')); return;
      }
      if (d.moochie === null) {
        var g = q('.hh-mgrid', body);
        bodyTo(q('.hh-sheet__hint', body) || g);
        qa('.hh-mcard', g).forEach(function (c, i) { anim(c, [{ transform: 'none' }, { transform: 'translateY(-6px)' }, { transform: 'none' }], { duration: 300, delay: i * 50, easing: EASE.out }); });
        announce(t('s2.req')); return;
      }
      if (st.editing) S.sets[st.i] = Object.assign({}, d); else S.sets.push(Object.assign({}, d));
      clearError();
      var target = st.target, wasAdd = !st.editing;
      closeSheet($.sheet);
      track('hh_cfg_upsell_add', { sets: S.sets.length });
      renderExtras(wasAdd);
      renderStep3(); renderRows(); renderProgress(); renderBar(); persist();
      if (wasAdd && S.sets.length < target && S.sets.length < 3) setTimeout(function () { openSetSheet(S.sets.length, target); }, RM() ? 0 : 320);
    }
    function removeSet(i) {
      if (i < 1 || i >= S.sets.length) return;
      S.sets.splice(i, 1); clearError();
      renderExtras(false); renderStep3(); renderRows(); renderProgress(); renderBar(); persist();
    }

    /* ── v3: extra Moochies ("+ Weitere Moochies hinzufügen" in the summary → sheet with a stepper per Moochie) ── */
    function mergeEx(a, b) {
      var o = {};
      [a || {}, b || {}].forEach(function (x) { Object.keys(x).forEach(function (h) { var n = x[h] | 0; if (n > 0 && MBY[h]) o[h] = (o[h] || 0) + n; }); });
      return o;
    }
    // v3 review: the sheet edits the ABSOLUTE number of extras (opens with S.extras loaded), so "−" works on what is in the order;
    // "schon N× dabei" therefore counts the bundle Moochies of the hoodies only
    function inBundle(h) { var n = 0; S.sets.forEach(function (s) { if (s.moochie === h) n++; }); return n; }
    function hasAnyMoochie() { return extrasCount(S.extras) > 0 || S.sets.some(function (s) { return s.moochie && s.moochie !== 'none' && MBY[s.moochie]; }); }
    function emptySlots() { var out = []; S.sets.forEach(function (s, i) { if (!s.moochie || s.moochie === 'none') out.push(i); }); return out; }
    // summary: one line per extra Moochie (qty, real price from the model, "Entfernen"), then the subtle add link
    function xmSummaryHtml(m) {
      if (!MOO.length) return '';
      var rows = '';
      MOO.forEach(function (mo) {
        var ls = m.lines.filter(function (l) { return l.extra && l.handle === mo.handle; });
        if (!ls.length) return;
        var n = ls.length, price = 0, unit = 0, nf = 0, nh = 0;
        ls.forEach(function (l) { price += l.price; unit += l.unit; if (l.kind === 'free') nf++; else if (l.kind === 'half') nh++; });
        var val = price === 0 ? '<div class="hh-sumrow__val is-free">' + esc(t('m.free')) + '<s>' + fmt(unit) + '</s></div>'
          : '<div class="hh-sumrow__val">' + fmt(price) + (price < unit ? '<s>' + fmt(unit) + '</s>' : (n > 1 ? '<small class="is-each">' + esc(t('sum.xEach', { n: n, p: fmt(mo.price) })) + '</small>' : '')) + '</div>';
        // why part of a multi-piece line is cheaper: "extra · 2 Stück · 1 davon gratis"
        var meta = n > 1 ? t('sum.xMetaN', { n: n }) : t('sum.xMeta');
        if (n > 1 && nf && nf < n) meta += ' · ' + t('sum.xFree', { n: nf });
        if (n > 1 && nh && nh < n) meta += ' · ' + t('sum.xHalf', { n: nh, pct: CFG.mpct });
        rows += '<div class="hh-sumrow hh-sumrow--x" data-xm="' + esc(mo.handle) + '"><span class="hh-sumrow__img is-round"><img src="' + esc(mo.img) + '" alt="" width="44" height="44"></span>' +
          '<span class="hh-sumrow__txt">' + esc(t('sum.m', { m: mo.title })) + '<small>' + esc(meta) + '</small>' +
          '<button type="button" class="hh-tbtn hh-edit" data-act="xm-remove" data-h="' + esc(mo.handle) + '" aria-label="' + esc(t(n > 1 ? 'sum.xRemove1' : 'sum.xRemove', { m: mo.title })) + '">' + esc(t(n > 1 ? 'sum.remove1' : 'sum.remove')) + '</button></span>' + val + '</div>';
      });
      return '<div class="hh-sum__xm' + (rows ? ' has-rows' : '') + '">' + rows +
        '<button type="button" class="hh-xmlink" data-act="xm-open" aria-haspopup="dialog"><span class="hh-xmlink__p" aria-hidden="true">+</span><span class="hh-xmlink__t">' + esc(t(hasAnyMoochie() ? 'xm.link' : 'xm.link0')) + '</span></button></div>';
    }
    // the sheet's sub-copy is fixed when it opens (state before the sheet), so it does not flip with every tap
    function extraSubCopy() {
      if (!MOO.length) return t('xm.sub0');
      var p = MOO[0].price, same = MOO.every(function (mo) { return mo.price === p; });
      if (!same) return t('xm.sub0');
      var ex = mergeEx(S.extras, {}), cur = model(S.sets, ex).total, nf = 0, nh = 0, hp = 0;
      for (var k = 0; k < 6; k++) {
        ex[MOO[0].handle] = (ex[MOO[0].handle] | 0) + 1;
        var nx = model(S.sets, ex).total, d = nx - cur; cur = nx;
        if (d === 0 && !nh) nf++; else if (d > 0 && d < p) { nh++; hp = d; } else break;
      }
      if (nf) return t(nf > 1 ? 'xm.subFreeN' : 'xm.subFree1', { k: nf, p: fmt(p) });
      if (nh) return t(nh > 1 ? 'xm.subHalfN' : 'xm.subHalf1', { k: nh, h: fmt(hp), pct: CFG.mpct, p: fmt(p) });
      return t('xm.sub', { p: fmt(p) });
    }
    function openExtraSheet() {
      if (!MOO.length) return;
      sheetState = null;
      var base = mergeEx(S.extras, {});
      xState = { qty: mergeEx(base, {}), base: base, seq: [], wasReady: false };
      openSheet($.sheet, sheetHead(t(hasAnyMoochie() ? 'xm.title' : 'xm.title0')) + '<div class="hh-sheet__body" data-ref-sheet="body"></div><div class="hh-sheet__foot" data-ref-sheet="foot"></div>');
      var body = q('[data-ref-sheet="body"]', $.sheet);
      body.innerHTML = '<p class="hh-sub hh-xm__sub" data-xsub>' + esc(extraSubCopy()) + '</p><ul class="hh-xlist" role="list">' + MOO.map(function (mo) {
        return '<li class="hh-xm" data-h="' + esc(mo.handle) + '">' +
          '<button type="button" class="hh-xm__img" data-act="xm-plus" data-h="' + esc(mo.handle) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(mo.img) + '" alt="" width="64" height="64" decoding="async"><span class="hh-xm__badge" data-xb hidden></span></button>' +
          '<span class="hh-xm__txt"><span class="hh-xm__name">' + esc(mo.title) + '</span><span class="hh-xm__price" data-xp></span><span class="hh-xm__have" data-xh hidden></span></span>' +
          '<span class="hh-qty" role="group" aria-label="' + esc(mo.title) + '">' +
            '<button type="button" class="hh-qty__b" data-act="xm-minus" data-h="' + esc(mo.handle) + '" aria-label="' + esc(t('xm.minus', { m: mo.title })) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg></button>' +
            '<output class="hh-qty__n" data-xq aria-live="polite">0</output>' +
            '<button type="button" class="hh-qty__b is-plus" data-act="xm-plus" data-h="' + esc(mo.handle) + '" aria-label="' + esc(t('xm.plus', { m: mo.title })) + '">' + ICON.plus + '</button>' +
          '</span></li>';
      }).join('') + '</ul>';
      renderExtraSheet();
      track('hh_cfg_extra_open', { have: extrasCount(S.extras) });
    }
    function xDiff(st) {
      var inc = 0, dec = 0, incFull = 0;
      MOO.forEach(function (mo) { var d = (st.qty[mo.handle] | 0) - (st.base[mo.handle] | 0); if (d > 0) { inc += d; incFull += d * mo.price; } else dec -= d; });
      return { inc: inc, dec: dec, incFull: incFull };
    }
    // updates in place (no re-render: keeps focus on the stepper and the list's scroll position)
    function renderExtraSheet() {
      var st = xState; if (!st) return;
      var body = q('[data-ref-sheet="body"]', $.sheet), foot = q('[data-ref-sheet="foot"]', $.sheet);
      var before = model(S.sets), now = model(S.sets, st.qty), delta = now.total - before.total, df = xDiff(st);
      qa('.hh-xm', body).forEach(function (li) {
        var h = li.getAttribute('data-h'), mo = MBY[h]; if (!mo) return;
        var k = st.qty[h] | 0, add1 = {}; add1[h] = 1;
        var next = model(S.sets, mergeEx(st.qty, add1)).total - now.total; // what ONE more of this Moochie really adds
        li.classList.toggle('is-on', k > 0);
        q('[data-xq]', li).textContent = String(k);
        var b = q('[data-xb]', li); b.hidden = !k; b.textContent = '+' + k;
        q('[data-act="xm-minus"]', li).disabled = !k;
        q('[data-xp]', li).innerHTML = next === 0 ? esc(t('m.free')) + ' <s>' + fmt(mo.price) + '</s>' : fmt(next) + (next < mo.price ? ' <s>' + fmt(mo.price) + '</s>' : '');
        var have = inBundle(h), he = q('[data-xh]', li);
        he.hidden = !have; he.textContent = have ? t('xm.have', { n: have }) : '';
      });
      var changed = df.inc + df.dec > 0, hadExtras = extrasCount(st.base) > 0;
      var ready = changed || hadExtras;
      var label = !changed ? (hadExtras ? t('xm.done') : t('sheet.addK')) : (df.dec ? t('sheet.save') : t('sheet.addK'));
      var pill = '';
      if (changed) {
        if (delta === 0 && df.inc) pill = '<span class="hh-sheet__delta is-free">' + esc(t('xm.free')) + '</span>';
        else if (delta > 0) pill = '<span class="hh-sheet__delta">+' + esc(fmt(delta)) + '</span>';
        else if (delta < 0) pill = '<span class="hh-sheet__delta">−' + esc(fmt(-delta)) + '</span>';
      }
      // part of what they add is free / −50 %: say so next to the amount ("davon 1 gratis")
      var note = '';
      if (df.inc && !df.dec && delta > 0 && delta < df.incFull) {
        var nf = Math.max(0, now.free - before.free), nh = Math.max(0, now.half - before.half), bits = [];
        if (nf) bits.push(t('xm.noteFree', { n: nf }));
        if (nh) bits.push(t('xm.noteHalf', { n: nh, pct: CFG.mpct }));
        if (bits.length) note = '<p class="hh-xm__note">' + esc(bits.join(' · ')) + '</p>';
      }
      foot.innerHTML = note + '<button type="button" class="hh-btn hh-btn--embrace hh-sheet__ok' + (ready ? ' is-ready' : '') + '" data-act="xm-confirm">' + esc(label) + pill + '</button>' +
        '<button type="button" class="hh-sheet__cancel" data-act="sheet-close">' + esc(t('sheet.cancel')) + '</button>';
      if (changed && !st.wasReady) { var ok = q('.hh-sheet__ok', foot); anim(ok, [{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }], { duration: 420, easing: EASE.spring }); }
      st.wasReady = changed;
    }
    function extraStep(h, d) {
      var st = xState; if (!st || !MBY[h]) return;
      var k = Math.max(0, Math.min(20, (st.qty[h] | 0) + d));
      if (k === (st.qty[h] | 0)) return;
      if (k) st.qty[h] = k; else delete st.qty[h];
      // tap order: the first Moochie they add fills an empty bundle slot ("Ohne Moochie" hoodie) on confirm
      if (d > 0) st.seq.push(h); else { var j = st.seq.lastIndexOf(h); if (j >= 0) st.seq.splice(j, 1); }
      renderExtraSheet();
      var li = q('.hh-xm[data-h="' + cssEsc(h) + '"]', $.sheet);
      if (li && d > 0) { anim(q('.hh-xm__img img', li), [{ transform: 'scale(1)' }, { transform: 'scale(1.1) rotate(-5deg)' }, { transform: 'scale(1)' }], { duration: 360, easing: EASE.spring }); vibrate(8); }
      if (li) anim(q('[data-xq]', li), [{ transform: 'translateY(' + (d > 0 ? 6 : -6) + 'px)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 200, easing: EASE.out });
    }
    function extraConfirm() {
      var st = xState; if (!st) return;
      var df = xDiff(st);
      if (!df.inc && !df.dec) {
        if (extrasCount(st.base)) { closeSheet($.sheet); return; }
        qa('.hh-qty__b.is-plus', $.sheet).forEach(function (b, i) { anim(b, [{ transform: 'none' }, { transform: 'scale(1.18)' }, { transform: 'none' }], { duration: 300, delay: i * 50, easing: EASE.out }); });
        announce(t('xm.req')); return;
      }
      var Q = mergeEx(st.qty, {}), left = {};
      MOO.forEach(function (mo) { var d = (Q[mo.handle] | 0) - (st.base[mo.handle] | 0); if (d > 0) left[mo.handle] = d; });
      var added = Object.keys(left);
      // v3 review: a hoodie with "Ohne Moochie" takes the first NEW Moochie into its bundle slot (stage, chip and the
      // "−50 % / gratis" line follow); only the rest are "extra". Same cart, same total — just no "Ohne Moochie" + "extra" at once.
      var seq = st.seq.concat(added), absorbed = [];
      emptySlots().forEach(function (i) {
        for (var k = 0; k < seq.length; k++) {
          var h = seq[k];
          if ((left[h] | 0) > 0) { left[h]--; Q[h]--; if (!Q[h]) delete Q[h]; S.sets[i].moochie = h; absorbed.push({ i: i, h: h }); return; }
        }
      });
      S.extras = Q;
      clearError();
      closeSheet($.sheet);
      track('hh_cfg_extra_add', { qty: df.inc, removed: df.dec, handles: added, extras: extrasCount(S.extras), into_bundle: absorbed.length });
      if (absorbed.length) {
        updateStep2(); updateChip(); renderExtras(false); syncUrl();
        if (absorbed[0].i === 0) showSticker(absorbed[0].h, !RM());
      }
      renderStep3(); renderRows(); renderProgress(); renderBar(); persist();
      // the new lines light up once the sheet is gone (cause, then effect)
      setTimeout(function () {
        added.forEach(function (h) { var r = q('.hh-sumrow--x[data-xm="' + cssEsc(h) + '"]', $.s3); if (r) anim(r, [{ backgroundColor: 'rgba(250,229,255,1)' }, { backgroundColor: 'rgba(250,229,255,0)' }], { duration: 1200, easing: EASE.out }); });
      }, RM() ? 0 : 260);
    }
    // "Entfernen" takes ONE away ("Einen entfernen" when there are several), so a slip costs one tap to undo
    function removeExtra(h) {
      if (!S.extras[h]) return;
      var n = S.extras[h] - 1;
      if (n > 0) S.extras[h] = n; else delete S.extras[h];
      clearError();
      track('hh_cfg_extra_remove', { handle: h, qty: 1, left: n });
      renderStep3(); renderBar(); persist();
      announce(t('xm.removed', { m: MBY[h] ? MBY[h].title : h }));
      var el = n > 0 ? q('[data-act="xm-remove"][data-h="' + cssEsc(h) + '"]', $.s3) : q('[data-act="xm-open"]', $.s3);
      if (el) try { el.focus({ preventScroll: true }); } catch (e) {}
    }
    /* ── size help: "Größe finden" (the live PDP size finder, now able to SET the size) | "Größentabelle" ── */
    var SFK = 'hh-cfg-sf', SGK = 'hh-cfg-sgmode', sgMode = 'find';
    var SF = Object.assign({ unit: 'metric', fit: 'normal', hcm: '', hft: '', hin: '', w: '', res: null }, ss(SFK) || {});
    var SF_NAMES = ['XS', 'S', 'M', 'L', 'XL'];
    function sizeRows() {
      return String(CFG.sizeTable || '').split(/\n+/).map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); }).filter(function (r) { return r.length >= 2 && r[0]; });
    }
    function openSizeSheet(mode) {
      var saved = ls(SGK);
      sgMode = mode === 'chart' || mode === 'find' ? mode : (saved === 'chart' ? 'chart' : 'find');
      track('hh_cfg_size_helper_open', { mode: sgMode });
      openSheet($.sizeSheet, sheetHead(sgMode === 'find' ? t('sf.title') : t('sg.title')) + '<div class="hh-sheet__body" data-sg-body></div>');
      renderSizeSheet();
    }
    function renderSizeSheet() {
      var body = q('[data-sg-body]', $.sizeSheet); if (!body) return;
      var title = q('#hh-sheet-title', $.sizeSheet); if (title) title.textContent = sgMode === 'find' ? t('sf.title') : t('sg.title');
      var tabs = '<div class="hh-seg hh-sg__tabs" role="tablist" aria-label="' + esc(t('size.help')) + '">' +
        ['find', 'chart'].map(function (m) {
          return '<button type="button" role="tab" class="hh-seg__b" data-act="sg-mode" data-mode="' + m + '" aria-selected="' + (sgMode === m) + '">' + esc(t(m === 'find' ? 'sf.tabFind' : 'sf.tabChart')) + '</button>';
        }).join('') + '</div>';
      body.innerHTML = tabs + '<div class="hh-sg__pane" role="tabpanel">' + (sgMode === 'find' ? finderHtml() : chartHtml()) + '</div>';
      if (sgMode === 'find' && SF.res) showFinderResult(false);
    }
    function chartHtml() {
      var s0 = set0(), cols = t('sg.cols').split('|'), rows = sizeRows(), mark = s0.size || (SF.res && SF.res.size);
      var tbl = '<table class="hh-sizetbl"><caption>' + esc(t('sg.cap')) + '</caption><thead><tr>' + cols.map(function (c) { return '<th scope="col">' + esc(c) + '</th>'; }).join('') + '</tr></thead><tbody>' +
        rows.map(function (r) {
          var sz = r[0], av = !!resolve(s0.color, sz);
          return '<tr class="' + (sz === mark ? 'is-sel ' : '') + (av ? '' : 'is-sold') + '">' + r.map(function (cell, k) {
            if (k === 0) return '<td><button type="button" data-act="sg-pick" data-size="' + esc(sz) + '" aria-label="' + esc(av ? 'Größe ' + sz + ' wählen' : sz + ' – ' + t('sg.soldIn', { c: s0.color })) + '">' + esc(sz) + '</button></td>';
            return '<td>' + esc(cell) + '</td>';
          }).join('') + '</tr>';
        }).join('') + '</tbody></table>';
      var fit = FIT ? '<figure class="hh-sg__fit"><img src="' + esc(FIT.src) + '"' + (FIT.s1080 ? ' srcset="' + esc(FIT.src) + ' 720w, ' + esc(FIT.s1080) + ' 1080w" sizes="(min-width:600px) 520px, 100vw"' : '') +
        ' alt="' + esc(FIT.alt || '') + '" width="' + (FIT.w || 1) + '" height="' + (FIT.h || 1) + '" loading="lazy" decoding="async"><figcaption>' + esc(t('sg.fitK')) + '</figcaption></figure>' : '';
      // v2 review: the numbers first (visible without scrolling at 390x660), then the fit notes, then the fit picture
      return (rows.length ? '<p class="hh-sg__hint">' + esc(t('sg.hint')) + '</p>' + tbl : '') +
        '<p class="hh-sg__model">' + esc(t('sg.model')) + '</p><p class="hh-sg__lede hh-sg__lede--after">' + esc(t('sg.lede')) + '</p>' +
        fit + '<p class="hh-sg__ret">' + esc(t('sg.ret')) + '</p>';
    }
    function finderHtml() {
      var met = SF.unit !== 'imperial';
      var inp = function (id, name, min, max, ph, unit, val) {
        return '<span class="hh-sf__in"><input id="' + id + '" name="' + name + '" type="number" inputmode="numeric" min="' + min + '" max="' + max + '" placeholder="' + ph + '" value="' + esc(val || '') + '" autocomplete="off"><span class="hh-sf__u">' + unit + '</span></span>';
      };
      var hId = 'hh-sf-h-' + (D.sectionId || 'x'), wId = 'hh-sf-w-' + (D.sectionId || 'x');
      var height = met ? '<div class="hh-sf__f"><label class="hh-sf__l" for="' + hId + '">' + esc(t('sf.height')) + '</label>' + inp(hId, 'hcm', 130, 215, 175, 'cm', SF.hcm) + '</div>'
        : '<div class="hh-sf__f"><label class="hh-sf__l" for="' + hId + '">' + esc(t('sf.height')) + '</label><span class="hh-sf__split">' + inp(hId, 'hft', 4, 7, 5, 'ft', SF.hft) + inp(hId + 'i', 'hin', 0, 11, 9, 'in', SF.hin) + '</span></div>';
      var weight = '<div class="hh-sf__f"><label class="hh-sf__l" for="' + wId + '">' + esc(t('sf.weight')) + '</label>' + inp(wId, 'w', met ? 35 : 77, met ? 200 : 440, met ? 65 : 143, met ? 'kg' : 'lb', SF.w) + '</div>';
      var fit = function (k, n, sub) { return '<button type="button" class="hh-sf__fit" data-act="sf-fit" data-fit="' + k + '" aria-pressed="' + (SF.fit === k) + '"><b>' + esc(t(n)) + '</b><span>' + esc(t(sub)) + '</span></button>'; };
      return '<form class="hh-sf" data-sf-form novalidate>' +
        '<p class="hh-sg__lede">' + esc(t('sf.lede')) + '</p>' +
        '<div class="hh-seg hh-seg--sm" role="group" aria-label="' + esc(t('sf.units')) + '">' +
          '<button type="button" class="hh-seg__b" data-act="sf-unit" data-unit="metric" aria-pressed="' + met + '">' + esc(t('sf.metric')) + '</button>' +
          '<button type="button" class="hh-seg__b" data-act="sf-unit" data-unit="imperial" aria-pressed="' + !met + '">' + esc(t('sf.imperial')) + '</button></div>' +
        '<div class="hh-sf__fields">' + height + weight + '</div>' +
        '<div class="hh-sf__l" id="hh-sf-fitk">' + esc(t('sf.fitK')) + '</div>' +
        '<div class="hh-sf__fits" role="group" aria-labelledby="hh-sf-fitk">' + fit('normal', 'sf.fitN', 'sf.fitNs') + fit('extra', 'sf.fitX', 'sf.fitXs') + '</div>' +
        '<button type="submit" class="hh-btn hh-btn--embrace hh-btn--block hh-sf__go">' + esc(t('sf.go')) + '</button>' +
        '<p class="hh-sf__err" data-sf-err role="alert" hidden></p>' +
        '<div class="hh-sf__res" data-sf-res aria-live="polite" hidden></div>' +
        '</form>';
    }
    function readFinder() {
      var f = q('[data-sf-form]', $.sizeSheet); if (!f) return;
      ['hcm', 'hft', 'hin', 'w'].forEach(function (n) { var el = f.elements[n]; if (el) SF[n] = String(el.value || '').trim(); });
    }
    function persistFinder() { ss(SFK, SF); }
    // live PDP logic, verbatim (weight score + small height adjustment, +1 for "Extra weit")
    function sfWeightIndex(kg) {
      var b = [52, 62, 73, 85];
      if (kg <= b[0]) return Math.max(0, 0.5 - (b[0] - kg) / 20);
      if (kg >= b[3]) return Math.min(4, 3.5 + (kg - b[3]) / 22);
      for (var i = 0; i < b.length - 1; i++) { if (kg <= b[i + 1]) return (i + 0.5) + (kg - b[i]) / (b[i + 1] - b[i]); }
      return 2;
    }
    function sfHeightAdjust(cm) { if (cm <= 157) return -0.35; if (cm <= 167) return -0.15; if (cm <= 178) return 0; if (cm <= 186) return 0.25; return 0.5; }
    function sfRecommend(cm, kg, fit) {
      var raw = sfWeightIndex(kg) + sfHeightAdjust(cm); if (fit === 'extra') raw += 1;
      var idx = Math.round(Math.max(0, Math.min(4, raw))), frac = Math.abs(raw - Math.round(raw));
      return { idx: idx, between: frac > 0.38 && raw > 0 && raw < 4, raw: raw };
    }
    function sfReason(cm, r, fit) {
      var bits = [r.between ? t('sf.whyB') : t('sf.why1')];
      if (fit === 'extra') bits.push(t('sf.whyX'));
      if (cm >= 179) bits.push(t('sf.whyL')); else if (cm <= 157) bits.push(t('sf.whyS'));
      return bits.join(', ') + '.';
    }
    function sfCalc() {
      readFinder();
      var cm, kg;
      if (SF.unit === 'imperial') { var ft = parseFloat(SF.hft) || 0, inch = parseFloat(SF.hin) || 0; cm = (ft * 12 + inch) * 2.54; kg = (parseFloat(SF.w) || 0) * 0.45359237; }
      else { cm = parseFloat(String(SF.hcm).replace(',', '.')); kg = parseFloat(String(SF.w).replace(',', '.')); }
      var err = q('[data-sf-err]', $.sizeSheet);
      if (!cm || !kg || cm < 130 || cm > 215 || kg < 30 || kg > 200) {
        SF.res = null; persistFinder();
        q('[data-sf-res]', $.sizeSheet).hidden = true;
        err.textContent = t('sf.err'); err.hidden = false;
        var form = q('[data-sf-form]', $.sizeSheet); form.classList.remove('hh-shake'); void form.offsetWidth; form.classList.add('hh-shake');
        return;
      }
      err.hidden = true;
      var r = sfRecommend(cm, kg, SF.fit), name = SF_NAMES[r.idx];
      var size = SIZES.indexOf(name) > -1 ? name : (SIZES[Math.min(r.idx, SIZES.length - 1)] || name);
      SF.res = { size: size, why: sfReason(cm, r, SF.fit) };
      persistFinder();
      track('hh_cfg_size_finder', { size: size, fit: SF.fit, unit: SF.unit });
      try { if (document.activeElement && document.activeElement.blur && document.activeElement.tagName === 'INPUT') document.activeElement.blur(); } catch (e) {}
      showFinderResult(true);
    }
    function showFinderResult(animate) {
      var box = q('[data-sf-res]', $.sizeSheet); if (!box || !SF.res) return;
      var sz = SF.res.size, s0 = set0(), row = null;
      sizeRows().forEach(function (r) { if (r[0] === sz) row = r; });
      var specs = row ? '<div class="hh-sf__specs">' + [['sf.chest', 1], ['sf.waist', 2], ['sf.length', 3]].map(function (x) {
        return '<div><b>' + esc(row[x[1]] || '–') + ' cm</b><span>' + esc(t(x[0])) + '</span></div>';
      }).join('') + '</div>' : '';
      var avail = !!resolve(s0.color, sz), act;
      if (avail) {
        var on = s0.size === sz;
        act = '<button type="button" class="hh-btn hh-btn--embrace hh-btn--block hh-sf__take' + (on ? ' is-on' : '') + '" data-act="sf-take" data-size="' + esc(sz) + '">' + esc(on ? t('sf.taken', { s: sz }) : t('sf.take', { s: sz })) + (on ? '' : ARR) + '</button>';
      } else {
        var alts = COLORS.filter(function (c) { return c.name !== s0.color && resolve(c.name, sz); });
        act = '<div class="hh-soldmsg" role="status">' + esc(t('sf.sold', { s: sz, c: s0.color })) +
          (alts.length ? '<div class="hh-soldmsg__alts"><span class="hh-soldmsg__k">' + esc(t('sf.soldAlt')) + '</span>' +
            alts.map(function (c) { return '<button type="button" class="hh-chipbtn" data-act="sf-color" data-color="' + esc(c.name) + '"><i style="background:' + esc(c.swatch) + '"></i>' + esc(c.name) + '</button>'; }).join('') + '</div>' : '') + '</div>';
      }
      box.innerHTML = '<p class="hh-sf__yk">' + esc(t('sf.your')) + '</p><p class="hh-sf__ys">' + esc(sz) + '</p><p class="hh-sf__why">' + esc(SF.res.why) + '</p>' + specs + act +
        '<p class="hh-sf__note">' + esc(t('sf.note')) + '</p>';
      box.hidden = false;
      if (animate) {
        anim(box, [{ opacity: 0, transform: 'translateY(10px) scale(.98)' }, { opacity: 1, transform: 'none' }], { duration: 360, easing: EASE.spring });
        anim(q('.hh-sf__ys', box), [{ transform: 'scale(.6)', opacity: 0 }, { transform: 'scale(1.08)', opacity: 1, offset: .7 }, { transform: 'none', opacity: 1 }], { duration: 480, delay: 80, easing: EASE.out });
        // bring the result (size + "übernehmen") into view inside the sheet's own scroll area
        setTimeout(function () {
          var sc = box.closest('.hh-sheet__body'); if (!sc) return;
          var y = sc.scrollTop + box.getBoundingClientRect().top - sc.getBoundingClientRect().top - 12;
          try { sc.scrollTo({ top: y, behavior: RM() ? 'auto' : 'smooth' }); } catch (e) { sc.scrollTop = y; }
        }, 80);
      }
    }

    /* ── story viewer (UGC videos) + photo lightbox (product photos) ── */
    var story = null, storyGen = 0;
    function openStory(i, kind) {
      kind = kind === 'photo' ? 'photo' : 'ugc';
      var list = kind === 'photo' ? galOrder : UGC;
      if (!list[i]) return;
      lastFocus = document.activeElement;
      story = { i: i, kind: kind, list: list, muted: true, timer: null, chk: null };
      lockY = window.pageYOffset;
      $.story.hidden = false;
      $.story.classList.toggle('is-photo', kind === 'photo');
      $.story.setAttribute('aria-label', kind === 'photo' ? t('gal.k') : 'Story');
      document.documentElement.style.overflow = 'hidden';
      renderStory();
      requestAnimationFrame(function () { $.story.classList.add('is-open'); });
      track(kind === 'photo' ? 'hh_cfg_photo_open' : 'hh_cfg_story_open', { i: i });
    }
    function stopStoryMedia() {
      storyGen++; // every pending play()/error/timer callback of the previous clip becomes a no-op
      if (!story) return;
      clearInterval(story.timer); clearTimeout(story.chk);
      var v = q('video', $.story);
      if (v) { try { v.pause(); v.removeAttribute('src'); qa('source', v).forEach(function (x) { x.remove(); }); v.load(); } catch (e) {} }
    }
    function renderStory() {
      stopStoryMedia();
      var list = story.list, u = list[story.i], photo = story.kind === 'photo', isVid = !photo && hasVideo(u);
      var segs = list.map(function (_, k) { return '<i class="' + (k < story.i || (photo && k === story.i) ? 'is-done' : '') + '"><b' + (k === story.i ? ' data-seg' : '') + '></b></i>'; }).join('');
      // muted + playsinline as ATTRIBUTES (iOS autoplay), HLS first and MP4 fallback (the live PDP pattern)
      var media = isVid ? '<video playsinline muted autoplay preload="auto" poster="' + esc(u.posterLg || u.poster) + '">' + videoSources(u) + '</video>' +
          '<button type="button" class="hh-story__play" data-act="story-play" aria-label="' + esc(t('story.play')) + '" hidden>' + ICON.play + '</button>'
        : (photo ? '<img class="is-photo" src="' + esc(u.full || u.src) + '" alt="' + esc(u.alt || '') + '">' : '<img src="' + esc(u.posterLg || u.poster) + '" alt="">');
      var cta = '';
      if (u.color && CBY[u.color]) {
        var picked = set0().color === u.color;
        cta = '<div class="hh-story__cta"><button type="button" class="hh-btn ' + (picked ? 'hh-btn--hearth' : 'hh-btn--embrace') + '" data-act="story-pick">' + esc(picked ? t('story.picked') : t('story.pick')) + '</button></div>';
      }
      var cap = photo ? (u.color || t('gal.photo')) + ' · ' + (story.i + 1) + '/' + list.length : (u.caption || u.color || '');
      $.story.innerHTML = '<div class="hh-story__media">' + media +
        '<div class="hh-story__segs">' + segs + '</div>' +
        '<div class="hh-story__top"><span class="hh-story__cap">' + esc(cap) + '</span><span class="hh-story__btns">' +
        (isVid ? '<button type="button" class="hh-story__btn" data-act="story-sound" aria-label="' + esc(story.muted ? t('story.on') : t('story.off')) + '">' + (story.muted ? ICON.mute : ICON.sound) + '</button>' : '') +
        '<button type="button" class="hh-story__btn" data-act="story-close" aria-label="' + esc(t('close')) + '">' + ICON.x + '</button></span></div>' +
        '<button type="button" class="hh-story__tap hh-story__tap--l" data-act="story-prev" aria-label="Zurück"></button>' +
        '<button type="button" class="hh-story__tap hh-story__tap--r" data-act="story-next" aria-label="Weiter"></button>' + cta + '</div>';
      var seg = q('[data-seg]', $.story), vid = q('video', $.story), start = Date.now(), dur = 5000, mode = isVid ? 'video' : (photo ? 'photo' : 'image');
      var gen = storyGen; // per-render token (story itself is the same object for the whole session)
      if (vid) {
        var playBtn = q('.hh-story__play', $.story);
        var showPlay = function () { if (gen !== storyGen || !vid) return; if (vid.paused && playBtn) playBtn.hidden = false; };
        var tryPlay = function () {
          if (gen !== storyGen || !vid) return;
          var p; try { p = vid.play(); } catch (e) { p = null; }
          if (p && p.then) p.then(function () { if (gen === storyGen && playBtn) playBtn.hidden = true; }).catch(function () {
            if (gen !== storyGen || !vid) return;
            // sound may be refused without a fresh tap: fall back to muted once, then offer the play button
            if (!vid.muted) { vid.muted = true; story.muted = true; var sb = q('[data-act="story-sound"]', $.story); if (sb) { sb.innerHTML = ICON.mute; sb.setAttribute('aria-label', t('story.on')); } tryPlay(); }
            else showPlay();
          });
        };
        vid.muted = story.muted;
        vid.addEventListener('loadedmetadata', function () { if (vid.duration && isFinite(vid.duration)) dur = vid.duration * 1000; });
        vid.addEventListener('playing', function () { if (playBtn) playBtn.hidden = true; });
        vid.addEventListener('ended', function () { storyStep(1); });
        // every source failed (network / codec): show the poster as a 5 s photo story instead of a dead player
        var srcs = qa('source', vid), last = srcs[srcs.length - 1];
        if (last) last.addEventListener('error', function () {
          if (gen !== storyGen || !vid) return;
          clearTimeout(story.chk);
          mode = 'image'; start = Date.now(); dur = 5000;
          vid.outerHTML = '<img src="' + esc(u.posterLg || u.poster) + '" alt="">'; vid = null;
          if (playBtn) playBtn.hidden = true;
        });
        tryPlay();
        story.chk = setTimeout(showPlay, 2500);
        story.vid = vid;
      }
      story.timer = setInterval(function () {
        if (mode === 'photo') return;
        var el = mode === 'video' && vid ? (vid.currentTime * 1000) : (Date.now() - start);
        var d = mode === 'video' && vid && vid.duration && isFinite(vid.duration) ? vid.duration * 1000 : dur;
        if (seg) seg.style.width = Math.min(100, el / d * 100) + '%';
        if (mode === 'image' && el >= dur) storyStep(1);
      }, 80);
      setTimeout(function () { var x = q('[data-act="story-close"]', $.story); if (x) try { x.focus({ preventScroll: true }); } catch (e) {} }, 50);
    }
    function storyStep(d) {
      if (!story) return;
      var n = story.i + d;
      if (n < 0) n = 0;
      if (n >= story.list.length) { closeStory(); return; }
      story.i = n; renderStory();
    }
    function closeStory() {
      if (!story) return;
      stopStoryMedia(); story = null;
      $.story.classList.remove('is-open');
      unlockScroll();
      setTimeout(function () { if (!story) { $.story.hidden = true; $.story.innerHTML = ''; } }, RM() ? 0 : 300);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }

    /* ── heat video below the configurator: load ~300 px before it is visible, play muted, pause when gone ── */
    function initAiVideo() {
      if (!AIV || !$.aivV) return;
      var v = $.aivV, box = $.aiv, loaded = false, blocked = false, inView = false, chk = null;
      if (RM()) v.removeAttribute('autoplay');
      var showBtn = function () { blocked = true; $.aivPlay.hidden = false; };
      var play = function (user) {
        if (RM() && !user) { showBtn(); return; }
        var p; try { p = v.play(); } catch (e) { p = null; }
        // only a real refusal (Low Power Mode, autoplay off) shows the button; an AbortError just means we paused it meanwhile
        if (p && p.then) p.then(function () { blocked = false; $.aivPlay.hidden = true; }).catch(function (e) { if (user || (e && e.name === 'NotAllowedError')) showBtn(); });
        clearTimeout(chk);
        chk = setTimeout(function () { if (inView && v.paused && $.aivPlay.hidden) showBtn(); }, 3500);
      };
      var load = function () {
        if (loaded) return; loaded = true;
        qa('source', v).forEach(function (s) { s.src = s.getAttribute('data-src'); });
        v.preload = 'auto';
        try { v.load(); } catch (e) {}
      };
      v.addEventListener('playing', function () { box.classList.add('is-playing'); blocked = false; $.aivPlay.hidden = true; });
      AIV._play = function () { load(); play(true); };
      if (!('IntersectionObserver' in window)) { inView = true; if (RM()) showBtn(); else { load(); play(); } return; }
      // v2 review: really lazy. At boot step 1 is still opening, so the box sits ~1000px higher than after layout and a
      // boot-time observer reported it "near" (1.4 MB of HLS next to the hero image). So: observe only after the first real
      // scroll (or once the page has fully loaded and settled), and re-check the position 250 ms after it reports "near".
      // Reduced motion never autoplays, so it loads nothing until the play button is tapped.
      var settleT = null;
      var near = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          inView = e.isIntersecting;
          clearTimeout(settleT);
          if (e.isIntersecting) {
            settleT = setTimeout(function () {
              if (!inView || box.getBoundingClientRect().top >= window.innerHeight + 300) return;
              if (RM()) { showBtn(); return; }
              load(); if (!blocked) play();
            }, 250);
          } else { clearTimeout(chk); if (loaded && !v.paused) v.pause(); }
        });
      }, { rootMargin: '300px 0px' });
      var armed = false;
      var arm = function () {
        if (armed) return; armed = true;
        window.removeEventListener('scroll', arm);
        near.observe(box);
      };
      window.addEventListener('scroll', arm, { passive: true });
      var armLate = function () { setTimeout(arm, 1500); };
      if (document.readyState === 'complete') armLate(); else window.addEventListener('load', armLate);
      document.addEventListener('visibilitychange', function () { if (document.hidden) v.pause(); else if (inView && !blocked && loaded) play(); });
    }

    /* ───────────────────────── cart ───────────────────────── */
    // What this configurator already put into the cart (variant id -> qty). Every submit only sends the DIFFERENCE,
    // so a second "Zur Kasse" (back from checkout), the "Mehr Wärme" path, double taps and retries never duplicate lines.
    var ADDED_KEY = 'hh-cfg-added';
    S.added = (function () { var a = ss(ADDED_KEY); return a && typeof a === 'object' ? a : {}; })();
    S.pending = null; // an add whose response never arrived (timeout / network): {adds, before}
    var VBYID = {}; (D.variants || []).forEach(function (v) { VBYID[v.id] = v; });
    function buildItems() {
      var items = [], idx = {};
      function add(id) { id = +id; if (idx[id] != null) items[idx[id]].quantity++; else { idx[id] = items.length; items.push({ id: id, quantity: 1 }); } }
      S.sets.forEach(function (s) { var v = vOf(s); if (v) add(v.id); });
      S.sets.forEach(function (s) { if (s.moochie && s.moochie !== 'none' && MBY[s.moochie]) add(MBY[s.moochie].variantId); });
      extrasList(S.extras).forEach(function (mo) { add(mo.variantId); }); // v3: extra Moochies (same variant as a bundle one = qty 2)
      return items;
    }
    function toMap(items) { var m = {}; items.forEach(function (it) { m[it.id] = (m[it.id] || 0) + it.quantity; }); return m; }
    function cartMap(cart) { var m = {}; ((cart && cart.items) || []).forEach(function (it) { var id = it.variant_id || it.id; m[id] = (m[id] || 0) + (it.quantity | 0); }); return m; }
    function sum(m) { var n = 0; Object.keys(m).forEach(function (k) { n += m[k]; }); return n; }
    function getCart(ms) {
      var c = window.AbortController ? new AbortController() : null, tm = setTimeout(function () { if (c) c.abort(); }, ms || 5000);
      return fetch(R.cartJs, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin', signal: c ? c.signal : undefined })
        .then(function (r) { clearTimeout(tm); if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    }
    function postJson(url, body, signal) {
      return fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body), signal: signal
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) { var e = new Error(j.description || j.message || 'cart-failed'); e.status = r.status; e.resp = j; throw e; }
          return j;
        });
      });
    }
    function resetSubmit() { if (S.submit !== 'adding') { S.submit = 'idle'; S.mode = null; renderBar(); } }
    // lower one variant to `to` in the cart, line by line (by line KEY, last line first): a discount can split the same
    // Moochie into two cart lines (bundle one at 19/0 € + extra at 38 €), and /cart/change.js with a variant id only
    // touches the first of them. Each step works on the cart the previous change returned.
    function lowerVariant(id, to, cart, signal, depth) {
      var ls = ((cart && cart.items) || []).filter(function (it) { return String(it.variant_id || it.id) === String(id); });
      var total = 0; ls.forEach(function (it) { total += it.quantity | 0; });
      if (!cart || !ls.length) return postJson(R.cartChange, { id: String(id), quantity: to }, signal);
      if (total <= to) return Promise.resolve(cart);
      var ln = ls[ls.length - 1], q = Math.max(0, (ln.quantity | 0) - (total - to));
      return postJson(R.cartChange, { id: ln.key ? String(ln.key) : String(id), quantity: q }, signal).then(function (c2) {
        return c2 && c2.items && ls.length > 1 && (depth | 0) < 4 ? lowerVariant(id, to, c2, signal, (depth | 0) + 1) : c2;
      });
    }
    // v4: one buying action. Section setting checkout_mode: 'checkout' (default) = straight to /checkout,
    // 'drawer' = the theme's own cart drawer opens with the added items ("In den Warenkorb").
    // Optional cart tag (_hh_src/_hh_flow, hidden attributes) so orders can be split by landing page.
    function finishCall(mode, ctrl) {
      var body = {};
      if (CFG.tagCart) body.attributes = { _hh_src: 'configurator', _hh_flow: ORDER_ID === 'm1' ? 'moochie_first' : 'hoodie_first' };
      if (mode === 'drawer') { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      if (!body.attributes && !body.sections) return Promise.resolve(null);
      // never blocks the purchase: any failure just means no tag / the drawer HTML is fetched separately
      return postJson(R.cartUpdate, body, ctrl ? ctrl.signal : undefined).then(function (j) {
        var sec = j && j.sections;
        return sec && sec['cart-drawer'] && sec['cart-icon-bubble'] ? sec : null;
      }).catch(function () { return null; });
    }
    function fetchSections() {
      // v4b: plain request (with Accept: application/json Shopify answers without the section HTML)
      return fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    // the theme's own drawer path (same as the PDP add-to-cart): replace #CartDrawer + the cart bubble, then open.
    // hug-cart-boot wraps renderContents (render sequence) and keeps is-empty in sync; upsell, wallets, e-book and
    // payment badges come from the server-rendered section. Both sections are required (renderContents throws otherwise).
    function openDrawer(sec) {
      var dr = document.querySelector('cart-drawer');
      if (!sec || !sec['cart-drawer'] || !sec['cart-icon-bubble'] || !dr || typeof dr.renderContents !== 'function') return false;
      try {
        if (dr.setActiveElement) dr.setActiveElement(document.activeElement);
        dr.classList.remove('is-empty');
        dr.renderContents({ sections: sec });
        // v4b: no cartUpdate publish – the theme's CartDrawerItems answers it by loading the cart PAGE markup into the
        // drawer (no Wärmflasche/E-Book/reviews, a second heading). The PDP add-to-cart does not publish either.
        return true;
      } catch (e) {
        track('hh_cfg_error', { kind: 'drawer', status: 0, message: String(e && e.message || e) });
        return false;
      }
    }
    function submit() {
      var mode = CFG.mode;
      if (S.submit === 'adding') return;
      if (!allDone()) { routeMissing(); return; }
      var desired = toMap(buildItems()), predicted = model(S.sets).total;
      S.submit = 'adding'; S.mode = mode; S.error = null;
      renderBar();
      track('hh_cfg_submit', { mode: mode, total: predicted, items: buildItems(), order: ORDER_ID });
      var t0 = Date.now(), lastAdds = [];
      var ctrl = window.AbortController ? new AbortController() : null;
      var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, 10000);
      getCart(4000).catch(function () { return null; }).then(function (cart) {
        var have = cart ? cartMap(cart) : null;
        // the customer may have removed our lines in the cart: we can't own more than the cart holds
        if (have) Object.keys(S.added).forEach(function (id) { S.added[id] = Math.min(S.added[id], have[id] || 0); if (!S.added[id]) delete S.added[id]; });
        // v4b: no record in this browser tab (new tab, storage cleared) but the cart was filled by the configurator before:
        // the lines it already holds count as ours, so the set is not added a second time
        if (have && !Object.keys(S.added).length && cart && cart.attributes && cart.attributes._hh_src === 'configurator') {
          Object.keys(desired).forEach(function (id) { var n = Math.min(have[id] || 0, desired[id]); if (n > 0) S.added[id] = n; });
        }
        // a previous attempt timed out: if it reached the server after all, count it instead of sending it again
        if (S.pending && have) {
          var p = S.pending;
          var arrived = Object.keys(p.adds).every(function (id) { return (have[id] || 0) >= (p.before[id] || 0) + p.adds[id]; });
          if (arrived) Object.keys(p.adds).forEach(function (id) { S.added[id] = Math.min(have[id], (S.added[id] || 0) + p.adds[id]); });
          track('hh_cfg_retry_check', { arrived: arrived });
        }
        S.pending = null;
        var adds = [], decs = [];
        Object.keys(desired).forEach(function (id) {
          var d = desired[id] - (S.added[id] || 0);
          if (d > 0) adds.push({ id: +id, quantity: d });
          else if (d < 0) decs.push({ id: +id, to: Math.max(0, (have ? (have[id] || 0) : (S.added[id] || 0)) + d) });
        });
        Object.keys(S.added).forEach(function (id) {
          if (desired[id] == null && S.added[id] > 0) decs.push({ id: +id, to: Math.max(0, (have ? (have[id] || 0) : S.added[id]) - S.added[id]) });
        });
        return { have: have || {}, cart: cart, adds: adds, decs: decs };
      }).then(function (plan) {
        var chain = Promise.resolve(plan.cart);
        plan.decs.forEach(function (d) {
          chain = chain.then(function (cur) { return lowerVariant(d.id, d.to, cur, ctrl ? ctrl.signal : undefined); });
        });
        if (plan.adds.length) chain = chain.then(function () {
          lastAdds = plan.adds;
          S.pending = { adds: toMap(plan.adds), before: plan.have };
          return postJson(R.cartAdd, { items: plan.adds }, ctrl ? ctrl.signal : undefined).then(function (j) { S.pending = null; return j; });
        });
        var changed = plan.adds.length + plan.decs.length > 0;
        return chain.then(function () { return finishCall(mode, ctrl); }).then(function (sec) { return { changed: changed, sections: sec }; });
      }).then(function (res) {
        clearTimeout(to);
        return sleep(Math.max(0, (res.changed ? 400 : 150) - (Date.now() - t0))).then(function () { return res; });
      }).then(function (res) {
        S.added = desired; ss(ADDED_KEY, S.added);
        track(res.changed ? 'hh_cfg_added' : 'hh_cfg_unchanged', { mode: mode, total: predicted, order: ORDER_ID });
        var check = res.changed ? verifyTotal(desired, predicted) : Promise.resolve();
        if (mode === 'drawer') {
          S.submit = 'idle'; S.mode = null; renderBar();
          return (res.sections ? Promise.resolve(res.sections) : fetchSections()).then(function (sec) {
            if (openDrawer(sec)) track('hh_cfg_drawer_open', { total: predicted, order: ORDER_ID });
            else navigate(R.cart);
          });
        }
        S.submit = 'added'; renderBar();
        return Promise.race([check, sleep(1500)]).then(function () {
          navigate(R.checkout);
          // safety net if the page stays (or comes back without bfcache events)
          setTimeout(resetSubmit, 4000);
        });
      }).catch(function (err) {
        clearTimeout(to);
        S.submit = 'idle';
        var kind = 'generic', msg = t('err.generic'), retry = true;
        if (!navigator.onLine || err.name === 'AbortError' || err instanceof TypeError) { kind = 'network'; msg = t('err.network'); }
        else {
          S.pending = null; // the server answered: nothing is in flight
          if (err.status === 422) {
            kind = /sold out|ausverkauft|nicht verfügbar|not available/i.test(err.message) ? 'soldout' : 'qty';
            msg = err.message || t('err.generic'); retry = false;
          }
        }
        S.error = { kind: kind, message: msg, retry: retry };
        vibrate(20);
        track('hh_cfg_error', { kind: kind, status: err.status || 0 });
        renderBar();
        if (err.status === 422) handleUnavailable(lastAdds.length ? lastAdds : buildItems());
      });
    }
    // 422: find out WHICH line is gone (product .js has per-variant availability), mark it locally and take the
    // customer straight to the place where they can pick something else
    function handleUnavailable(items) {
      var hits = [], reqs = [], MV = {};
      MOO.forEach(function (m) { MV[m.variantId] = m; });
      if (items.some(function (it) { return VBYID[it.id]; })) {
        reqs.push(fetch((D.product && D.product.url ? D.product.url.split('?')[0] : '/products/' + (D.product && D.product.handle)) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); }).then(function (p) {
            (p.variants || []).forEach(function (pv) { var v = VBYID[pv.id]; if (v && v.available && !pv.available) { v.available = false; hits.push({ h: v }); } });
          }));
      }
      items.forEach(function (it) {
        var mo = MV[it.id]; if (!mo) return;
        reqs.push(fetch('/products/' + encodeURIComponent(mo.handle) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
          var ok = (p.variants || []).some(function (pv) { return String(pv.id) === String(mo.variantId) && pv.available; });
          if (!ok) hits.push({ m: mo });
        }));
      });
      Promise.all(reqs.map(function (p) { return p.catch(function () {}); })).then(function () {
        if (!hits.length) return;
        var h = null, mo = null;
        hits.forEach(function (x) { if (x.h && !h) h = x.h; if (x.m && !mo) mo = x.m; });
        if (mo) {
          MOO = MOO.filter(function (m) { return m.handle !== mo.handle; });
          S.sets.forEach(function (s) { if (s.moochie === mo.handle) s.moochie = null; });
          delete S.extras[mo.handle];
          delete MBY[mo.handle];
          if (set0().moochie == null) { ++pkTok; pkClear(); $.dock.hidden = true; if (stageWant() === SHOW && SHOW) pkSettle(SHOW, pkTok, true); }
        }
        if (h) S.error.message = t('err.soldVariant', { c: h.options[iC], s: h.options[iS] });
        else if (mo) S.error.message = t('err.soldMoochie', { m: mo.title });
        S.error.kind = 'soldout';
        track('hh_cfg_soldout_marked', { variant: h ? h.id : null, moochie: mo ? mo.handle : null });
        updateStep1(); renderStep2(); updateChip(); renderExtras(false);
        if (S.maxStep >= 3) renderStep3();
        renderRows(); renderProgress(); renderBar(); persist();
        var bad = -1;
        S.sets.forEach(function (s, i) { if (bad < 0 && !setDone(s)) bad = i; });
        if (bad > 0) openSetSheet(bad); else routeMissing();
      });
    }
    function verifyTotal(desired, predicted) {
      return getCart(4000).then(function (cart) {
        var want = sum(desired);
        if (cart && cart.item_count === want) {
          if (cart.total_price !== predicted) track('hh_cfg_price_mismatch', { predicted: predicted, cart: cart.total_price, items: desired });
          else track('hh_cfg_price_match', { total: predicted });
        }
      }).catch(function () {});
    }
    // back/forward cache (iOS Safari, Instagram webview back from checkout): never come back with a dead, busy CTA
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { S.submit = 'idle'; S.mode = null; S.error = null; renderBar(); }
    });

    /* ───────────────────────── events ───────────────────────── */
    function touch() { S.touched = true; }
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-act]');
      if (!el || !root.contains(el)) return;
      var act = el.getAttribute('data-act');
      if (el.getAttribute('aria-disabled') === 'true' && act === 'goto') return;
      switch (act) {
        case 'color': { var r = el.getBoundingClientRect(); selectColor(el.getAttribute('data-color'), { x: r.left + r.width / 2, y: null }, el.classList.contains('hh-chipbtn') ? 'soldout-alt' : 'card'); break; }
        case 'size': selectSize(el.getAttribute('data-size')); break;
        case 'moochie': selectMoochie(el.getAttribute('data-handle'), el); break;
        case 'none': skipMoochie(); break;
        case 'next': ctaNext(); break;
        case 'goto3': gotoStep(3); break;
        case 'route': routeMissing(); break;
        case 'goto': gotoStep(+el.getAttribute('data-step')); break;
        case 'resume': scrollToEl(q('#' + HEAD[kindAt(S.step)], root), true); break;
        case 'stage-prev': cycleColor(-1, 'arrow'); break;
        case 'stage-next': cycleColor(1, 'arrow'); break;
        case 'sizehelp': openSizeSheet(el.getAttribute('data-mode')); break;
        case 'sg-mode': { readFinder(); persistFinder(); sgMode = el.getAttribute('data-mode') === 'chart' ? 'chart' : 'find'; ls(SGK, sgMode); renderSizeSheet(); track('hh_cfg_size_helper_mode', { mode: sgMode }); break; }
        case 'sf-unit': { var un = el.getAttribute('data-unit'); if (un !== SF.unit) { SF.unit = un; SF.hcm = SF.hft = SF.hin = SF.w = ''; SF.res = null; persistFinder(); renderSizeSheet(); var fi = q('[data-sf-form] input', $.sizeSheet); if (fi) try { fi.focus({ preventScroll: true }); } catch (x) {} } break; }
        case 'sf-fit': { readFinder(); SF.fit = el.getAttribute('data-fit') === 'extra' ? 'extra' : 'normal'; SF.res = null; persistFinder();
          qa('[data-act="sf-fit"]', $.sizeSheet).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-fit') === SF.fit)); });
          var rb = q('[data-sf-res]', $.sizeSheet); if (rb) rb.hidden = true; break; }
        case 'sf-take': { var tz = el.getAttribute('data-size'); track('hh_cfg_size_finder_take', { size: tz }); closeSheet($.sizeSheet); if (kindAt(S.step) !== 'hoodie') gotoStep(posOf('hoodie'), { force: true }); selectSize(tz); break; }
        case 'sf-color': { selectColor(el.getAttribute('data-color'), null, 'size-finder'); showFinderResult(true); break; }
        case 'photo': openStory(+el.getAttribute('data-i'), 'photo'); break;
        case 'story-play': { var sv = q('video', $.story); if (sv) { var pp = sv.play(); el.hidden = true; if (pp && pp.catch) pp.catch(function () { sv.muted = true; sv.play().catch(function () { el.hidden = false; }); }); } break; }
        case 'aiv-play': if (AIV && AIV._play) AIV._play(); break;
        case 'info': { var pop = $.pop; pop.hidden = !pop.hidden; el.setAttribute('aria-expanded', String(!pop.hidden)); break; }
        case 'tier': { var tier = +el.getAttribute('data-tier'); openSetSheet(S.sets.length, tier); break; }
        case 'set-edit': { var i = +el.getAttribute('data-i'); if (i > 0) openSetSheet(i); break; }
        case 'set-remove': removeSet(+el.getAttribute('data-i')); break;
        case 'submit': submit(el.getAttribute('data-mode') || 'checkout'); break;
        case 'retry': if (S.mode) submit(S.mode); break;
        case 'story': openStory(+el.getAttribute('data-i')); break;
        case 'story-close': closeStory(); break;
        case 'story-next': storyStep(1); break;
        case 'story-prev': storyStep(-1); break;
        case 'story-sound': { story.muted = !story.muted; var v = q('video', $.story); if (v) { v.muted = story.muted; if (v.paused) v.play().catch(function () {}); } el.innerHTML = story.muted ? ICON.mute : ICON.sound; el.setAttribute('aria-label', story.muted ? t('story.on') : t('story.off')); break; }
        case 'story-pick': { var u = story.list[story.i]; closeStory(); if (u && u.color) { gotoStep(posOf('hoodie'), { force: true, noFocus: true }); selectColor(u.color, null, 'story'); } break; }
        case 'sheet-close': closeSheet(el.closest('.hh-sheet')); break;
        case 'sheet-color': { sheetState.draft.color = el.getAttribute('data-color'); if (sheetState.draft.size && !resolve(sheetState.draft.color, sheetState.draft.size)) sheetState.draft.size = null; renderSheet(); break; }
        case 'sheet-size': { var z = el.getAttribute('data-size'); if (resolve(sheetState.draft.color, z)) { sheetState.draft.size = z; renderSheet(); } else { pressPop(el); } break; }
        case 'sheet-moochie': { sheetState.draft.moochie = el.getAttribute('data-handle'); renderSheet(); break; }
        case 'sheet-none': { sheetState.draft.moochie = 'none'; renderSheet(); break; }
        case 'sheet-confirm': sheetConfirm(); break;
        case 'xm-open': openExtraSheet(); break;
        case 'xm-plus': extraStep(el.getAttribute('data-h'), 1); break;
        case 'xm-minus': extraStep(el.getAttribute('data-h'), -1); break;
        case 'xm-confirm': extraConfirm(); break;
        case 'xm-remove': removeExtra(el.getAttribute('data-h')); break;
        case 'sg-pick': { var sz = el.getAttribute('data-size'); closeSheet($.sizeSheet); if (kindAt(S.step) !== 'hoodie') gotoStep(posOf('hoodie'), { force: true }); selectSize(sz); break; }
        case 'to-reviews': {
          var tgt = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews, .jdgm-widget, [data-hh-reviews]');
          if (tgt) smoothScrollTo(tgt.getBoundingClientRect().top + window.pageYOffset - headerH() - 12, 800);
          break;
        }
      }
    });
    root.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-sf-form]')) { e.preventDefault(); sfCalc(); }
    });
    root.addEventListener('input', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-sf-form]')) { readFinder(); persistFinder(); }
    });
    function ctaNext() {
      var k = kindAt(S.step);
      if (k === 'sum') return;
      if (!kindDone(k)) { routeMissing(); return; }
      gotoStep(skipToSum() ? 3 : S.step + 1);
    }
    // bar CTA (has data-act set dynamically, handled by the delegated listener above)
    root.addEventListener('pointerdown', function (e) {
      var el = e.target.closest('.hh-ccard,.hh-size,.hh-mcard,.hh-tier');
      if (el) anim(el, [{ transform: 'scale(1)' }, { transform: 'scale(.97)' }], { duration: 80, easing: EASE.out, fill: 'forwards' });
    });
    root.addEventListener('pointerup', function (e) {
      var el = e.target.closest('.hh-ccard,.hh-size,.hh-mcard,.hh-tier');
      if (el && el.getAnimations) el.getAnimations().forEach(function (a) { if (a.effect && a.effect.getTiming && a.effect.getTiming().duration === 80) a.cancel(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // v4b: Esc already handled by the Rubbel pop-up on top (it closes itself first, in the capture phase)
        if (e.defaultPrevented || document.documentElement.classList.contains('hh-rb-lock')) return;
        if (story) closeStory(); else if (!$.sheet.hidden) closeSheet($.sheet); else if (!$.sizeSheet.hidden) closeSheet($.sizeSheet);
        return;
      }
      if (story && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) { storyStep(e.key === 'ArrowRight' ? 1 : -1); return; }
      // roving arrows inside a choice group
      var el = document.activeElement;
      if (!el || !root.contains(el)) return;
      var grpEl = el.closest('.hh-colors,.hh-sizes,.hh-mgrid');
      if (!grpEl || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) < 0) return;
      var btns = qa('button', grpEl), i = btns.indexOf(el);
      var n = e.key === 'Home' ? 0 : e.key === 'End' ? btns.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length;
      e.preventDefault(); btns[n].focus();
    });
    // focus trap for sheets
    // v4: never steal focus from the Rubbel pop-up or the theme's cart drawer when they open on top of a sheet/story
    document.addEventListener('focusin', function (e) {
      var open = story ? $.story : (!$.sheet.hidden ? $.sheet : (!$.sizeSheet.hidden ? $.sizeSheet : null));
      if (!open || open.contains(e.target)) return;
      if (e.target && e.target.closest && e.target.closest('.hh-rb-root,cart-drawer')) return;
      var f = q('button', open); if (f) f.focus();
    });

    // stage swipe
    (function () {
      var x0 = null, y0 = null, dx = 0, dy = 0, id = null;
      $.stage.addEventListener('pointerdown', function (e) { if (e.target.closest('button')) return; x0 = e.clientX; y0 = e.clientY; dx = dy = 0; id = e.pointerId; });
      $.stage.addEventListener('pointermove', function (e) {
        if (x0 == null || e.pointerId !== id) return;
        dx = e.clientX - x0; dy = e.clientY - y0;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.5 && !RM()) $.box.style.transform = 'translate(calc(-50% + ' + (dx * .25) + 'px),-50%)';
      });
      function end() {
        if (x0 == null) return;
        var sw = Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5;
        if ($.box.style.transform) { var cur = $.box.style.transform; $.box.style.transform = ''; anim($.box, [{ transform: cur }, { transform: 'translate(-50%,-50%)' }], { duration: 220, easing: EASE.spring }); }
        if (sw) cycleColor(dx < 0 ? 1 : -1, 'swipe');
        x0 = null;
      }
      $.stage.addEventListener('pointerup', end); $.stage.addEventListener('pointercancel', end);
    })();

    window.addEventListener('scroll', onScroll, { passive: true });
    // `below` must never be stale after layout changes (step open/close, compaction, sheets) – not only on scroll
    if (window.ResizeObserver) try { new ResizeObserver(function () { onScroll(); }).observe($.grid); } catch (e) {}
    // the expanded stage height (--stage-h, svh based) is re-measured only when the viewport really changes
    function remeasureStage() { S.stageH = 0; S.stageCur = null; $.stage.style.height = ''; $.stagewrap.style.marginBottom = ''; }
    var lastVW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lastVW) { lastVW = window.innerWidth; remeasureStage(); renderBar({ holdPrice: true }); } moveLoz(true); onScroll(); });
    window.addEventListener('orientationchange', function () { remeasureStage(); setTimeout(function () { remeasureStage(); onScroll(); }, 350); });
    if (RMQ && RMQ.addEventListener) RMQ.addEventListener('change', function () { root.classList.toggle('is-rm', RM()); });
    if (MQD && MQD.addEventListener) MQD.addEventListener('change', function () { remeasureStage(); setCompact(false); moveLoz(true); onScroll(); pkWarm(); });

    // header: only offset when the theme header is really sticky/fixed
    (function () {
      var hdr = document.querySelector('sticky-header, .section-header, header.header-wrapper, .shopify-section-header-sticky');
      if (!hdr) { root.style.setProperty('--hh-top', '0px'); return; }
      var pos = getComputedStyle(hdr).position;
      if (pos !== 'sticky' && pos !== '-webkit-sticky' && pos !== 'fixed') {
        var parent = hdr.closest('.shopify-section'); var pp = parent ? getComputedStyle(parent).position : '';
        if (pp !== 'sticky' && pp !== 'fixed') root.style.setProperty('--hh-top', '0px');
      }
    })();

    // Bottom UI must never sit under something fixed at the bottom of the screen: the Shopify theme-preview bar
    // (Luis's test link: it covered the sticky bar and the sheet's "Hinzufügen") and the real visible height on phones
    // (in-app browser toolbars). --hh-pbar / --hh-vvh feed the bar, sheets and story viewer.
    (function () {
      var de = document.documentElement, lastP = -1, lastV = -1;
      function obstruction() {
        var h = 0, vh = window.innerHeight, els = [];
        try { els = qa('[id*="preview-bar" i],[id^="PBar"],[class*="preview-bar" i]'); } catch (e) { els = qa('#preview-bar-iframe,#PBarNextFrameWrapper'); }
        els.forEach(function (el) {
          if (root.contains(el)) return;
          var r = el.getBoundingClientRect(), cs = getComputedStyle(el);
          if (!r.height || cs.display === 'none' || cs.visibility === 'hidden') return;
          if (r.top > vh * 0.5 && r.bottom >= vh - 4 && r.height < vh * 0.4) h = Math.max(h, Math.round(vh - r.top));
        });
        return h;
      }
      var lastW = window.innerWidth;
      function typing() {
        var a = document.activeElement;
        return !!(a && root.contains(a) && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName));
      }
      function measure() {
        var p = obstruction(), vv = Math.round((window.visualViewport && window.visualViewport.height) || window.innerHeight);
        if (p !== lastP) { lastP = p; de.style.setProperty('--hh-pbar', p + 'px'); root.classList.toggle('has-pbar', p > 0); }
        // v2 review: the on-screen keyboard (size finder inputs) and pinch zoom also shrink visualViewport. Freeze the
        // sheet height while typing and ignore big shrinks at the same width, so the inputs never slide behind the keyboard.
        var w = window.innerWidth, rotated = w !== lastW; lastW = w;
        if (!rotated && lastV > 0 && (typing() || (window.visualViewport && window.visualViewport.scale > 1.01) || vv < lastV - 150)) return;
        if (vv !== lastV) { lastV = vv; de.style.setProperty('--hh-vvh', vv + 'px'); }
      }
      measure();
      [400, 1500, 4000, 8000].forEach(function (ms) { setTimeout(measure, ms); });
      window.addEventListener('resize', measure);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', measure);
      if (window.MutationObserver) try { new MutationObserver(function () { clearTimeout(measure.t); measure.t = setTimeout(measure, 120); }).observe(document.body, { childList: true }); } catch (e) {}
      root.__measureBottom = measure;
    })();

    /* ───────────────────────── first render ───────────────────────── */
    renderStageInitial();
    renderStep1();
    renderStep2();
    renderRows();
    renderProgress();
    renderBar({ noRoll: true });
    // restored session: reopen the step the customer was on (guards still apply)
    (function () {
      var rs = S.restore; if (!rs) return;
      var st = Math.min(3, Math.max(1, rs.step | 0)), mx = Math.min(3, Math.max(st, rs.maxStep | 0));
      // v4: a session saved in the other step order (no `order` = the old Hoodie-first page) is mapped by kind
      if (rs.order !== ORDER_ID) {
        var OLD = rs.order === 'm1' ? ['moochie', 'hoodie', 'sum'] : ['hoodie', 'moochie', 'sum'];
        var st2 = posOf(OLD[st - 1]);
        mx = mx >= 3 ? 3 : Math.max.apply(null, OLD.slice(0, mx).map(posOf));
        st = st2;
      }
      // never past the first open decision (the step order decides which one that is)
      var f = 1; while (f < 3 && kindDone(kindAt(f))) f++;
      st = Math.min(st, f); mx = Math.min(mx, f);
      if (f === 3) mx = Math.max(mx, 2);
      mx = Math.max(mx, st);
      S.maxStep = mx;
      updateStep1(true); updateStep2();   // v4b: inline "Weiter"/"Zur Übersicht" labels against the restored maxStep
      if (st > 1) gotoStep(st, { force: true, noScroll: true, noFocus: true, noAnim: true });
      else { renderRows(); renderProgress(); renderBar({ noRoll: true }); }
      renderExtras(false);
    })();
    var skel = document.querySelector('[data-hh-cfg-skel="' + (D.sectionId || '') + '"]'); if (skel) skel.remove();
    // v4b: the bar label fit (short label / is-tight) was measured with the fallback font: measure again once Inter is in
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { renderBar({ holdPrice: true }); }); } catch (e) {}

    // entrance
    (function entrance() {
      var bar = $.bar;
      setTimeout(function () { bar.classList.remove('is-pre'); anim(bar, [{ transform: 'translateY(100%)' }, { transform: 'none' }], { duration: 360, easing: EASE.out }); }, RM() ? 0 : 300);
      var img = $.imgA;
      var reveal = function () { anim($.stage.querySelector('.hh-stage__box'), [{ filter: 'blur(12px)', opacity: 0, transform: 'translate(-50%,calc(-50% + 8px))' }, { filter: 'blur(0)', opacity: 1, transform: 'translate(-50%,-50%)' }], { duration: 560, easing: EASE.glide }); };
      if (img.complete && img.naturalWidth) { /* already there: no blur-in (no flash) */ }
      else {
        var t0 = Date.now();
        img.addEventListener('load', function () { if (Date.now() - t0 < 800) reveal(); }, { once: true });
      }
      // v4: the cards of the FIRST step fade in (Moochie cards when the Moochie comes first)
      var firstCards = function () { return posOf('moochie') === 1 ? qa('.hh-mcard', $.mgrid) : qa('.hh-ccard', $.colors); };
      if (S.step === 1) firstCards().forEach(function (c, i) { anim(c, [{ opacity: 0, transform: 'scale(.92)' }, { opacity: 1, transform: 'none' }], { duration: 360, delay: 160 + i * 80, easing: EASE.out, fill: 'backwards' }); });
      var ub = q('.hh-ugc__row', $.s1); if (ub) anim(ub, [{ opacity: 0 }, { opacity: 1 }], { duration: 360, delay: 400, fill: 'backwards' });
      // Auflagen stamps land one after another, then edition 4 lights up
      var stamps = qa('[data-stamp]', $.ed);
      if (!RM()) {
        stamps.forEach(function (s, i) {
          s.style.opacity = 0;
          var d = 350 + i * 360;
          var a = anim(s, [
            { transform: 'translate(-50%,-50%) rotate(-24deg) scale(2.3)', opacity: 0 },
            { transform: 'translate(-50%,-50%) rotate(-11deg) scale(.9)', opacity: 1, offset: .7 },
            { transform: 'translate(-50%,-50%) rotate(-13deg) scale(1)', opacity: 1 }
          ], { duration: 340, delay: d, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' });
          done(a).then(function () { s.style.opacity = 1; if (a) a.cancel(); });
          setTimeout(function () { anim(s.parentNode, [{ transform: 'none' }, { transform: 'translate(-1.5px,1px) rotate(-.6deg)' }, { transform: 'translate(1.5px,0) rotate(.5deg)' }, { transform: 'none' }], { duration: 220, easing: EASE.out }); }, d + 230);
        });
        setTimeout(function () { $.ed.classList.add('is-lit'); }, 350 + stamps.length * 360 + 120);
      } else { $.ed.classList.add('is-lit'); }
      var bar2 = q('[data-ref="edbar"]', $.ed);
      if (bar2) setTimeout(function () { bar2.style.width = bar2.getAttribute('data-w') + '%'; }, RM() ? 0 : 500);
      // ONE nudge only, pointing at the decision (stamps + Auflage-4 glow come first; no swipe hint / hoodie wiggle)
      setTimeout(function () {
        if (S.touched || S.step !== 1 || RM()) return;
        firstCards().forEach(function (c, i) { anim(c, [{ transform: 'none' }, { transform: 'translateY(-4px)' }, { transform: 'none' }], { duration: 280, delay: i * 70, easing: EASE.out }); });
      }, 3200);
      // preload the other colour images (stage size) when idle
      var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 600); };
      idle(function () { COLORS.forEach(function (c) { var i = new Image(); i.decoding = 'async'; i.src = colorImg(c.name, true); var j = new Image(); j.src = c.thumb; }); });
      // pocket layers (zip + lip per colour, body/shadow/paws per Moochie) into the HTTP cache, so switching is instant
      if (PK) setTimeout(function () { idle(pkWarm); }, 1500);
    })();

    initAiVideo();
    onScroll();
    track('hh_cfg_view', { color: set0().color, order: ORDER_ID, showcase: SHOW || '', moochieFromUrl: !!S.introChosen });

    // public test hooks (used by the local harness; harmless in production)
    root.__hhcfg = {
      state: S, model: function () { return model(S.sets); }, items: buildItems, order: ORDER_ID,
      // v4: "Jetzt zusammenstellen ↑" under the info slides: straight to the open decision, or to the summary
      resume: function () { if (!allDone()) routeMissing(); else gotoStep(3, { force: true }); },
      selectColor: function (c) { selectColor(c, null, 'api'); }, selectSize: selectSize,
      selectMoochie: function (h) { var b = q('.hh-mcard[data-handle="' + cssEsc(h) + '"]', $.mgrid); selectMoochie(h, b); },
      skipMoochie: skipMoochie, goto: function (n) { gotoStep(n, { force: true }); }, next: ctaNext,
      openTier: function (n) { openSetSheet(S.sets.length, n); },
      sheet: { color: function (c) { sheetState.draft.color = c; renderSheet(); }, size: function (z) { sheetState.draft.size = z; renderSheet(); }, moochie: function (h) { sheetState.draft.moochie = h; renderSheet(); }, confirm: sheetConfirm },
      extras: { open: openExtraSheet, plus: function (h) { extraStep(h, 1); }, minus: function (h) { extraStep(h, -1); }, confirm: extraConfirm, remove: removeExtra, get: function () { return S.extras; } },
      addSet: function (set) { S.sets.push(set); renderExtras(false); renderStep3(); renderRows(); renderProgress(); renderBar(); },
      submit: submit, openSizeHelp: openSizeSheet, openStory: openStory, celebrate: celebrate, route: routeMissing,
      setCompact: setCompact,
      sizeFinder: function (o) { o = o || {}; openSizeSheet('find'); if (o.unit && o.unit !== SF.unit) { SF.unit = o.unit; renderSizeSheet(); } var f = q('[data-sf-form]', $.sizeSheet);
        if (o.fit) q('[data-act="sf-fit"][data-fit="' + o.fit + '"]', f).click();
        ['hcm', 'hft', 'hin', 'w'].forEach(function (n) { if (o[n] != null && f.elements[n]) f.elements[n].value = o[n]; }); sfCalc(); return SF.res; },
      openPhoto: function (i) { openStory(i || 0, 'photo'); }, gallery: function () { return galOrder.map(function (g) { return g.color; }); }
    };
    root.dispatchEvent(new CustomEvent('hhcfg:ready', { bubbles: true, detail: root.__hhcfg }));
  }

  // any boot failure must never leave an ad landing page without a way to buy:
  // fall back to the normal product page (same URL without ?view=), or show the error in the theme editor.
  // The configurator is also the main product template now, so that URL can be this same page: redirect at most
  // once per tab and only from a ?view= URL, otherwise show the plain <noscript> buy form (no reload loop).
  function safeBoot(r) {
    var ns = q('noscript', r), nsHtml = ns ? ns.textContent : '';
    try { boot(r); }
    catch (e) {
      try { console.error('[hh-cfg] boot failed', e); } catch (x) {}
      track('hh_cfg_boot_error', { message: String(e && e.message || e) });
      if (window.HHCFG_ON_BOOT_FAIL) return window.HHCFG_ON_BOOT_FAIL(e);
      if (window.Shopify && Shopify.designMode) { r.insertAdjacentHTML('afterbegin', '<p style="padding:16px;color:#9C3F66;font:600 14px/1.4 system-ui">HuggHer Konfigurator: ' + esc(e && e.message || e) + '</p>'); return; }
      var failedBefore = false;
      try { failedBefore = !!sessionStorage.getItem('hh-cfg-bootfail'); } catch (x) {}
      if (failedBefore || !/[?&]view(=|&|$)/.test(location.search)) {
        if (nsHtml) {
          try {
            r.innerHTML = nsHtml;
            var nb = q('button', r); if (nb) nb.style.cssText += ';background:#9C3F66;color:#fff;border:0;border-radius:999px;font-weight:600;font-size:16px;cursor:pointer';
          } catch (x) {}
        }
        return;
      }
      try { sessionStorage.setItem('hh-cfg-bootfail', '1'); } catch (x) {}
      try {
        var u = new URL(location.href); u.searchParams.delete('view');
        var fb = r.getAttribute('data-fallback-url'); if (fb) { var f = new URL(fb, location.origin); u.searchParams.forEach(function (v, k) { if (!f.searchParams.has(k)) f.searchParams.set(k, v); }); u = f; }
        location.replace(u.toString());
      } catch (x) { location.replace(location.pathname); }
    }
  }
  function start() { qa('[data-hh-cfg]').forEach(function (r) { if (!r.__hhBooted) { r.__hhBooted = true; safeBoot(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
